import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, ViewChild, Inject, HostListener, inject, NgModule } from '@angular/core';
import { isNotNil, deepCopy, omit, isEqual, pick, EMAIL_REGEX, range } from '@engineering11/utility';
import { RestApiClient } from '@engineering11/web-api-rest';
import { filter, map, firstValueFrom, lastValueFrom, mergeMap, finalize, from, tap, switchMap, distinctUntilChanged, combineLatest, exhaustMap, take, Subject, takeUntil, withLatestFrom, of, BehaviorSubject } from 'rxjs';
import jwt_decode from 'jwt-decode';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i6 from '@engineering11/user-web';
import { UserModule } from '@engineering11/user-web';
import * as i4 from '@ngrx/component';
import { LetDirective } from '@ngrx/component';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import * as i1 from '@engineering11/web-api-error';
import { e11Error, LOGGER_TOKEN, isE11ErrorOfType } from '@engineering11/web-api-error';
import { DateService } from '@engineering11/date-time';
import * as i2$1 from '@engineering11/auth-web';
import { AuthModule } from '@engineering11/auth-web';
import * as i3 from '@engineering11/customer-web';
import { CustomerModule } from '@engineering11/customer-web';
import * as i4$1 from '@engineering11/web-ui-helpers';
import { map as map$1, filter as filter$1, takeUntil as takeUntil$1 } from 'rxjs/operators';
import * as i2$3 from '@engineering11/access-web';
import * as i2$4 from '@engineering11/ui-lib/e11-loader-dots';
import { E11LoaderDotsModule } from '@engineering11/ui-lib/e11-loader-dots';
import * as i6$2 from '@engineering11/ui-lib/e11-tooltip';
import { E11TooltipModule } from '@engineering11/ui-lib/e11-tooltip';
import * as i2$2 from '@engineering11/ui-lib/e11-button';
import { E11ButtonModule } from '@engineering11/ui-lib/e11-button';
import * as i1$1 from '@engineering11/ui-lib/e11-modal';
import { E11ModalModule } from '@engineering11/ui-lib/e11-modal';
import * as i2$5 from '@angular/forms';
import { Validators, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import * as i3$1 from '@engineering11/ui-lib/e11-form-builder';
import { e11FormFor, e11FormLayoutInlineGrid, e11FieldInputText, e11FieldInputDynamicComponent, e11FieldInputFile, e11FormLayoutInline3Grid, e11FieldInputColor, e11FormLayoutFullWidth, e11FieldInputTextArea, e11FieldInputPhone, e11LayoutGroup, E11DynamicFormModule } from '@engineering11/ui-lib/e11-form-builder';
import * as i7$1 from '@engineering11/ui-lib/e11-input-errors';
import { E11FormValidator, E11FormValidationService, Validation, E11InputErrorsModule } from '@engineering11/ui-lib/e11-input-errors';
import * as i6$1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i4$2 from '@engineering11/ui-lib/e11-confirmation';
import { E11ConfirmationModule } from '@engineering11/ui-lib/e11-confirmation';
import * as i3$2 from '@engineering11/ui-lib/e11-empty-state';
import { E11EmptyStateModule } from '@engineering11/ui-lib/e11-empty-state';
import * as i2$6 from '@engineering11/tenant-bootstrap-web';
import { HostRegex, TenantType, BaseTenantBootstrapConfigProvider } from '@engineering11/tenant-bootstrap-web';
import * as i4$3 from '@engineering11/ui-lib/e11-input';
import { E11InputModule } from '@engineering11/ui-lib/e11-input';
import * as i6$3 from '@engineering11/files-web';
import { FilesModule } from '@engineering11/files-web';
import * as i8 from '@engineering11/ui-lib/e11-ui-utils';
import * as i3$3 from '@engineering11/maps-web';
import { AddressFormService } from '@engineering11/maps-web';
import * as i7 from '@engineering11/ui-lib/e11-select';
import { E11SelectModule } from '@engineering11/ui-lib/e11-select';
import { DataType, E11DataTableModule } from '@engineering11/ui-lib/e11-datatable';
import * as i5 from '@engineering11/ui-lib/e11-card';
import { E11CardModule } from '@engineering11/ui-lib/e11-card';
import * as i4$5 from '@engineering11/web-utilities';
import { DisplayPager, WebUtilityModule } from '@engineering11/web-utilities';
import * as i4$4 from '@angular/platform-browser';
import * as i7$2 from 'ng-recaptcha';
import { RecaptchaModule } from 'ng-recaptcha';
import * as i8$1 from '@engineering11/ui-lib/e11-phone-number';
import { E11PhoneNumberModule } from '@engineering11/ui-lib/e11-phone-number';
import * as i1$2 from '@engineering11/ui-lib/e11-side-over';
import { E11SideOverModule } from '@engineering11/ui-lib/e11-side-over';
import * as i3$4 from '@engineering11/ui-lib/e11-notifications';
import * as i12 from '@engineering11/ui-lib/e11-multi-select';
import { E11MultiSelectModule } from '@engineering11/ui-lib/e11-multi-select';
import * as i5$1 from '@engineering11/ui-lib/e11-textarea';
import { E11TextareaModule } from '@engineering11/ui-lib/e11-textarea';
import * as i1$3 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i3$5 from '@engineering11/ui-lib/e11-panel';
import { E11PanelModule } from '@engineering11/ui-lib/e11-panel';

class BaseRegistrationConfigProvider {
    getCurrentUserCustomerKey() {
        return this.config.token$.pipe(filter(isNotNil), map((token) => {
            const user = jwt_decode(token);
            return user.customerKey;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseRegistrationConfigProvider, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseRegistrationConfigProvider, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseRegistrationConfigProvider, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class RegistrationSearchKeyService {
    constructor(configProvider) {
        this.configProvider = configProvider;
        this.restClient = new RestApiClient({
            baseUrl: this.configProvider.config.registrationBaseURL,
            token: this.configProvider.config.token$.pipe(filter(isNotNil)),
            throwNon200s: true,
        });
    }
    customerClientUser(customerClientId) {
        return this.restClient.get(`search-key/${customerClientId}/admin-package`, { version: '1' }).pipe(map((keys) => keys.data));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RegistrationSearchKeyService, deps: [{ token: BaseRegistrationConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RegistrationSearchKeyService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RegistrationSearchKeyService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BaseRegistrationConfigProvider }] });

class CustomerClientUserSearchComponent {
    set clientId(clientId) {
        this.keyPackage$ = this.searchKeyService.customerClientUser(clientId);
    }
    constructor(searchKeyService) {
        this.searchKeyService = searchKeyService;
        this.searchParams = { hitsPerPage: 15 };
        this.userSelected = new EventEmitter();
    }
    ngOnInit() { }
    selectUser(userId) {
        this.userSelected.emit(userId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientUserSearchComponent, deps: [{ token: RegistrationSearchKeyService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerClientUserSearchComponent, selector: "sdk-customer-client-user-search", inputs: { clientId: "clientId" }, outputs: { userSelected: "userSelected" }, ngImport: i0, template: `
    <ng-container *ngrxLet="keyPackage$ as keyPackage">
      <sdk-user-search
        *ngIf="keyPackage"
        [searchKey]="keyPackage.searchKey"
        [searchAppId]="keyPackage.searchAppId"
        [searchParams]="searchParams"
        (selectedUserId)="selectUser($event)"
      >
      </sdk-user-search>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.UserSearchComponent, selector: "sdk-user-search", inputs: ["searchKey", "searchAppId", "searchFilters", "searchParams"], outputs: ["selectedUserId", "selectedUser"] }, { kind: "directive", type: i4.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientUserSearchComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-client-user-search',
                    template: `
    <ng-container *ngrxLet="keyPackage$ as keyPackage">
      <sdk-user-search
        *ngIf="keyPackage"
        [searchKey]="keyPackage.searchKey"
        [searchAppId]="keyPackage.searchAppId"
        [searchParams]="searchParams"
        (selectedUserId)="selectUser($event)"
      >
      </sdk-user-search>
    </ng-container>
  `,
                }]
        }], ctorParameters: () => [{ type: RegistrationSearchKeyService }], propDecorators: { clientId: [{
                type: Input
            }], userSelected: [{
                type: Output
            }] } });

const IDENTICON = Object.freeze({
    ROOT_PATH: 'assets/identicon/',
    TAIL: '_identity.svg',
    SIZE: 300,
});
const REGISTRATION_ERRORS = Object.freeze({
    MISSING_USER: 'registration/missing-user',
    INVALID_TOKEN: 'registration/invalid-token',
    MISSING_CONFIG: 'registration/missing-config',
    INVITATION_NOT_FOUND: 'registration/invitation-not-found',
});
const NOTIFICATION_DEFAULTS$1 = {
    inviteRegistrationPath: '/#/registration/register-invite',
    verifyEmailPath: '/#/actions/verify-email',
    resetPasswordPath: '/#/actions/reset-password',
};
var RegistrationPermissions;
(function (RegistrationPermissions) {
    RegistrationPermissions["ProvisionCustomerTenant"] = "registration/provision-customer-tenant";
    RegistrationPermissions["ProvisionCustomerClient"] = "registration/provision-customer-client";
    RegistrationPermissions["ProvisionCustomer"] = "registration/provision-customer";
    RegistrationPermissions["ProvisionConsumerTenant"] = "registration/provision-consumer-tenant";
    RegistrationPermissions["DeprovisionCustomer"] = "registration/deprovision-customer";
    RegistrationPermissions["ReactivateCustomer"] = "registration/reactivate-customer";
    RegistrationPermissions["EditClientUsers"] = "registration/edit-client-users";
    RegistrationPermissions["ViewClientUsers"] = "registration/view-client-users";
    RegistrationPermissions["SearchClientUsers"] = "registration/search-client-users";
    RegistrationPermissions["PlatformAdminEditAllInvites"] = "registration/platform-admin-edit-all-invites";
    RegistrationPermissions["PlatformAdminViewAllInvites"] = "registration/platform-admin-view-all-invites";
})(RegistrationPermissions || (RegistrationPermissions = {}));

class RegistrationService {
    constructor(configProvider, authService) {
        this.configProvider = configProvider;
        this.authService = authService;
        this.authTenantId = this.configProvider.config.authTenantId;
    }
    async registerConsumerUserV2(registrationModel, captchaResponse) {
        const restClient = this.createRestClient({ isPublicRequest: true });
        const response = await firstValueFrom(restClient.post('registration/consumer', registrationModel, {
            version: '2',
            headers: { 'X-Captcha-Response': captchaResponse, 'X-Auth-Tenant-Id': this.authTenantId },
        }));
        const { res, err } = await this.authService.customTokenSignIn(response.data.authToken);
        // Server returns a token with nested custom claims, get a flattened token.
        if (err)
            throw err; // ! Consider not rethrowing since error is already handled
        if (!res?.user)
            throw e11Error({ type: REGISTRATION_ERRORS.MISSING_USER, title: 'Registration failed. Please try again.' });
        const token = await res.user.getIdToken(true);
        response.data.authToken = token;
        return response.data;
    }
    async registerBusinessUserV2(registrationModel, captchaResponse) {
        const restClient = this.createRestClient({ isPublicRequest: true });
        const response = await firstValueFrom(restClient.post('registration/business', registrationModel, {
            version: '2',
            headers: { 'X-Captcha-Response': captchaResponse, 'X-Auth-Tenant-Id': this.authTenantId },
        }));
        const { res, err } = await this.authService.customTokenSignIn(response.data.authToken);
        // Server returns a token with nested custom claims, get a flattened token.
        if (err)
            throw err; // ! Consider not rethrowing since error is already handled
        if (!res?.user)
            throw e11Error({ type: REGISTRATION_ERRORS.MISSING_USER, title: 'Registration failed. Please try again.' });
        const token = await res.user.getIdToken(true);
        response.data.authToken = token;
        return response.data;
    }
    async deregister(deregisterRequest) {
        const restClient = this.createRestClient();
        await firstValueFrom(restClient.post('registration/deregister', deregisterRequest, { version: '2' }));
    }
    async reactivate(reactivateRequest) {
        const restClient = this.createRestClient();
        await firstValueFrom(restClient.post('registration/reactivate', reactivateRequest, { version: '2' }));
    }
    reactivationAvailability(customerKey) {
        const restClient = this.createRestClient();
        return restClient
            .get(`registration/reactivation/${customerKey}`, { version: '2' })
            .pipe(map((response) => DateService.convertAllDateFields(response.data)));
    }
    /**
     * Called to validate a registration code
     *
     * @param code
     * @returns {Promise<IRegistrationCodeValidationResponse>}
     */
    async validateRegistrationCode(code, captchaResponse) {
        const restClient = this.createRestClient({ isPublicRequest: true });
        const response = await firstValueFrom(restClient.post(`registration/${code}/validate`, {}, {
            version: '2',
            headers: { 'X-Captcha-Response': captchaResponse, 'X-Auth-Tenant-Id': this.authTenantId },
        }));
        return response.data;
    }
    async registerEmployeeUserV2(registrationModel, captchaResponse) {
        const restClient = this.createRestClient({ isPublicRequest: true });
        const response = await firstValueFrom(restClient.post('registration/employee', registrationModel, {
            version: '2',
            headers: { 'X-Captcha-Response': captchaResponse, 'X-Auth-Tenant-Id': this.authTenantId },
        }));
        const { res, err } = await this.authService.customTokenSignIn(response.data.authToken);
        // Server returns a token with nested custom claims, get a flattened token.
        if (err)
            throw err; // ! Consider not rethrowing since error is already handled
        if (!res?.user)
            throw e11Error({ type: REGISTRATION_ERRORS.MISSING_USER, title: 'Registration failed. Please try again.' });
        const token = await res.user.getIdToken(true);
        response.data.authToken = token;
        return response.data;
    }
    async createAccount(email, password) {
        const { res, err } = await this.authService.emailPasswordSignUp(email, password);
        if (err)
            throw err; // ! Consider not rethrowing since error is already handled
        if (!res?.user)
            throw e11Error({ type: REGISTRATION_ERRORS.MISSING_USER, title: 'Registration failed. Please try again.' });
        return res.user.getIdToken(true);
    }
    async abort(userPassword) {
        // Note: This is a partial clean up, full cleanup should be done in the audit task
        // but this at least logs them out and allows a retry.
        if (userPassword) {
            const credential = await this.authService.reAuthenticateWithCredential(userPassword);
            await credential?.user?.delete();
        }
    }
    createRestClient({ isPublicRequest } = { isPublicRequest: false }) {
        if (!this.configProvider.config.registrationBaseURL) {
            throw e11Error({
                type: REGISTRATION_ERRORS.MISSING_CONFIG,
                title: 'Missing configuration',
                message: 'Missing configuration, registrationBaseURL is undefined. Configure Registration module with an IRegistrationConfig model',
            });
        }
        return new RestApiClient({
            baseUrl: this.configProvider.config.registrationBaseURL,
            token: this.configProvider.config.token$.pipe(filter((token) => isPublicRequest || isNotNil(token))),
            throwNon200s: true,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RegistrationService, deps: [{ token: BaseRegistrationConfigProvider }, { token: i2$1.AuthService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RegistrationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RegistrationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: BaseRegistrationConfigProvider }, { type: i2$1.AuthService }] });

class ProvisioningService {
    constructor(configProvider) {
        this.configProvider = configProvider;
    }
    provisionCustomerTenant(provisionModel) {
        const restClient = this.createRestClient();
        return restClient.post('provision/tenant-business', provisionModel, { version: '1' }).pipe(map((response) => response.data));
    }
    provisionConsumerTenant(provisionModel) {
        const restClient = this.createRestClient();
        return restClient.post('provision/tenant-consumer', provisionModel, { version: '1' }).pipe(map((response) => response.data));
    }
    provisionCustomerClient(provisionModel) {
        const restClient = this.createRestClient();
        return restClient.post('provision/client-business', provisionModel, { version: '1' }).pipe(map((response) => response.data));
    }
    provisionCustomer(provisionModel) {
        const restClient = this.createRestClient();
        return restClient.post('provision/business', provisionModel, { version: '1' }).pipe(map((response) => response.data));
    }
    createRestClient() {
        if (!this.configProvider.config.registrationBaseURL) {
            throw e11Error({
                type: REGISTRATION_ERRORS.MISSING_CONFIG,
                title: 'Missing configuration',
                message: 'Missing configuration, registrationBaseURL is undefined. Configure Registration module with an IRegistrationConfig model',
            });
        }
        return new RestApiClient({
            baseUrl: this.configProvider.config.registrationBaseURL,
            token: this.configProvider.config.token$.pipe(filter(isNotNil)),
            throwNon200s: true,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ProvisioningService, deps: [{ token: BaseRegistrationConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ProvisioningService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ProvisioningService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: BaseRegistrationConfigProvider }] });

class RegistrationInviteService {
    constructor(configProvider) {
        this.configProvider = configProvider;
        this.restClient = this.createRestClient();
    }
    async checkForExistingInvitation(email, authToken) {
        const response = await firstValueFrom(this.restClient.post(`invitation/${email}/exists`, {}));
        return response?.data;
    }
    async inviteUser(invite) {
        await this.restClient.post('invitation', invite).toPromise();
    }
    async resendInvite(invite, authToken) {
        await this.restClient.post(`invitation/${invite.email}/resend`, {}).toPromise();
    }
    async resendInviteProvisioned(invite) {
        await lastValueFrom(this.restClient.post(`invitation/${invite.email}/resend/${invite.customerKey}`, {}));
    }
    async deleteInvite(invite) {
        await lastValueFrom(this.restClient.delete(`invitation/${invite.email}/delete`));
    }
    async deleteInviteProvisioned(invite) {
        await lastValueFrom(this.restClient.delete(`invitation/${invite.email}/delete/${invite.customerKey}`));
    }
    /**
     * The api will get the customer key from the auth token
     *
     * @param authToken
     * @returns
     */
    getInvitedUsers(authToken) {
        return this.restClient.get('invitation').pipe(map$1((item) => item.data));
    }
    getProvisionedInvites(clientCustomerKey) {
        return this.restClient.get(`invitation/${clientCustomerKey}/provisioned`).pipe(map$1((item) => item.data));
    }
    addProvisionedInvite(clientCustomerKey, invite) {
        return this.restClient.post(`invitation/${clientCustomerKey}/add`, invite).pipe(map$1((item) => item.data));
    }
    createRestClient() {
        if (!this.configProvider.config.registrationBaseURL)
            throw e11Error(configMissingErr$1('registrationBaseURL'));
        if (!this.configProvider.config.token$)
            throw e11Error(configMissingErr$1('token$'));
        return new RestApiClient({
            baseUrl: this.configProvider.config.registrationBaseURL,
            token: this.configProvider.config.token$.pipe(filter$1(isNotNil)),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RegistrationInviteService, deps: [{ token: BaseRegistrationConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RegistrationInviteService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RegistrationInviteService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BaseRegistrationConfigProvider }] });
const configMissingErr$1 = (field) => ({
    title: 'Configuration Error',
    message: `Missing configuration, ${field} is undefined. Configure Registration module with an IRegistrationConfig model`,
    type: 'registration/config-error',
});

class IdenticonService {
    constructor() { }
    static buildPath(userId, cdnCname) {
        return `https://${cdnCname}/${IDENTICON.ROOT_PATH}${userId}/${userId}${IDENTICON.TAIL}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IdenticonService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IdenticonService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IdenticonService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

var ClientAccountStatus;
(function (ClientAccountStatus) {
    ClientAccountStatus["NoAccount"] = "NoAccount";
    ClientAccountStatus["Provisioned"] = "Provisioned";
    ClientAccountStatus["Deactivated"] = "Deactivated";
})(ClientAccountStatus || (ClientAccountStatus = {}));
const initialState$1 = {
    initialized: false,
    provisioning: false,
    deactivating: false,
    reactivating: false,
    invitesLoading: false,
};
class ClientAccountStore extends ComponentStore {
    constructor(logger, errorHandler, registrationService, customerClientStore, provisioningService, notificationService, inviteService) {
        super(initialState$1);
        this.logger = logger;
        this.errorHandler = errorHandler;
        this.registrationService = registrationService;
        this.customerClientStore = customerClientStore;
        this.provisioningService = provisioningService;
        this.notificationService = notificationService;
        this.inviteService = inviteService;
        // SELECTORS
        this.getState = this.select((s) => s);
        this.state$ = this.select((s) => s);
        this.provisioning$ = this.select((s) => s.provisioning);
        this.reactivating$ = this.select((s) => s.reactivating);
        this.clientCustomerKey$ = this.select(this.customerClientStore.selectedCustomer$, (customer) => customer?.id);
        this.clientAccountStatus$ = this.select(this.getState, this.customerClientStore.selectedCustomer$, (s, customer) => {
            if (!customer)
                return ClientAccountStatus.NoAccount;
            if (customer.endDate)
                return ClientAccountStatus.Deactivated;
            else
                return ClientAccountStatus.Provisioned;
        });
        this.invites$ = this.select((s) => s.invites);
        this.invitesLoading$ = this.select((s) => s.invitesLoading);
        // EFFECTS
        this.provisionCustomerClient = this.effect((provisionModel$) => provisionModel$.pipe(mergeMap((model) => {
            this.setProvisioning(true);
            return this.provisioningService.provisionCustomerClient(model).pipe(tapResponse((client) => {
                this.logger.log('provisionCustomerClient', { client });
                this.customerClientStore.getClient(client.id);
                this.notificationService.popNotification({ type: 'success', title: 'Success', message: 'Account successfully provisioned' });
            }, (e) => {
                this.errorHandler.handleError(e, { alertUser: true });
            }), finalize(() => {
                this.setProvisioning(false);
            }));
        })));
        this.deactivateCustomer = this.effect((request$) => request$.pipe(mergeMap((request) => {
            this.setDeactivating(true);
            return from(this.registrationService.deregister(request)).pipe(tapResponse((res) => {
                this.setDeactivating(false);
                this.customerClientStore.getClient(request.clientId);
                // ? Do we need to fetch the customer record again?
            }, (e) => {
                this.errorHandler.handleError(e, { alertUser: true });
                this.setDeactivating(false);
            }));
        })));
        this.reactivateCustomer = this.effect((req$) => req$.pipe(mergeMap((req) => {
            const { clientId, customerKey } = req;
            this.setReactivating(true);
            return from(this.registrationService.reactivate({ customerKey })).pipe(tapResponse((res) => {
                // TODO: consider another approach
                // this.customerClientStore.getClient(clientId) // Refetches customer record implicitly
                this.setReactivating(false);
            }, (e) => {
                this.errorHandler.handleError(e, { alertUser: true });
                this.setReactivating(false);
            }));
        })));
        this.addInvite = this.effect((request$) => request$.pipe(filter(isNotNil), tap(() => this.setInviteLoading(true)), switchMap((request) => this.inviteService.addProvisionedInvite(request.clientCustomerKey, request.invite).pipe(tapResponse((res) => {
            this.inviteAdded(res);
            this.setInviteLoading(false);
            this.notificationService.popNotification({ title: 'Success', message: 'The invite was sent', type: 'success' });
        }, (e) => {
            this.errorHandler.handleError(e, { alertUser: true });
            this.setInviteLoading(false);
        })))));
        this.resendInvite = this.effect((invite$) => invite$.pipe(filter(isNotNil), tap(() => this.setInviteLoading(true)), switchMap((invite) => from(this.inviteService.resendInviteProvisioned(invite)).pipe(tapResponse((res) => {
            this.setInviteLoading(false);
            this.notificationService.popNotification({ title: 'Success', message: 'The invite was resent', type: 'success' });
        }, (e) => {
            this.errorHandler.handleError(e, { alertUser: true });
            this.setInviteLoading(false);
        })))));
        this.deleteInvite = this.effect((invite$) => invite$.pipe(filter(isNotNil), tap(() => this.setInviteLoading(true)), switchMap((invite) => from(this.inviteService.deleteInviteProvisioned(invite)).pipe(tapResponse((res) => {
            this.inviteRemoved(invite.id);
            this.setInviteLoading(false);
            this.notificationService.popNotification({ title: 'Success', message: 'The invite was deleted', type: 'success' });
        }, (e) => {
            this.errorHandler.handleError(e, { alertUser: true });
            this.setInviteLoading(false);
        })))));
        this.getInvites = this.effect((customerKey$) => customerKey$.pipe(distinctUntilChanged(), // Prevent duplicate calls
        switchMap((customerKey) => {
            this.setInviteLoading(true);
            return this.inviteService.getProvisionedInvites(customerKey).pipe(tapResponse((invites) => {
                this.setInvites(invites);
                this.setInviteLoading(false);
            }, (e) => {
                this.errorHandler.handleError(e);
                this.setInviteLoading(false);
            }));
        })));
        // UPDATERS
        this.setProvisioning = this.updater((state, provisioning) => ({ ...state, provisioning }));
        this.setReactivating = this.updater((state, reactivating) => ({ ...state, reactivating }));
        this.setDeactivating = this.updater((state, deactivating) => ({ ...state, deactivating }));
        this.setInvites = this.updater((state, invites) => ({ ...state, invites }));
        this.inviteAdded = this.updater((state, invite) => ({
            ...state,
            invites: (state.invites ?? []).concat([invite]),
        }));
        this.inviteRemoved = this.updater((state, inviteId) => ({
            ...state,
            invites: state.invites?.filter((i) => i.id !== inviteId) ?? [],
        }));
        this.setInviteLoading = this.updater((state, invitesLoading) => ({ ...state, invitesLoading }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ClientAccountStore, deps: [{ token: i1.E11Logger }, { token: i1.E11ErrorHandlerService }, { token: RegistrationService }, { token: i3.CustomerClientStore }, { token: ProvisioningService }, { token: i4$1.NotificationHelper }, { token: RegistrationInviteService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ClientAccountStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ClientAccountStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.E11Logger }, { type: i1.E11ErrorHandlerService }, { type: RegistrationService }, { type: i3.CustomerClientStore }, { type: ProvisioningService }, { type: i4$1.NotificationHelper }, { type: RegistrationInviteService }] });

class FormProvisionInvitationComponent {
    constructor(logger) {
        this.logger = logger;
        this.loading = false;
        this.submitted = new EventEmitter();
        this.provisionInvitationFields = e11FormFor()([
            e11FormLayoutInlineGrid([
                e11FieldInputText('firstName', 'First Name', undefined, {
                    validatorOrOpts: [Validators.required, E11FormValidator.whitespaceValidator(), E11FormValidator.nameValidator()],
                }),
                e11FieldInputText('lastName', 'Last Name', undefined, {
                    validatorOrOpts: [Validators.required, E11FormValidator.whitespaceValidator(), E11FormValidator.nameValidator()],
                }),
            ]),
            e11FormLayoutInlineGrid([
                e11FieldInputText('email', 'Email', undefined, { validatorOrOpts: [Validators.required, E11FormValidator.emailValidator()] }),
            ]),
        ]);
    }
    onSubmit(formData) {
        this.submitted.emit(formData);
        this.provisionForm.reset();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormProvisionInvitationComponent, deps: [{ token: i1.E11Logger }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: FormProvisionInvitationComponent, selector: "sdk-provision-invitation-form", inputs: { loading: "loading" }, outputs: { submitted: "submitted" }, viewQueries: [{ propertyName: "provisionForm", first: true, predicate: ["provisionForm"], descendants: true }], ngImport: i0, template: `
    <e11-dynamic-form-builder
      #provisionForm
      [fieldGroups]="provisionInvitationFields"
      [hideSubmitMenu]="true"
      [loading]="loading"
      (onSubmit)="onSubmit($event)"
    ></e11-dynamic-form-builder>
    <e11-button
      id="submit_formProvision"
      value="{{ 'Save' | translate }}"
      [color]="'primary-accent'"
      [type]="'submit'"
      [loading]="loading"
      (click)="!loading && provisionForm.onSubmitClick()"
    >
    </e11-button>
  `, isInline: true, dependencies: [{ kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i3$1.E11DynamicFormBuilderComponent, selector: "e11-dynamic-form-builder", inputs: ["initialValue", "hideSubmitMenu", "loading", "disabled", "disabledText", "submitButtonConfig", "cancelButtonConfig", "deleteButtonConfig", "cancelLinkConfig", "showCancelLink", "showCancelButton", "showDeleteButton", "submitButtonTitle", "cancelLinkTitle", "cancelButtonTitle", "deleteButtonTitle", "buttonColorSubmit", "buttonColorCancel", "buttonColorDelete", "fieldGroups", "errorMessageOverrides"], outputs: ["valueChanges", "onSubmit", "onCancel", "onDelete"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormProvisionInvitationComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-provision-invitation-form',
                    template: `
    <e11-dynamic-form-builder
      #provisionForm
      [fieldGroups]="provisionInvitationFields"
      [hideSubmitMenu]="true"
      [loading]="loading"
      (onSubmit)="onSubmit($event)"
    ></e11-dynamic-form-builder>
    <e11-button
      id="submit_formProvision"
      value="{{ 'Save' | translate }}"
      [color]="'primary-accent'"
      [type]="'submit'"
      [loading]="loading"
      (click)="!loading && provisionForm.onSubmitClick()"
    >
    </e11-button>
  `,
                }]
        }], ctorParameters: () => [{ type: i1.E11Logger }], propDecorators: { provisionForm: [{
                type: ViewChild,
                args: ['provisionForm']
            }], loading: [{
                type: Input
            }], submitted: [{
                type: Output
            }] } });

class ProvisionCustomerClientComponent {
    constructor(accountStore, permissionStore) {
        this.accountStore = accountStore;
        this.permissionStore = permissionStore;
        this.provisioning$ = this.accountStore.provisioning$;
        this.canProvisionAccount$ = this.permissionStore.hasPermission(RegistrationPermissions.ProvisionCustomerClient);
        this.disabledText$ = this.canProvisionAccount$.pipe(map((canProvision) => {
            if (!canProvision)
                return 'You do not have permission to provision a client account';
            return 'You must first create and save a client record before you can provision an account';
        }));
        this.accountCreated = new EventEmitter();
    }
    ngOnInit() { }
    provisionAccount(client, formData) {
        const model = this.createProvisionModel(client, formData);
        this.accountStore.provisionCustomerClient(model);
    }
    createProvisionModel(client, formData) {
        const invite = {
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
        };
        const clientBusiness = {
            clientId: client.id,
            invite: invite,
        };
        return clientBusiness;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ProvisionCustomerClientComponent, deps: [{ token: ClientAccountStore }, { token: i2$3.PermissionStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ProvisionCustomerClientComponent, selector: "sdk-provision-customer-client", inputs: { customerClient: "customerClient" }, outputs: { accountCreated: "accountCreated" }, ngImport: i0, template: `
    <e11-button
      [color]="'primary-accent'"
      [value]="'Provision Account' | translate"
      [disabled]="!customerClient || !(canProvisionAccount$ | async)"
      [disabledText]="(disabledText$ | async) ?? '' | translate"
      (click)="modalCreateAccount.open()"
    >
    </e11-button>

    <e11-modal #modalCreateAccount title="{{ 'Create Customer Account' | translate }}" [showHeader]="true" [showFooter]="false">
      <div modal-body>
        <sdk-provision-invitation-form
          *ngIf="customerClient"
          [loading]="(provisioning$ | async) ?? false"
          (submitted)="provisionAccount(customerClient, $event)"
        ></sdk-provision-invitation-form>
      </div>
    </e11-modal>
  `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i1$1.E11ModalComponent, selector: "e11-modal", inputs: ["title", "width", "bodyHeight", "titleAlign", "hideCloseButton", "closer", "bodyClassOverrides", "bodyClass", "modalClassOverrides", "modalClass", "contentClassOverrides", "contentClass", "headerClassOverrides", "headerClass", "footerClassOverrides", "footerClass", "showFooter", "showHeader", "darkMode", "closeOnEscape", "closeOnClickOutside", "headerCTAs", "hasBackdrop", "backdropStyle"], outputs: ["modalOpened", "onModalOpened", "modalClosed", "onModalClosed", "headerCTAClicked", "onHeaderCTAClicked"] }, { kind: "component", type: FormProvisionInvitationComponent, selector: "sdk-provision-invitation-form", inputs: ["loading"], outputs: ["submitted"] }, { kind: "pipe", type: i2.AsyncPipe, name: "async" }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ProvisionCustomerClientComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-provision-customer-client',
                    template: `
    <e11-button
      [color]="'primary-accent'"
      [value]="'Provision Account' | translate"
      [disabled]="!customerClient || !(canProvisionAccount$ | async)"
      [disabledText]="(disabledText$ | async) ?? '' | translate"
      (click)="modalCreateAccount.open()"
    >
    </e11-button>

    <e11-modal #modalCreateAccount title="{{ 'Create Customer Account' | translate }}" [showHeader]="true" [showFooter]="false">
      <div modal-body>
        <sdk-provision-invitation-form
          *ngIf="customerClient"
          [loading]="(provisioning$ | async) ?? false"
          (submitted)="provisionAccount(customerClient, $event)"
        ></sdk-provision-invitation-form>
      </div>
    </e11-modal>
  `,
                }]
        }], ctorParameters: () => [{ type: ClientAccountStore }, { type: i2$3.PermissionStore }], propDecorators: { customerClient: [{
                type: Input
            }], accountCreated: [{
                type: Output
            }] } });

class ReactivateClientCustomerComponent {
    constructor(accountStore, registrationService) {
        this.accountStore = accountStore;
        this.registrationService = registrationService;
        this.accountReactivated = new EventEmitter();
        this.size = 'md';
        this.loading = false;
    }
    ngOnInit() { }
    async confirmReactivate(confirmed, customer) {
        if (confirmed) {
            await this.reactivate(customer?.id);
        }
    }
    async reactivate(customerKey) {
        if (!customerKey) {
            throw e11Error({ title: 'Invalid configuration', message: 'A customerKey is required', type: 'registration/invalid-configuration' });
        }
        this.loading = true;
        await this.registrationService.reactivate({ customerKey });
        this.loading = false;
        this.accountReactivated.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ReactivateClientCustomerComponent, deps: [{ token: ClientAccountStore }, { token: RegistrationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ReactivateClientCustomerComponent, selector: "sdk-reactivate-client-customer", inputs: { clientId: "clientId", customer: "customer", reactivationDeadline: "reactivationDeadline", size: "size" }, outputs: { accountReactivated: "accountReactivated" }, ngImport: i0, template: `
    <div class="e11-w-full e11-flex e11-flex-col " *ngIf="customer">
      <div class="e11-flex e11-grow e11-items-center e11-mb-4">
        <span class="material-icons-outlined md-48 e11-mr-2 e11-text-skin-light"> no_accounts </span>
        <p class="e11-mb-0">
          {{
            ('This account can be reactivated on or before ' | translate) +
              (reactivationDeadline | date) +
              (' after which it will be deleted from our system.' | translate)
          }}
        </p>
      </div>
      <div class="e11-flex e11-items-center e11-justify-start  e11-ml-0">
        <e11-button
          value="{{ loading ? 'Reactivating...' : ('Reactivate Account' | translate) }}"
          [icon]="'account_circle'"
          [iconPosition]="'left'"
          [iconSize]="'md-18'"
          [color]="'secondary'"
          [type]="'button'"
          [size]="size"
          (click)="confirmation.open()"
          [disabled]="loading"
        >
        </e11-button>
      </div>
    </div>

    <e11-confirmation
      #confirmation
      confirmTitle="{{ 'Reactivate Account' | translate }}"
      confirmText="{{ 'Reactivate' | translate }}"
      cancelText="{{ 'Cancel' | translate }}"
      [backdropStyle]="'dark'"
      [confirmClassOverrides]="'e11-bg-skin-error'"
      [isMobile]="false"
      (answer)="confirmReactivate($event, customer)"
    >
      {{ 'Reactivating this account will re-enable all users associated with ' + customer?.name | translate }}
    </e11-confirmation>
  `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4$2.E11ConfirmationComponent, selector: "e11-confirmation", inputs: ["confirmTitle", "confirmText", "cancelText", "confirmClassOverrides", "cancelClassOverrides", "isMobile", "processing", "processingText", "closeOnEscape", "closeOnClickOutside", "hasBackdrop", "backdropStyle", "confirmValueWithInputBox", "valueToConfirm"], outputs: ["answer"] }, { kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "pipe", type: i2.DatePipe, name: "date" }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ReactivateClientCustomerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-reactivate-client-customer',
                    template: `
    <div class="e11-w-full e11-flex e11-flex-col " *ngIf="customer">
      <div class="e11-flex e11-grow e11-items-center e11-mb-4">
        <span class="material-icons-outlined md-48 e11-mr-2 e11-text-skin-light"> no_accounts </span>
        <p class="e11-mb-0">
          {{
            ('This account can be reactivated on or before ' | translate) +
              (reactivationDeadline | date) +
              (' after which it will be deleted from our system.' | translate)
          }}
        </p>
      </div>
      <div class="e11-flex e11-items-center e11-justify-start  e11-ml-0">
        <e11-button
          value="{{ loading ? 'Reactivating...' : ('Reactivate Account' | translate) }}"
          [icon]="'account_circle'"
          [iconPosition]="'left'"
          [iconSize]="'md-18'"
          [color]="'secondary'"
          [type]="'button'"
          [size]="size"
          (click)="confirmation.open()"
          [disabled]="loading"
        >
        </e11-button>
      </div>
    </div>

    <e11-confirmation
      #confirmation
      confirmTitle="{{ 'Reactivate Account' | translate }}"
      confirmText="{{ 'Reactivate' | translate }}"
      cancelText="{{ 'Cancel' | translate }}"
      [backdropStyle]="'dark'"
      [confirmClassOverrides]="'e11-bg-skin-error'"
      [isMobile]="false"
      (answer)="confirmReactivate($event, customer)"
    >
      {{ 'Reactivating this account will re-enable all users associated with ' + customer?.name | translate }}
    </e11-confirmation>
  `,
                }]
        }], ctorParameters: () => [{ type: ClientAccountStore }, { type: RegistrationService }], propDecorators: { clientId: [{
                type: Input
            }], customer: [{
                type: Input
            }], reactivationDeadline: [{
                type: Input
            }], accountReactivated: [{
                type: Output
            }], size: [{
                type: Input
            }] } });

class DeprovisionCustomerComponent {
    constructor(registrationService, permissionStore) {
        this.registrationService = registrationService;
        this.permissionStore = permissionStore;
        this.accountDeactivated = new EventEmitter();
        this.loading = false;
        this.canDeprovisionAccount$ = this.permissionStore.hasPermission(RegistrationPermissions.DeprovisionCustomer);
    }
    ngOnInit() { }
    async confirmDelete(confirmed, customer) {
        if (confirmed)
            await this.deactivate(customer?.id);
    }
    async deactivate(customerKey) {
        if (!customerKey) {
            throw e11Error({ title: 'Invalid configuration', message: 'A customerKey is required', type: 'registration/invalid-configuration' });
        }
        this.loading = true;
        const deactivationData = {};
        await this.registrationService.deregister({ customerKey, deactivationData }); // TODO: Replace with store
        this.loading = false;
        this.accountDeactivated.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DeprovisionCustomerComponent, deps: [{ token: RegistrationService }, { token: i2$3.PermissionStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: DeprovisionCustomerComponent, selector: "sdk-deprovision-customer", inputs: { customer: "customer" }, outputs: { accountDeactivated: "accountDeactivated" }, ngImport: i0, template: `
    <div class="e11-w-full e11-block lg:e11-flex e11-border-b e11-border-skin-grey/50 e11-pb-2 e11-mb-6" *ngIf="customer">
      <div class="e11-flex e11-grow e11-items-center e11-mb-4">
        <span class="material-icons-outlined md-48 e11-mr-2"> account_circle </span>
        <p class="e11-mb-0">{{ ('An account was provisioned for ' | translate) + customer.name + ' on ' + (customer.__createdAt | date) }}</p>
      </div>
      <div class="e11-flex e11-items-center e11-justify-start lg:e11-justify-end e11-ml-0 lg:e11-ml-6">
        <e11-button
          id="degresiter_button"
          value="{{ loading ? 'Deactivating...' : ('Deactivate Account' | translate) }}"
          [icon]="'no_accounts'"
          [iconPosition]="'left'"
          [iconSize]="'md-18'"
          [color]="'secondary'"
          [type]="'button'"
          (click)="confirmation.open()"
          [disabled]="!(canDeprovisionAccount$ | async) || loading"
          [disabledText]="'You do not have permission to deactivate an account' | translate"
        >
        </e11-button>
      </div>
    </div>

    <e11-confirmation
      #confirmation
      confirmTitle="{{ 'Deactivate Account' | translate }}"
      confirmText="{{ 'Deactivate' | translate }}"
      cancelText="{{ 'Cancel' | translate }}"
      [backdropStyle]="'dark'"
      [confirmClassOverrides]="'e11-bg-skin-error'"
      [isMobile]="false"
      (answer)="confirmDelete($event, customer)"
    >
      {{ 'WARNING: Deleting this account will immediately logout and disable all users associated with ' + customer?.name | translate }}
    </e11-confirmation>
  `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4$2.E11ConfirmationComponent, selector: "e11-confirmation", inputs: ["confirmTitle", "confirmText", "cancelText", "confirmClassOverrides", "cancelClassOverrides", "isMobile", "processing", "processingText", "closeOnEscape", "closeOnClickOutside", "hasBackdrop", "backdropStyle", "confirmValueWithInputBox", "valueToConfirm"], outputs: ["answer"] }, { kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "pipe", type: i2.AsyncPipe, name: "async" }, { kind: "pipe", type: i2.DatePipe, name: "date" }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DeprovisionCustomerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-deprovision-customer',
                    template: `
    <div class="e11-w-full e11-block lg:e11-flex e11-border-b e11-border-skin-grey/50 e11-pb-2 e11-mb-6" *ngIf="customer">
      <div class="e11-flex e11-grow e11-items-center e11-mb-4">
        <span class="material-icons-outlined md-48 e11-mr-2"> account_circle </span>
        <p class="e11-mb-0">{{ ('An account was provisioned for ' | translate) + customer.name + ' on ' + (customer.__createdAt | date) }}</p>
      </div>
      <div class="e11-flex e11-items-center e11-justify-start lg:e11-justify-end e11-ml-0 lg:e11-ml-6">
        <e11-button
          id="degresiter_button"
          value="{{ loading ? 'Deactivating...' : ('Deactivate Account' | translate) }}"
          [icon]="'no_accounts'"
          [iconPosition]="'left'"
          [iconSize]="'md-18'"
          [color]="'secondary'"
          [type]="'button'"
          (click)="confirmation.open()"
          [disabled]="!(canDeprovisionAccount$ | async) || loading"
          [disabledText]="'You do not have permission to deactivate an account' | translate"
        >
        </e11-button>
      </div>
    </div>

    <e11-confirmation
      #confirmation
      confirmTitle="{{ 'Deactivate Account' | translate }}"
      confirmText="{{ 'Deactivate' | translate }}"
      cancelText="{{ 'Cancel' | translate }}"
      [backdropStyle]="'dark'"
      [confirmClassOverrides]="'e11-bg-skin-error'"
      [isMobile]="false"
      (answer)="confirmDelete($event, customer)"
    >
      {{ 'WARNING: Deleting this account will immediately logout and disable all users associated with ' + customer?.name | translate }}
    </e11-confirmation>
  `,
                }]
        }], ctorParameters: () => [{ type: RegistrationService }, { type: i2$3.PermissionStore }], propDecorators: { customer: [{
                type: Input
            }], accountDeactivated: [{
                type: Output
            }] } });

class UIInvitedUserComponent {
    constructor() {
        this.allowDelete = true;
        this.allowResend = true;
        this.index = 0;
        this.resend = new EventEmitter();
        this.delete = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UIInvitedUserComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UIInvitedUserComponent, selector: "ui-invited-user", inputs: { invite: "invite", allowDelete: "allowDelete", allowResend: "allowResend", index: "index" }, outputs: { resend: "resend", delete: "delete" }, ngImport: i0, template: `
    <div
      class="e11-flex e11-mb-4 e11-border e11-flex-col md:e11-border-0 md:e11-rounded-none md:e11-mb-0 md:e11-flex-row e11-items-center md:e11-h-12 hover:e11-bg-skin-primary-accent/10 hover:e11-text-skin-primary"
      [ngClass]="{ 'e11-cursor-wait': !invite, 'e11-bg-skin-grey/10': index === 1 }"
    >
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-2/12">
        <span class="md:e11-hidden e11-min-w-[100px] e11-text-sm e11-mr-2 e11-p-2 e11-bg-skin-primary-100">{{ 'First Name' | translate }}</span>
        <div class="e11-truncate e11-skeleton-empty e11-pl-2">{{ invite?.firstName }}</div>
      </div>
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-2/12">
        <span class="md:e11-hidden e11-min-w-[100px] e11-text-sm e11-mr-2 e11-p-2 e11-bg-skin-primary-100">{{ 'Last Name' | translate }}</span>
        <div class="e11-truncate e11-skeleton-empty">{{ invite?.lastName }}</div>
      </div>
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-3/12">
        <span class="md:e11-hidden e11-min-w-[100px] e11-text-sm e11-mr-2 e11-p-2 e11-bg-skin-primary-100">{{ 'Email' | translate }}</span>
        <div class="e11-truncate e11-skeleton-empty">{{ invite?.email }}</div>
      </div>
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-2/12">
        <span class="md:e11-hidden e11-min-w-[100px] e11-text-sm e11-mr-2 e11-p-2 e11-bg-skin-primary-100">{{ 'Roles' | translate }}</span>
        <div class="e11-truncate e11-skeleton-empty">{{ invite?.roles }}</div>
      </div>
      <div class="e11-w-full e11-flex e11-items-center md:e11-w-3/12 e11-justify-start md:e11-justify-end md:e11-pr-2">
        <span class="md:e11-hidden e11-min-w-[100px] e11-text-sm e11-mr-2 e11-p-2 e11-bg-skin-primary-100">{{ 'Actions' | translate }}</span>
        <e11-button
          *ngIf="allowDelete"
          [size]="'sm'"
          value="{{ 'Cancel' | translate }}"
          [ghost]="true"
          [color]="'neutral'"
          [type]="'button'"
          [skeletonLoading]="!invite"
          [buttonGroup]="true"
          (click)="delete.emit(invite)"
        >
        </e11-button>
        <e11-button
          *ngIf="allowResend"
          [size]="'sm'"
          value="{{ 'Resend' | translate }}"
          [color]="'secondary'"
          [type]="'button'"
          [skeletonLoading]="!invite"
          (click)="resend.emit(invite)"
        >
        </e11-button>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UIInvitedUserComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ui-invited-user',
                    template: `
    <div
      class="e11-flex e11-mb-4 e11-border e11-flex-col md:e11-border-0 md:e11-rounded-none md:e11-mb-0 md:e11-flex-row e11-items-center md:e11-h-12 hover:e11-bg-skin-primary-accent/10 hover:e11-text-skin-primary"
      [ngClass]="{ 'e11-cursor-wait': !invite, 'e11-bg-skin-grey/10': index === 1 }"
    >
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-2/12">
        <span class="md:e11-hidden e11-min-w-[100px] e11-text-sm e11-mr-2 e11-p-2 e11-bg-skin-primary-100">{{ 'First Name' | translate }}</span>
        <div class="e11-truncate e11-skeleton-empty e11-pl-2">{{ invite?.firstName }}</div>
      </div>
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-2/12">
        <span class="md:e11-hidden e11-min-w-[100px] e11-text-sm e11-mr-2 e11-p-2 e11-bg-skin-primary-100">{{ 'Last Name' | translate }}</span>
        <div class="e11-truncate e11-skeleton-empty">{{ invite?.lastName }}</div>
      </div>
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-3/12">
        <span class="md:e11-hidden e11-min-w-[100px] e11-text-sm e11-mr-2 e11-p-2 e11-bg-skin-primary-100">{{ 'Email' | translate }}</span>
        <div class="e11-truncate e11-skeleton-empty">{{ invite?.email }}</div>
      </div>
      <div class="e11-w-full e11-flex e11-items-center md:e11-block md:e11-w-2/12">
        <span class="md:e11-hidden e11-min-w-[100px] e11-text-sm e11-mr-2 e11-p-2 e11-bg-skin-primary-100">{{ 'Roles' | translate }}</span>
        <div class="e11-truncate e11-skeleton-empty">{{ invite?.roles }}</div>
      </div>
      <div class="e11-w-full e11-flex e11-items-center md:e11-w-3/12 e11-justify-start md:e11-justify-end md:e11-pr-2">
        <span class="md:e11-hidden e11-min-w-[100px] e11-text-sm e11-mr-2 e11-p-2 e11-bg-skin-primary-100">{{ 'Actions' | translate }}</span>
        <e11-button
          *ngIf="allowDelete"
          [size]="'sm'"
          value="{{ 'Cancel' | translate }}"
          [ghost]="true"
          [color]="'neutral'"
          [type]="'button'"
          [skeletonLoading]="!invite"
          [buttonGroup]="true"
          (click)="delete.emit(invite)"
        >
        </e11-button>
        <e11-button
          *ngIf="allowResend"
          [size]="'sm'"
          value="{{ 'Resend' | translate }}"
          [color]="'secondary'"
          [type]="'button'"
          [skeletonLoading]="!invite"
          (click)="resend.emit(invite)"
        >
        </e11-button>
      </div>
    </div>
  `,
                }]
        }], ctorParameters: () => [], propDecorators: { invite: [{
                type: Input
            }], allowDelete: [{
                type: Input
            }], allowResend: [{
                type: Input
            }], index: [{
                type: Input
            }], resend: [{
                type: Output
            }], delete: [{
                type: Output
            }] } });

class UIInvitedListComponent {
    constructor() {
        this.loading = false;
        this.allowDelete = true;
        this.allowResend = true;
        this.resend = new EventEmitter();
        this.delete = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UIInvitedListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UIInvitedListComponent, selector: "ui-invited-user-list", inputs: { invitedUsers: "invitedUsers", loading: "loading", allowDelete: "allowDelete", allowResend: "allowResend" }, outputs: { resend: "resend", delete: "delete" }, ngImport: i0, template: `
    <div class="e11-relative">
      <e11-loader-dots *ngIf="loading" [color]="'e11-bg-skin-primary-accent'" [size]="'sm'"></e11-loader-dots>
      <div *ngIf="!loading">
        <div class="e11-w-full e11-mb-16" *ngIf="!invitedUsers?.length">
          <e11-empty-state
            [icon]="'description'"
            [iconSize]="'md-36'"
            title="{{ 'No Current Invites' | translate }}"
            subtitle="{{ 'You have no pending invitations sent to anyone.' | translate }}"
            [clickable]="false"
          ></e11-empty-state>
        </div>
        <div class="e11-flex e11-w-full" *ngIf="invitedUsers?.length">
          <div class="e11-w-full e11-overflow-hidden">
            <div class="e11-hidden md:e11-flex e11-text-sm e11-font-bold e11-border-b e11-border-skin-grey/50">
              <div class="e11-w-2/12 e11-mb-2">{{ 'First Name' | translate }}</div>
              <div class="e11-w-2/12 e11-mb-2">{{ 'Last Name' | translate }}</div>
              <div class="e11-w-3/12 e11-mb-2">{{ 'Email' | translate }}</div>
              <div class="e11-w-2/12 e11-mb-2">{{ 'Roles' | translate }}</div>
              <div class="e11-w-3/12 e11-mb-2"></div>
            </div>

            <div>
              <ui-invited-user
                *ngFor="let invite of invitedUsers; let i = index"
                [invite]="invite"
                [index]="i"
                [allowDelete]="allowDelete"
                [allowResend]="allowResend"
                (resend)="resend.emit(invite)"
                (delete)="delete.emit(invite)"
              ></ui-invited-user>
            </div>
          </div>
        </div>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$4.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i3$2.E11EmptyStateComponent, selector: "e11-empty-state", inputs: ["icon", "iconType", "iconSize", "customImageUrl", "customImageAltText", "showButton", "borderColor", "buttonValue", "buttonColor", "buttonDisabled", "buttonIcon", "border", "title", "subtitle", "clickable", "disabled", "disabledText", "containerClass", "contentClass", "containerClassOverrides", "contentClassOverrides", "htmlSubtitle"], outputs: ["buttonClicked"] }, { kind: "component", type: UIInvitedUserComponent, selector: "ui-invited-user", inputs: ["invite", "allowDelete", "allowResend", "index"], outputs: ["resend", "delete"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UIInvitedListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ui-invited-user-list',
                    template: `
    <div class="e11-relative">
      <e11-loader-dots *ngIf="loading" [color]="'e11-bg-skin-primary-accent'" [size]="'sm'"></e11-loader-dots>
      <div *ngIf="!loading">
        <div class="e11-w-full e11-mb-16" *ngIf="!invitedUsers?.length">
          <e11-empty-state
            [icon]="'description'"
            [iconSize]="'md-36'"
            title="{{ 'No Current Invites' | translate }}"
            subtitle="{{ 'You have no pending invitations sent to anyone.' | translate }}"
            [clickable]="false"
          ></e11-empty-state>
        </div>
        <div class="e11-flex e11-w-full" *ngIf="invitedUsers?.length">
          <div class="e11-w-full e11-overflow-hidden">
            <div class="e11-hidden md:e11-flex e11-text-sm e11-font-bold e11-border-b e11-border-skin-grey/50">
              <div class="e11-w-2/12 e11-mb-2">{{ 'First Name' | translate }}</div>
              <div class="e11-w-2/12 e11-mb-2">{{ 'Last Name' | translate }}</div>
              <div class="e11-w-3/12 e11-mb-2">{{ 'Email' | translate }}</div>
              <div class="e11-w-2/12 e11-mb-2">{{ 'Roles' | translate }}</div>
              <div class="e11-w-3/12 e11-mb-2"></div>
            </div>

            <div>
              <ui-invited-user
                *ngFor="let invite of invitedUsers; let i = index"
                [invite]="invite"
                [index]="i"
                [allowDelete]="allowDelete"
                [allowResend]="allowResend"
                (resend)="resend.emit(invite)"
                (delete)="delete.emit(invite)"
              ></ui-invited-user>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
                }]
        }], ctorParameters: () => [], propDecorators: { invitedUsers: [{
                type: Input
            }], loading: [{
                type: Input
            }], allowDelete: [{
                type: Input
            }], allowResend: [{
                type: Input
            }], resend: [{
                type: Output
            }], delete: [{
                type: Output
            }] } });

class CustomerClientProvisionedComponent {
    set customer(customer) {
        if (customer?.id && customer?.id !== this._customer?.id)
            this.clientAccountStore.getInvites(customer.id);
        this._customer = customer;
    }
    constructor(logger, clientAccountStore, permissionStore, configProvider) {
        this.logger = logger;
        this.clientAccountStore = clientAccountStore;
        this.permissionStore = permissionStore;
        this.configProvider = configProvider;
        this.accountDeactivated = new EventEmitter();
        this.invitesLoading$ = this.clientAccountStore.invitesLoading$;
        this.invitedUsers$ = this.clientAccountStore.invites$.pipe(map((invitedUsers) => deepCopy(invitedUsers)));
        this.canProvisionAccount$ = this.permissionStore.hasPermission(RegistrationPermissions.ProvisionCustomerClient);
    }
    ngOnInit() {
        this.logger.log({ customer: this._customer });
    }
    inviteNewUser(invite) {
        const updatedInvite = { ...invite, additionalRoles: this.configProvider.config.additionalCustomerClientRoles };
        this.clientAccountStore.addInvite({ clientCustomerKey: this._customer.id, invite: updatedInvite });
        this.modalInviteUser?.close();
    }
    resendInvitation(request) {
        this.clientAccountStore.resendInvite(request);
    }
    deleteInvitation(request) {
        this.clientAccountStore.deleteInvite(request);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientProvisionedComponent, deps: [{ token: i1.E11Logger }, { token: ClientAccountStore }, { token: i2$3.PermissionStore }, { token: BaseRegistrationConfigProvider }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerClientProvisionedComponent, selector: "sdk-customer-client-provisioned", inputs: { customer: "customer" }, outputs: { accountDeactivated: "accountDeactivated" }, viewQueries: [{ propertyName: "modalInviteUser", first: true, predicate: ["modalInviteUser"], descendants: true }], ngImport: i0, template: `
    <ng-container *ngIf="_customer; else Loading">
      <sdk-deprovision-customer [customer]="_customer" (accountDeactivated)="accountDeactivated.emit()"></sdk-deprovision-customer>

      <div class="e11-w-full e11-flex e11-items-center">
        <div class="e11-grow">
          <h3>{{ 'Invited Users' }}</h3>
          <p class="e11-text-sm e11-pr-6">
            {{
              'The invitations here are emailed to the email address you provide which then allows those recipients to complete the registration process and use this application.'
            }}
          </p>
        </div>
        <div class="e11-flex e11-justify-end">
          <e11-button
            [size]="'sm'"
            [value]="'Invite User' | translate"
            [color]="'primary-accent'"
            [disabled]="!(canProvisionAccount$ | async)"
            [disabledText]="'You do not have permission to invite new users' | translate"
            (click)="modalInviteUser.open()"
          ></e11-button>
        </div>
      </div>

      <ui-invited-user-list
        [invitedUsers]="(invitedUsers$ | async) ?? undefined"
        [loading]="(invitesLoading$ | async) ?? false"
        [allowResend]="(canProvisionAccount$ | async) ?? false"
        [allowDelete]="(canProvisionAccount$ | async) ?? false"
        (resend)="resendInvitation($event)"
        (delete)="deleteInvitation($event)"
      ></ui-invited-user-list>
    </ng-container>

    <ng-template #Loading>
      <e11-loader-dots *ngIf="!_customer" [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-template>

    <e11-modal #modalInviteUser title="{{ 'Invite New User' | translate }}" [showHeader]="true" [showFooter]="false">
      <div modal-body>
        <sdk-provision-invitation-form
          [loading]="(invitesLoading$ | async) ?? false"
          (submitted)="inviteNewUser($event)"
        ></sdk-provision-invitation-form>
      </div>
    </e11-modal>
  `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i2$4.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i1$1.E11ModalComponent, selector: "e11-modal", inputs: ["title", "width", "bodyHeight", "titleAlign", "hideCloseButton", "closer", "bodyClassOverrides", "bodyClass", "modalClassOverrides", "modalClass", "contentClassOverrides", "contentClass", "headerClassOverrides", "headerClass", "footerClassOverrides", "footerClass", "showFooter", "showHeader", "darkMode", "closeOnEscape", "closeOnClickOutside", "headerCTAs", "hasBackdrop", "backdropStyle"], outputs: ["modalOpened", "onModalOpened", "modalClosed", "onModalClosed", "headerCTAClicked", "onHeaderCTAClicked"] }, { kind: "component", type: DeprovisionCustomerComponent, selector: "sdk-deprovision-customer", inputs: ["customer"], outputs: ["accountDeactivated"] }, { kind: "component", type: FormProvisionInvitationComponent, selector: "sdk-provision-invitation-form", inputs: ["loading"], outputs: ["submitted"] }, { kind: "component", type: UIInvitedListComponent, selector: "ui-invited-user-list", inputs: ["invitedUsers", "loading", "allowDelete", "allowResend"], outputs: ["resend", "delete"] }, { kind: "pipe", type: i2.AsyncPipe, name: "async" }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientProvisionedComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-client-provisioned',
                    template: `
    <ng-container *ngIf="_customer; else Loading">
      <sdk-deprovision-customer [customer]="_customer" (accountDeactivated)="accountDeactivated.emit()"></sdk-deprovision-customer>

      <div class="e11-w-full e11-flex e11-items-center">
        <div class="e11-grow">
          <h3>{{ 'Invited Users' }}</h3>
          <p class="e11-text-sm e11-pr-6">
            {{
              'The invitations here are emailed to the email address you provide which then allows those recipients to complete the registration process and use this application.'
            }}
          </p>
        </div>
        <div class="e11-flex e11-justify-end">
          <e11-button
            [size]="'sm'"
            [value]="'Invite User' | translate"
            [color]="'primary-accent'"
            [disabled]="!(canProvisionAccount$ | async)"
            [disabledText]="'You do not have permission to invite new users' | translate"
            (click)="modalInviteUser.open()"
          ></e11-button>
        </div>
      </div>

      <ui-invited-user-list
        [invitedUsers]="(invitedUsers$ | async) ?? undefined"
        [loading]="(invitesLoading$ | async) ?? false"
        [allowResend]="(canProvisionAccount$ | async) ?? false"
        [allowDelete]="(canProvisionAccount$ | async) ?? false"
        (resend)="resendInvitation($event)"
        (delete)="deleteInvitation($event)"
      ></ui-invited-user-list>
    </ng-container>

    <ng-template #Loading>
      <e11-loader-dots *ngIf="!_customer" [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-template>

    <e11-modal #modalInviteUser title="{{ 'Invite New User' | translate }}" [showHeader]="true" [showFooter]="false">
      <div modal-body>
        <sdk-provision-invitation-form
          [loading]="(invitesLoading$ | async) ?? false"
          (submitted)="inviteNewUser($event)"
        ></sdk-provision-invitation-form>
      </div>
    </e11-modal>
  `,
                }]
        }], ctorParameters: () => [{ type: i1.E11Logger }, { type: ClientAccountStore }, { type: i2$3.PermissionStore }, { type: BaseRegistrationConfigProvider }], propDecorators: { modalInviteUser: [{
                type: ViewChild,
                args: ['modalInviteUser']
            }], customer: [{
                type: Input
            }], accountDeactivated: [{
                type: Output
            }] } });

class ClientAccountComponent {
    set clientId(id) {
        this.clientStore.getClientIfDistinct(id);
    }
    constructor(clientStore, clientAccountStore, permissionStore) {
        this.clientStore = clientStore;
        this.clientAccountStore = clientAccountStore;
        this.permissionStore = permissionStore;
        this.ClientAccountStatus = ClientAccountStatus;
        this.client$ = this.clientStore.selectedClient$;
        this.clientCustomer$ = this.clientStore.selectedCustomer$;
        this.clientAccountStatus$ = this.clientAccountStore.clientAccountStatus$;
        this.loaded$ = combineLatest([this.clientStore.customerLoaded$, this.clientStore.clientLoading$, this.permissionStore.loaded$]).pipe(map(([customerLoaded, clientLoading, permissionsLoaded]) => customerLoaded && !clientLoading && permissionsLoaded));
    }
    ngOnInit() { }
    accountCreated(client) {
        this.clientStore.getClient(client.id);
    }
    accountDeactivated(clientId) {
        this.clientStore.getClient(clientId);
    }
    accountReactivated(clientId) {
        this.clientStore.getClient(clientId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ClientAccountComponent, deps: [{ token: i3.CustomerClientStore }, { token: ClientAccountStore }, { token: i2$3.PermissionStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ClientAccountComponent, selector: "sdk-client-account", inputs: { clientId: "clientId" }, ngImport: i0, template: `
    <ng-container>
      <section class="e11-mb-4">
        <div class="e11-flex e11-gap-2 e11-items-center">
          <h3>{{ 'Account' | translate }}</h3>
          <e11-tooltip
            [color]="'dark'"
            [tooltipText]="
              'When you create an account on your clients behalf an email will be sent to the email address you provide. The client can then complete the registration process and log into the application.'
                | translate
            "
          >
            <span class="material-icons-outlined md-18 e11-cursor-default">info</span>
          </e11-tooltip>
        </div>

        <p>{{ 'Provision an account for this client.' | translate }}</p>
        <!-- <p>
          {{
            'When you create an account on your clients behalf an email will be sent to the email address you provide. The client can then complete the registration process and log into the application.'
              | translate
          }}
        </p> -->
      </section>

      <ng-container *ngIf="loaded$ | async; else Loading">
        <ng-container *ngrxLet="client$ as client">
          <ng-container *ngrxLet="clientAccountStatus$ as clientAccountStatus">
            <sdk-provision-customer-client
              *ngIf="clientAccountStatus === ClientAccountStatus.NoAccount"
              [customerClient]="client"
              (accountCreated)="accountCreated($event)"
            ></sdk-provision-customer-client>
            <ng-container *ngrxLet="clientCustomer$ as clientCustomer">
              <sdk-customer-client-provisioned
                *ngIf="clientAccountStatus === ClientAccountStatus.Provisioned"
                [customer]="clientCustomer"
                (accountDeactivated)="accountDeactivated(client?.id)"
              ></sdk-customer-client-provisioned>
              <sdk-reactivate-client-customer
                *ngIf="clientAccountStatus === ClientAccountStatus.Deactivated"
                [customer]="clientCustomer"
                [reactivationDeadline]="clientCustomer?.deactivationWindowEnd"
                (accountReactivated)="accountReactivated(client?.id)"
              ></sdk-reactivate-client-customer>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-template #Loading>
        <e11-loader-dots [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
      </ng-template>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$4.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i6$2.E11TooltipComponent, selector: "e11-tooltip", inputs: ["tooltipText", "tooltipClassOverrides", "hideTooltip", "color", "tooltipContent", "position", "interactive", "maxWidth", "delay"], outputs: ["tooltipClick"] }, { kind: "directive", type: i4.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: ProvisionCustomerClientComponent, selector: "sdk-provision-customer-client", inputs: ["customerClient"], outputs: ["accountCreated"] }, { kind: "component", type: ReactivateClientCustomerComponent, selector: "sdk-reactivate-client-customer", inputs: ["clientId", "customer", "reactivationDeadline", "size"], outputs: ["accountReactivated"] }, { kind: "component", type: CustomerClientProvisionedComponent, selector: "sdk-customer-client-provisioned", inputs: ["customer"], outputs: ["accountDeactivated"] }, { kind: "pipe", type: i2.AsyncPipe, name: "async" }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ClientAccountComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-client-account',
                    template: `
    <ng-container>
      <section class="e11-mb-4">
        <div class="e11-flex e11-gap-2 e11-items-center">
          <h3>{{ 'Account' | translate }}</h3>
          <e11-tooltip
            [color]="'dark'"
            [tooltipText]="
              'When you create an account on your clients behalf an email will be sent to the email address you provide. The client can then complete the registration process and log into the application.'
                | translate
            "
          >
            <span class="material-icons-outlined md-18 e11-cursor-default">info</span>
          </e11-tooltip>
        </div>

        <p>{{ 'Provision an account for this client.' | translate }}</p>
        <!-- <p>
          {{
            'When you create an account on your clients behalf an email will be sent to the email address you provide. The client can then complete the registration process and log into the application.'
              | translate
          }}
        </p> -->
      </section>

      <ng-container *ngIf="loaded$ | async; else Loading">
        <ng-container *ngrxLet="client$ as client">
          <ng-container *ngrxLet="clientAccountStatus$ as clientAccountStatus">
            <sdk-provision-customer-client
              *ngIf="clientAccountStatus === ClientAccountStatus.NoAccount"
              [customerClient]="client"
              (accountCreated)="accountCreated($event)"
            ></sdk-provision-customer-client>
            <ng-container *ngrxLet="clientCustomer$ as clientCustomer">
              <sdk-customer-client-provisioned
                *ngIf="clientAccountStatus === ClientAccountStatus.Provisioned"
                [customer]="clientCustomer"
                (accountDeactivated)="accountDeactivated(client?.id)"
              ></sdk-customer-client-provisioned>
              <sdk-reactivate-client-customer
                *ngIf="clientAccountStatus === ClientAccountStatus.Deactivated"
                [customer]="clientCustomer"
                [reactivationDeadline]="clientCustomer?.deactivationWindowEnd"
                (accountReactivated)="accountReactivated(client?.id)"
              ></sdk-reactivate-client-customer>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-template #Loading>
        <e11-loader-dots [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
      </ng-template>
    </ng-container>
  `,
                }]
        }], ctorParameters: () => [{ type: i3.CustomerClientStore }, { type: ClientAccountStore }, { type: i2$3.PermissionStore }], propDecorators: { clientId: [{
                type: Input
            }] } });

class TenantBootstrapService {
    constructor(configProvider) {
        this.configProvider = configProvider;
    }
    getBusinessBootstrap(customerKey) {
        const restClient = this.createRestClient();
        return restClient.get(`bootstrap/${customerKey}/business`, { version: '1' }).pipe(map((response) => response.data));
    }
    getConsumerBootstrap(customerKey) {
        const restClient = this.createRestClient();
        return restClient.get(`bootstrap${customerKey}/consumer`, { version: '1' }).pipe(map((response) => response.data));
    }
    getAllConsumerTenants() {
        const restClient = this.createRestClient();
        return restClient.get(`bootstrap/consumer`, { version: '1' }).pipe(map((response) => response.data));
    }
    getAllBusinessTenants() {
        const restClient = this.createRestClient();
        return restClient.get(`bootstrap/business`, { version: '1' }).pipe(map((response) => response.data));
    }
    updateBusinessTenant(tenantModel) {
        const restClient = this.createRestClient();
        return restClient.patch(`bootstrap/business`, tenantModel).pipe(map((response) => response.data));
    }
    createRestClient() {
        if (!this.configProvider.config.registrationBaseURL)
            throw e11Error(missingRegistrationBaseURL$1);
        return new RestApiClient({
            baseUrl: this.configProvider.config.registrationBaseURL,
            token: this.configProvider.config.token$.pipe(filter((token) => isNotNil(token))),
            throwNon200s: true,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TenantBootstrapService, deps: [{ token: BaseRegistrationConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TenantBootstrapService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TenantBootstrapService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BaseRegistrationConfigProvider }] });
const missingRegistrationBaseURL$1 = {
    type: REGISTRATION_ERRORS.MISSING_CONFIG,
    title: 'Missing configuration',
    message: 'Missing configuration, registrationBaseURL is undefined. Configure Registration module with an IRegistrationConfig model',
};

class TenantInviteService {
    constructor(configProvider) {
        this.configProvider = configProvider;
        this.restClient = this.createRestClient();
    }
    getInvitesForTenant(request) {
        const { customerKey, authTenantId } = request;
        return this.restClient.get(`tenants/${authTenantId}/invitations/${customerKey}`).pipe(map((response) => response.data));
    }
    resendInvite(request) {
        const { customerKey, authTenantId, email } = request;
        return this.restClient
            .post(`tenants/${authTenantId}/invitations/${email}/resend`, { customerKey })
            .pipe(map((response) => response.data));
    }
    createInvite(request) {
        const { authTenantId } = request;
        return this.restClient
            .post(`tenants/${authTenantId}/invitations`, omit(request, 'authTenantId'))
            .pipe(map((response) => response.data));
    }
    createBulkInvites(request) {
        const { authTenantId } = request;
        return this.restClient
            .post(`tenants/${authTenantId}/invitations/bulk`, omit(request, 'authTenantId'))
            .pipe(map((response) => response.data));
    }
    deleteInvite(request) {
        const { id, authTenantId } = request;
        return this.restClient.delete(`tenants/${authTenantId}/invitations/${id}/delete`).pipe(map((response) => response.data));
    }
    createRestClient() {
        if (!this.configProvider.config.registrationBaseURL)
            throw e11Error(missingRegistrationBaseURL);
        return new RestApiClient({
            baseUrl: this.configProvider.config.registrationBaseURL,
            token: this.configProvider.config.token$.pipe(filter((token) => isNotNil(token))),
            throwNon200s: true,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TenantInviteService, deps: [{ token: BaseRegistrationConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TenantInviteService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TenantInviteService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BaseRegistrationConfigProvider }] });
const missingRegistrationBaseURL = {
    type: REGISTRATION_ERRORS.MISSING_CONFIG,
    title: 'Missing configuration',
    message: 'Missing configuration, registrationBaseURL is undefined. Configure Registration module with an IRegistrationConfig model',
};

const initialTenantBootstrapState = {
    loading: false,
    businessTenantBootstraps: [],
    consumerTenantBootstraps: [],
    invites: [],
    invitesLoading: false,
};
class TenantBootstrapStore extends ComponentStore {
    constructor(logger, errorHandler, tenantBootstrapService, tenantInviteService, notificationService, configProvider) {
        super(initialTenantBootstrapState);
        this.logger = logger;
        this.errorHandler = errorHandler;
        this.tenantBootstrapService = tenantBootstrapService;
        this.tenantInviteService = tenantInviteService;
        this.notificationService = notificationService;
        this.configProvider = configProvider;
        // SELECTORS
        this.state$ = this.select((s) => s);
        this.businessTenantBootstraps$ = this.select((s) => s.businessTenantBootstraps);
        this.consumerTenantBootstraps$ = this.select((s) => s.consumerTenantBootstraps);
        this.tenantInvites$ = this.select((s) => s.invites);
        this.invitesLoading$ = this.select((s) => s.invitesLoading);
        this.loading$ = this.select((s) => s.loading);
        this.selectedBootstrap$ = this.select((s) => s.selectedBootstrap);
        // EFFECTS
        this.getSingleConsumerTenant = this.effect((id$) => id$.pipe(switchMap((id) => this.tenantBootstrapService.getConsumerBootstrap(id).pipe(tapResponse((_) => this.getAllConsumerTenants(), (e) => this.errorHandler.handleError(e))))));
        this.getSingleBusinessTenant = this.effect((id$) => id$.pipe(switchMap((id) => this.tenantBootstrapService.getBusinessBootstrap(id).pipe(tapResponse((_) => this.getAllBusinessTenants(), (e) => {
            this.errorHandler.handleError(e);
        })))));
        this.getSelectBootstrap = this.effect((customerKey$) => customerKey$.pipe(switchMap((customerKey) => this.tenantBootstrapService.getBusinessBootstrap(customerKey).pipe(tapResponse((bootstrap) => this.setSelectedBootstrap(bootstrap), (e) => {
            this.errorHandler.handleError(e);
        })))));
        this.getAllConsumerTenants = this.effect(($) => $.pipe(tap(() => this.setLoading(true)), switchMap(() => this.tenantBootstrapService.getAllConsumerTenants().pipe(tapResponse((tenants) => {
            this.addConsumerTenant(tenants);
            this.setLoading(false);
        }, (e) => this.errorHandler.handleError(e))))));
        this.getAllBusinessTenants = this.effect(($) => $.pipe(tap(() => this.setLoading(true)), switchMap(() => this.tenantBootstrapService.getAllBusinessTenants().pipe(tapResponse((tenants) => {
            this.addBusinessTenant(tenants);
            this.setLoading(false);
        }, (e) => this.errorHandler.handleError(e))))));
        this.updateBusinessTenant = this.effect((newBusinessTenant$) => newBusinessTenant$.pipe(tap(() => this.setLoading(true)), exhaustMap((newBusinessTenant) => this.tenantBootstrapService.updateBusinessTenant(newBusinessTenant).pipe(tapResponse(() => {
            this.getAllBusinessTenants();
            this.setLoading(false);
            this.notificationService.popNotification({ title: 'Updated', message: 'The bootstrap was updated', type: 'success' });
        }, (e) => this.errorHandler.handleError(e, { alertUser: true }))))));
        this.getInvites = this.effect((request$) => request$.pipe(distinctUntilChanged(isEqual), // Prevent duplicate calls
        switchMap((request) => {
            this.setInviteLoading(true);
            return this.tenantInviteService.getInvitesForTenant(request).pipe(tapResponse((invites) => this.setInvites(invites), (e) => this.errorHandler.handleError(e)), finalize(() => this.setInviteLoading(false)));
        })));
        this.resendInvite = this.effect((request$) => request$.pipe(tap(() => this.setInviteLoading(true)), switchMap((invite) => this.tenantInviteService.resendInvite(invite).pipe(tapResponse((res) => this.notificationService.popNotification({ title: 'Success', message: 'The invite was resent', type: 'success' }), (e) => this.errorHandler.handleError(e, { alertUser: true })), finalize(() => this.setInviteLoading(false))))));
        this.addInvite = this.effect((request$) => request$.pipe(tap(() => this.setInviteLoading(true)), map((request) => ({ ...request, additionalRoles: this.configProvider.config.additionalTenantCustomerRoles })), switchMap((request) => this.tenantInviteService.createInvite(request).pipe(tapResponse((res) => {
            this.inviteAdded(res);
            this.notificationService.popNotification({ title: 'Success', message: 'The invite was sent', type: 'success' });
        }, (e) => this.errorHandler.handleError(e, { alertUser: true })), finalize(() => this.setInviteLoading(false))))));
        this.addBulkInvite = this.effect((request$) => request$.pipe(tap(() => this.setInviteLoading(true)), switchMap((request) => this.tenantInviteService.createBulkInvites(request).pipe(tapResponse((res) => {
            this.invitesAdded(res);
            this.notificationService.popNotification({ title: 'Success', message: 'The invites were sent', type: 'success' });
        }, (e) => this.errorHandler.handleError(e, { alertUser: true })), finalize(() => this.setInviteLoading(false))))));
        this.deleteInvite = this.effect((invite$) => invite$.pipe(tap(() => this.setInviteLoading(true)), switchMap((invite) => this.tenantInviteService.deleteInvite(invite).pipe(tapResponse((res) => {
            this.inviteRemoved(invite.id);
            this.notificationService.popNotification({ title: 'Success', message: 'The invite was deleted', type: 'success' });
        }, (e) => this.errorHandler.handleError(e, { alertUser: true })), finalize(() => this.setInviteLoading(false))))));
        // UPDATERS
        this.setLoading = this.updater((state, loading) => ({ ...state, loading }));
        this.setSelectedBootstrap = this.updater((state, selectedBootstrap) => ({ ...state, selectedBootstrap }));
        this.addConsumerTenant = this.updater((state, consumerTenantBootstraps) => ({ ...state, consumerTenantBootstraps }));
        this.addBusinessTenant = this.updater((state, businessTenantBootstraps) => ({ ...state, businessTenantBootstraps }));
        this.setInvites = this.updater((state, invites) => ({ ...state, invites }));
        this.setInviteLoading = this.updater((state, invitesLoading) => ({ ...state, invitesLoading }));
        this.inviteAdded = this.updater((state, invite) => ({
            ...state,
            invites: (state.invites ?? []).concat([invite]),
        }));
        this.invitesAdded = this.updater((state, invites) => ({
            ...state,
            invites: (state.invites ?? []).concat(invites),
        }));
        this.inviteRemoved = this.updater((state, inviteId) => ({
            ...state,
            invites: state.invites?.filter((i) => i.id !== inviteId) ?? [],
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TenantBootstrapStore, deps: [{ token: i1.E11Logger }, { token: i1.E11ErrorHandlerService }, { token: TenantBootstrapService }, { token: TenantInviteService }, { token: i4$1.NotificationHelper }, { token: BaseRegistrationConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TenantBootstrapStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TenantBootstrapStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.E11Logger }, { type: i1.E11ErrorHandlerService }, { type: TenantBootstrapService }, { type: TenantInviteService }, { type: i4$1.NotificationHelper }, { type: BaseRegistrationConfigProvider }] });

const TENANT_IMAGES = {
    logoImage: { fileName: 'logo.png', fileExtension: '.png' },
    logoImageDark: { fileName: 'logo-dark.png', fileExtension: '.png' },
    logoImageLight: { fileName: 'logo-light.png', fileExtension: '.png' },
    favIcon: { fileName: 'favicon.svg', fileExtension: '.svg' },
    favIconNotification: { fileName: 'favicon-notification.svg', fileExtension: '.svg' },
    emailLogo: { fileName: 'logo-email.png', fileExtension: '.png' },
};

/**
 * Utility class for building form fields for tenant creation and editing.
 * This class provides methods to generate URLs for tenant brand logos and prepare
 * arguments for file inputs used in tenant forms.
 */
class TenantFileInputUtil {
    /**
     * Generates a URL for tenant brand logos based on the provided configuration.
     *
     * @param {ITenantImageConfig} config - Configuration object for generating the tenant image URL.
     * @param {string} config.hostName - The hostname of the tenant (e.g., "tenant-name").
     * @param {string} config.fileName - The filename of the image (e.g., "logo.png").
     * @param {string} config.cdnName - The CDN base URL (e.g., "cdn.example.com").
     * @returns {string} The generated URL for the tenant's brand logo.
     * @example
     * const config = {
     *   hostName: 'example-tenant',
     *   fileName: 'logo.png',
     *   cdnName: 'content.engineering11.com'
     * };
     * const url = TenantFileInputUtil.getImageUrl(config);
     * console.log(url); // Outputs: https://content.engineering11.com/assets/bootstrap/example-tenant/logo.png
     */
    static getImageUrl({ hostName, fileName, cdnName }) {
        return `https://${cdnName}/assets/bootstrap/${hostName}/${fileName}`;
    }
    /**
     * Prepares input arguments for a tenant form's file input field.
     *
     * @param {FileInfo} fileInfo - Information about the file to be uploaded.
     * @param {string} fileInfo.fileName - The name of the file (e.g., "logo.png").
     * @param {AcceptFileType} fileInfo.fileExtension - The file's extension (e.g., ".png").
     * @param {Pick<ITenantImageConfig, 'cdnName' | 'hostName'>} [configs] - Optional configuration
     * object containing CDN and hostname information for generating default preview URLs.
     * @returns {Partial<E11InputFileComponent>} An object containing input attributes for the file input field.
     * @returns {AcceptFileType[]} accept - A list of acceptable file extensions for the input.
     * @returns {string[]} [defaultPreviewUrls] - A list of default preview URLs, if configs are provided.
     * @example
     * const fileInfo = { fileName: 'logo.png', fileExtension: '.png' };
     * const configs = { cdnName: 'content.engineering11.com', hostName: 'example-tenant' };
     * const args = TenantFileInputUtil.getArgsForFileInput(fileInfo, configs);
     * console.log(args);
     * // Outputs: {
     * //   accept: ['.png'],
     * //   defaultPreviewUrls: ['https://content.engineering11.com/assets/bootstrap/example-tenant/logo.png']
     * // }
     */
    static getArgsForFileInput(fileInfo, configs) {
        return {
            accept: [fileInfo.fileExtension],
            ...(configs && { defaultPreviewUrls: [this.getImageUrl({ ...configs, fileName: fileInfo.fileName })] }),
        };
    }
}

class AdditionalHostsComponent {
    constructor(fb) {
        this.fb = fb;
        this.inputControl = new FormControl('', [Validators.pattern(HostRegex)]);
        this.hosts = this.fb.array([]);
        this.loading = false;
        this.value = [];
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    onHostEntered(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.inputControl.valid) {
            const newHost = this.inputControl.value.trim();
            this.addHost(newHost);
            this.inputControl.reset();
            this.onChange(this.hosts.value);
        }
    }
    onRemoveHost(control) {
        const index = this.hosts.controls.indexOf(control);
        this.hosts.removeAt(index);
        this.onChange(this.hosts.value);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    writeValue(value) {
        this.hosts.clear();
        value.map((host) => this.addHost(host));
    }
    addHost(host) {
        this.hosts.push(new FormControl(host, { nonNullable: true, validators: [Validators.pattern(HostRegex)] }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AdditionalHostsComponent, deps: [{ token: i2$5.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.9", type: AdditionalHostsComponent, selector: "sdk-additional-hosts", inputs: { loading: "loading", value: "value" }, ngImport: i0, template: `
    <div>
      <div class="e11-mb-2">
        <e11-input
          label="{{ 'Additional hosts (These will be other hosts accessible under the same tenant)' | translate }}"
          [loading]="loading"
          [type]="'text'"
          [hasError]="inputControl.invalid"
          [formControl]="inputControl"
          (keydown.enter)="onHostEntered($event)"
        >
          <span *ngIf="inputControl.invalid" class="e11-text-skin-error e11-text-sm">{{ 'Invalid host name' | translate }}</span>
        </e11-input>
      </div>
      @for (host of hosts.controls; track host) {
      <div [ngClass]="{ 'e11-skeleton': loading }" class="e11-flex e11-justify-between e11-text-center e11-p-2 hover:e11-bg-skin-grey/20">
        <p class="e11-mb-0">{{ host.value }}</p>
        <span
          (click)="!loading ? onRemoveHost(host) : undefined"
          [ngClass]="{ 'e11-text-skin-base': loading, 'e11-text-skin-secondary e11-cursor-pointer hover:e11-text-skin-error': !loading }"
          class="material-icons-outlined"
          title="{{ 'Remove' | translate }}"
        >
          delete
        </span>
      </div>
      }
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$5.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i4$3.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AdditionalHostsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-additional-hosts',
                    template: `
    <div>
      <div class="e11-mb-2">
        <e11-input
          label="{{ 'Additional hosts (These will be other hosts accessible under the same tenant)' | translate }}"
          [loading]="loading"
          [type]="'text'"
          [hasError]="inputControl.invalid"
          [formControl]="inputControl"
          (keydown.enter)="onHostEntered($event)"
        >
          <span *ngIf="inputControl.invalid" class="e11-text-skin-error e11-text-sm">{{ 'Invalid host name' | translate }}</span>
        </e11-input>
      </div>
      @for (host of hosts.controls; track host) {
      <div [ngClass]="{ 'e11-skeleton': loading }" class="e11-flex e11-justify-between e11-text-center e11-p-2 hover:e11-bg-skin-grey/20">
        <p class="e11-mb-0">{{ host.value }}</p>
        <span
          (click)="!loading ? onRemoveHost(host) : undefined"
          [ngClass]="{ 'e11-text-skin-base': loading, 'e11-text-skin-secondary e11-cursor-pointer hover:e11-text-skin-error': !loading }"
          class="material-icons-outlined"
          title="{{ 'Remove' | translate }}"
        >
          delete
        </span>
      </div>
      }
    </div>
  `,
                }]
        }], ctorParameters: () => [{ type: i2$5.FormBuilder }], propDecorators: { loading: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

function bootstrapEditFieldGroups(configs) {
    const { emailLogo, logoImage, logoImageDark, logoImageLight, favIcon, favIconNotification } = TENANT_IMAGES;
    const { themeValues } = configs;
    return e11FormFor()([
        e11FormLayoutInlineGrid([
            e11FieldInputText('name', 'Name', undefined, { validatorOrOpts: [Validators.required] }),
            e11FieldInputText('host', 'Host', undefined, { validatorOrOpts: [Validators.required] }),
            e11FieldInputDynamicComponent('additionalHosts', '', AdditionalHostsComponent, []),
        ], { containerClass: 'e11-grid e11-grid-cols-2 e11-gap-y-0 e11-mb-4' }),
        e11FormLayoutInlineGrid([
            e11FieldInputText('emailCompanyName', 'Email Company Name', undefined, { validatorOrOpts: [Validators.required] }),
            e11FieldInputText('emailPlatformName', 'Email Platform Name', undefined, { validatorOrOpts: [Validators.required] }),
            e11FieldInputText('emailFrom', 'Email From', undefined, { validatorOrOpts: [Validators.required] }),
        ], { containerClass: 'e11-grid e11-grid-cols-2 e11-gap-y-0 e11-mb-4' }),
        e11FormLayoutInlineGrid([
            e11FieldInputFile('emailLogo', 'Email Logo', undefined, {
                extraInputOption: {
                    ...TenantFileInputUtil.getArgsForFileInput(emailLogo, configs),
                    labelTextOptional: '',
                },
            }),
        ], { containerClass: 'e11-flex e11-items-center e11-justify-start e11-border e11-rounded-md e11-p-4 e11-mb-4 e11-w-full md:e11-w-1/2 e11-mb-8' }),
        e11FormLayoutInlineGrid([
            e11FieldInputText('inviteRegistrationPath', 'Registration path', undefined, { validatorOrOpts: [Validators.required] }),
            e11FieldInputText('verifyEmailPath', 'Verify email path', undefined, { validatorOrOpts: [Validators.required] }),
            e11FieldInputText('resetPasswordPath', 'Reset password path', undefined, { validatorOrOpts: [Validators.required] }),
        ]),
        e11FormLayoutInlineGrid([
            e11FieldInputFile('logoImage', 'Logo Url', undefined, {
                extraInputOption: {
                    ...TenantFileInputUtil.getArgsForFileInput(logoImage, configs),
                    labelTextOptional: '',
                },
            }),
            e11FieldInputFile('logoImageDark', 'Logo Url (Dark)', undefined, {
                extraInputOption: {
                    ...TenantFileInputUtil.getArgsForFileInput(logoImageDark, configs),
                    labelTextOptional: '',
                },
            }),
        ], { containerClass: 'e11-grid e11-grid-cols-1 md:e11-grid-cols-2 e11-gap-8 e11-mb-8', fieldsClass: 'e11-border e11-rounded-md e11-p-4' }),
        e11FormLayoutInlineGrid([
            e11FieldInputFile('logoImageLight', 'Logo Url (Light)', undefined, {
                extraInputOption: {
                    ...TenantFileInputUtil.getArgsForFileInput(logoImageLight, configs),
                    labelTextOptional: '',
                },
            }),
            e11FieldInputFile('favIcon', 'Fav Icon', undefined, {
                extraInputOption: {
                    ...TenantFileInputUtil.getArgsForFileInput(favIcon, configs),
                    labelTextOptional: '',
                },
            }),
            e11FieldInputFile('favIconNotification', 'Fav Icon Notification', undefined, {
                extraInputOption: {
                    ...TenantFileInputUtil.getArgsForFileInput(favIconNotification, configs),
                    labelTextOptional: '',
                },
            }),
        ], { containerClass: 'e11-grid e11-grid-cols-1 md:e11-grid-cols-3 e11-gap-8 e11-mb-8', fieldsClass: 'e11-border e11-rounded-md e11-p-4' }),
        e11FormLayoutInlineGrid([
            e11FieldInputText('companyName', 'Company Name', undefined, { validatorOrOpts: [Validators.required] }),
            e11FieldInputText('appName', 'App Name', undefined, { validatorOrOpts: [Validators.required] }),
        ], {
            containerClass: 'e11-border-b e11-border-dashed e11-mb-4',
        }),
        e11FormLayoutInline3Grid([
            e11FieldInputColor('--color-primary', 'Primary color', themeValues?.['--color-primary'] || '#1E5631'),
            e11FieldInputColor('--color-primary-accent', 'Primary accent color', themeValues?.['--color-primary-accent'] || '#2B7C47'),
            e11FieldInputColor('--color-complimentary', 'Complimentary color', themeValues?.['--color-complimentary'] || '#7C2B60'),
            e11FieldInputColor('--color-secondary', 'Secondary color', themeValues?.['--color-secondary'] || '#d3823d'),
            e11FieldInputColor('--color-app-bg', 'App background color', themeValues?.['--color-app-bg'] || '#ffffff'),
            e11FieldInputColor('--color-app-bg-dark', 'Dark app background color', themeValues?.['--color-app-bg-dark'] || '#3F3F46'),
            e11FieldInputColor('--color-app-borders', 'App borders color', themeValues?.['--color-app-borders'] || '#C8C8C8'),
            e11FieldInputColor('--color-info', 'Info color', themeValues?.['--color-info'] || '#033C6D'),
            e11FieldInputColor('--color-success', 'Success color', themeValues?.['--color-success'] || '#1E5631'),
            e11FieldInputColor('--color-alert', 'Alert color', themeValues?.['--color-alert'] || '#FDF873'),
            e11FieldInputColor('--color-warning', 'Warning color', themeValues?.['--color-warning'] || '#d3823d'),
            e11FieldInputColor('--color-danger', 'Danger color', themeValues?.['--color-danger'] || '#a52c13'),
            e11FieldInputColor('--color-error', 'Error color', themeValues?.['--color-error'] || '#a52c13'),
            e11FieldInputColor('--color-text-base', 'Base text color', themeValues?.['--color-text-base'] || '#7e7e7e'),
            e11FieldInputColor('--color-text-dark', 'Dark text color', themeValues?.['--color-text-dark'] || '#333333'),
            e11FieldInputColor('--color-text-light', 'Light text color', themeValues?.['--color-text-light'] || '#A1A1A1'),
            e11FieldInputColor('--color-text-extra-light', 'Extra light text color', themeValues?.['--color-text-extra-light'] || '#E1E1E1'),
            e11FieldInputColor('--color-text-info', 'Info text color', themeValues?.['--color-text-info'] || '#033C6D'),
            e11FieldInputColor('--color-text-success', 'Success text color', themeValues?.['--color-text-success'] || '#1E5631'),
            e11FieldInputColor('--color-text-alert', 'Alert text color', themeValues?.['--color-text-alert'] || '#FDF873'),
            e11FieldInputColor('--color-text-warning', 'Warning text color', themeValues?.['--color-text-warning'] || '#d3823d'),
            e11FieldInputColor('--color-text-danger', 'Danger text color', themeValues?.['--color-text-danger'] || '#a52c13'),
            e11FieldInputColor('--color-text-error', 'Error text color', themeValues?.['--color-text-error'] || '#a52c13'),
        ]),
    ]);
}

function extractBrand({ logoImageUrl, logoImageDarkUrl, logoImageLightUrl, companyName, appName, favIconUrl, favIconNotificationUrl, }) {
    return { logoImageUrl, logoImageDarkUrl, logoImageLightUrl, companyName, appName, favIconUrl, favIconNotificationUrl };
}
function extractNotification({ emailLogoUrl, emailFrom, emailCompanyName, emailPlatformName, inviteRegistrationPath, resetPasswordPath, verifyEmailPath, }) {
    return {
        emailLogoUrl,
        emailFrom,
        emailCompanyName,
        emailPlatformName,
        inviteRegistrationPath,
        resetPasswordPath,
        verifyEmailPath,
    };
}
function extractBusiness({ companyName, phone, address, city, state, zip, countryCode, address2 }) {
    return {
        companyName,
        phone,
        address,
        city,
        state,
        zip,
        countryCode,
        address2,
    };
}
function extractInvite({ firstName, lastName, email }) {
    return { firstName, lastName, email };
}
function extractTheme({ '--color-primary': colorPrimary, '--color-primary-accent': colorPrimaryAccent, '--color-complimentary': colorComplimentary, '--color-secondary': colorSecondary, '--color-app-bg': colorAppBg, '--color-app-bg-dark': colorAppBgDark, '--color-app-borders': colorAppBorders, '--color-info': colorInfo, '--color-success': colorSuccess, '--color-alert': colorAlert, '--color-warning': colorWarning, '--color-danger': colorDanger, '--color-error': colorError, '--color-text-base': colorTextBase, '--color-text-dark': colorTextDark, '--color-text-light': colorTextLight, '--color-text-extra-light': colorTextExtraLight, '--color-text-info': colorTextInfo, '--color-text-success': colorTextSuccess, '--color-text-alert': colorTextAlert, '--color-text-warning': colorTextWarning, '--color-text-danger': colorTextDanger, '--color-text-error': colorTextError, }) {
    return {
        '--color-primary': colorPrimary,
        '--color-primary-accent': colorPrimaryAccent,
        '--color-complimentary': colorComplimentary,
        '--color-secondary': colorSecondary,
        '--color-app-bg': colorAppBg,
        '--color-app-bg-dark': colorAppBgDark,
        '--color-app-borders': colorAppBorders,
        '--color-info': colorInfo,
        '--color-success': colorSuccess,
        '--color-alert': colorAlert,
        '--color-warning': colorWarning,
        '--color-danger': colorDanger,
        '--color-error': colorError,
        '--color-text-base': colorTextBase,
        '--color-text-dark': colorTextDark,
        '--color-text-light': colorTextLight,
        '--color-text-extra-light': colorTextExtraLight,
        '--color-text-info': colorTextInfo,
        '--color-text-success': colorTextSuccess,
        '--color-text-alert': colorTextAlert,
        '--color-text-warning': colorTextWarning,
        '--color-text-danger': colorTextDanger,
        '--color-text-error': colorTextError,
    };
}

class TenantUtils {
    constructor(userConfigProvider) {
        this.userConfigProvider = userConfigProvider;
        this.appUserId$ = this.userConfigProvider.getCurrentUserAppId().pipe(filter(isNotNil), take(1));
    }
    buildProvisionModel(tenantFormResult, config) {
        const brand = this.buildBrand(tenantFormResult, config);
        const invite = extractInvite(tenantFormResult);
        const additionalHosts = tenantFormResult.additionalHosts?.length ? tenantFormResult.additionalHosts : undefined;
        return {
            host: tenantFormResult.host,
            bootstrap: {
                name: tenantFormResult.name,
                theme: extractTheme(tenantFormResult),
                brand,
                notification: extractNotification({
                    ...tenantFormResult,
                    emailLogoUrl: TenantFileInputUtil.getImageUrl({
                        hostName: tenantFormResult.host,
                        fileName: TENANT_IMAGES.emailLogo.fileName,
                        cdnName: config.cdnName,
                    }),
                }),
                basePlatformHost: config.basePlatformHost,
                additionalHosts,
                type: TenantType.Business,
            },
            business: extractBusiness(tenantFormResult),
            invite: invite.email ? { ...invite, additionalRoles: config.additionalTenantCustomerRoles } : undefined,
        };
    }
    editProvisionModel(tenantFormResult, config, tenantModel) {
        const brand = this.buildBrand(tenantFormResult, config);
        const finalEdit = {
            id: tenantModel?.id,
            name: tenantFormResult.name,
            theme: extractTheme(tenantFormResult),
            brand,
            auth: {
                host: tenantFormResult.host,
            },
            notification: {
                ...extractNotification(tenantFormResult),
                emailLogoUrl: TenantFileInputUtil.getImageUrl({
                    hostName: tenantFormResult.host,
                    fileName: TENANT_IMAGES.emailLogo.fileName,
                    cdnName: config.cdnName,
                }),
            },
            customerKey: tenantModel?.customerKey,
            additionalHosts: tenantFormResult.additionalHosts,
        };
        return finalEdit;
    }
    buildBrand(tenantFormResult, config) {
        const { host: hostName, companyName, appName } = tenantFormResult;
        const { cdnName } = config;
        return {
            logoImageUrl: TenantFileInputUtil.getImageUrl({ hostName, fileName: TENANT_IMAGES.logoImage.fileName, cdnName }),
            logoImageDarkUrl: TenantFileInputUtil.getImageUrl({ hostName, fileName: TENANT_IMAGES.logoImageDark.fileName, cdnName }),
            logoImageLightUrl: TenantFileInputUtil.getImageUrl({ hostName, fileName: TENANT_IMAGES.logoImageLight.fileName, cdnName }),
            companyName,
            appName,
            favIconUrl: TenantFileInputUtil.getImageUrl({ hostName, fileName: TENANT_IMAGES.favIcon.fileName, cdnName }),
            favIconNotificationUrl: TenantFileInputUtil.getImageUrl({ hostName, fileName: TENANT_IMAGES.favIconNotification.fileName, cdnName }),
        };
    }
    extractFiles(rawResult) {
        const fileNameMaps = {
            emailLogo: TENANT_IMAGES.emailLogo.fileName,
            favIcon: TENANT_IMAGES.favIcon.fileName,
            favIconNotification: TENANT_IMAGES.favIconNotification.fileName,
            logoImage: TENANT_IMAGES.logoImage.fileName,
            logoImageDark: TENANT_IMAGES.logoImageDark.fileName,
            logoImageLight: TENANT_IMAGES.logoImageLight.fileName,
        };
        const fileFields = pick(rawResult, 'emailLogo', 'favIcon', 'favIconNotification', 'logoImage', 'logoImageDark', 'logoImageLight');
        return Object.entries(fileFields)
            .map(([key, field]) => field?.[0] && this.renameFile(field?.[0], fileNameMaps[key]))
            .filter(isNotNil);
    }
    renameFile(file, newName) {
        return new File([file], newName, { type: file.type });
    }
    prepareTenantFormResult(rawResult) {
        const result = omit(rawResult, 'emailLogo', 'favIcon', 'favIconNotification', 'logoImage', 'logoImageDark', 'logoImageLight');
        return result;
    }
    async uploadTenantAssets(fs, { files, customPath }, notify) {
        const appUserId = await firstValueFrom(this.appUserId$);
        const response = await Promise.all(files.map((file) => fs.uploadFile({
            file,
            makePublic: true,
            customPath,
            appUserId,
        })));
        notify?.popNotification({
            title: 'Images Uploaded',
            message: 'The images have been successfully uploaded. Please allow up to one hour for the uploaded assets to reflect in the tenant.',
            type: 'success',
        });
        return response;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TenantUtils, deps: [{ token: i6.BaseUserConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TenantUtils }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TenantUtils, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i6.BaseUserConfigProvider }] });

class FormProvisionBulkInvitationComponent {
    constructor(logger) {
        this.logger = logger;
        this.loading = false;
        this.submitted = new EventEmitter();
        this.provisionBulkInvitationFields = e11FormFor()([
            e11FormLayoutFullWidth([
                e11FieldInputTextArea('userInformation', 'User Information', undefined, {
                    validatorOrOpts: [bulkUserValidators],
                    extraInputOption: {
                        placeholder: 'John, Doe, john.doe@test.com\nMary, Smith, mary.smith@test.com',
                        tooltipConfig: {
                            tooltipText: 'Users included in this list will be included in the bulk invitation. Use new lines to separate entries.',
                        },
                    },
                }),
            ]),
        ]);
    }
    onSubmit(formData) {
        const formattedForm = transformUserInformation(formData.userInformation);
        this.submitted.emit(formattedForm);
        this.bulkProvisionForm.reset();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormProvisionBulkInvitationComponent, deps: [{ token: i1.E11Logger }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: FormProvisionBulkInvitationComponent, selector: "sdk-provision-bulk-invitation-form", inputs: { loading: "loading" }, outputs: { submitted: "submitted" }, viewQueries: [{ propertyName: "bulkProvisionForm", first: true, predicate: ["bulkProvisionForm"], descendants: true }], ngImport: i0, template: `
    <e11-dynamic-form-builder
      #provisionForm
      [fieldGroups]="provisionBulkInvitationFields"
      [hideSubmitMenu]="true"
      [loading]="loading"
      (onSubmit)="onSubmit($event)"
    ></e11-dynamic-form-builder>
    <e11-button
      id="submit_formProvision"
      value="{{ 'Save' | translate }}"
      [color]="'primary-accent'"
      [type]="'submit'"
      [loading]="loading"
      (click)="!loading && provisionForm.onSubmitClick()"
    >
    </e11-button>
  `, isInline: true, dependencies: [{ kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i3$1.E11DynamicFormBuilderComponent, selector: "e11-dynamic-form-builder", inputs: ["initialValue", "hideSubmitMenu", "loading", "disabled", "disabledText", "submitButtonConfig", "cancelButtonConfig", "deleteButtonConfig", "cancelLinkConfig", "showCancelLink", "showCancelButton", "showDeleteButton", "submitButtonTitle", "cancelLinkTitle", "cancelButtonTitle", "deleteButtonTitle", "buttonColorSubmit", "buttonColorCancel", "buttonColorDelete", "fieldGroups", "errorMessageOverrides"], outputs: ["valueChanges", "onSubmit", "onCancel", "onDelete"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormProvisionBulkInvitationComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-provision-bulk-invitation-form',
                    template: `
    <e11-dynamic-form-builder
      #provisionForm
      [fieldGroups]="provisionBulkInvitationFields"
      [hideSubmitMenu]="true"
      [loading]="loading"
      (onSubmit)="onSubmit($event)"
    ></e11-dynamic-form-builder>
    <e11-button
      id="submit_formProvision"
      value="{{ 'Save' | translate }}"
      [color]="'primary-accent'"
      [type]="'submit'"
      [loading]="loading"
      (click)="!loading && provisionForm.onSubmitClick()"
    >
    </e11-button>
  `,
                }]
        }], ctorParameters: () => [{ type: i1.E11Logger }], propDecorators: { bulkProvisionForm: [{
                type: ViewChild,
                args: ['bulkProvisionForm']
            }], loading: [{
                type: Input
            }], submitted: [{
                type: Output
            }] } });
const bulkUserValidators = (control) => {
    if (!control.value || control.value.trim() === '')
        return null;
    const userInformation = transformUserInformation(control.value);
    for (const user of userInformation) {
        if (!EMAIL_REGEX.test(user.email))
            return { invalidEmail: { value: user.email } };
    }
    return null;
};
const transformUserInformation = (userString) => {
    return userString
        .split('\n')
        .map((infoString) => infoString.trim())
        .filter((infoString) => infoString.length > 0)
        .map((infoString) => {
        const [firstName, lastName, email] = infoString.split(',').map((value) => value.trim());
        return { firstName, lastName, email };
    });
};

class ProvisionEditBootstrapComponent {
    set tenantModel(value) {
        this._tenantModel = value;
        if (!value) {
            this.formattedForm = undefined;
            return;
        }
        this.formattedForm = {
            name: value?.name,
            host: value?.auth?.host,
            additionalHosts: value?.additionalHosts,
            ...value?.notification,
            ...value?.brand,
            ...value?.theme,
        };
        const data = {
            cdnName: this.configProvider.config.cdnName,
            hostName: value.auth.host,
            themeValues: value?.theme,
        };
        this.fieldGroups = bootstrapEditFieldGroups(data);
        this.tenantBootstrapStore.getInvites({ authTenantId: value.auth.tenantId, customerKey: value.customerKey });
    }
    constructor(tenantBootstrapStore, configProvider, directUpload, notificationService, errorHandlerService, tenantUtils, logger) {
        this.tenantBootstrapStore = tenantBootstrapStore;
        this.configProvider = configProvider;
        this.directUpload = directUpload;
        this.notificationService = notificationService;
        this.errorHandlerService = errorHandlerService;
        this.tenantUtils = tenantUtils;
        this.logger = logger;
        this.saved = new EventEmitter();
        this.loading$ = this.tenantBootstrapStore.loading$;
        this.invites$ = this.tenantBootstrapStore.tenantInvites$;
        this.invitesLoading$ = this.tenantBootstrapStore.invitesLoading$;
        this.loading = false;
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        this.loading$.pipe(takeUntil(this.destroy$)).subscribe((loading) => (this.loading = loading));
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    async onSubmit(rawTenantFormResult) {
        const customPath = `bootstrap/${rawTenantFormResult.host}`;
        const files = this.tenantUtils.extractFiles(rawTenantFormResult);
        /**
         * NOTE: this is here until we have an upload but even when so, we will want the
         * URLs to be the consistent naming pattern below (e.g) logoImageUrl is always logo.png
         */
        const tenantFormResult = this.tenantUtils.prepareTenantFormResult(rawTenantFormResult);
        const finalEdit = this.tenantUtils.editProvisionModel(tenantFormResult, this.configProvider.config, this._tenantModel);
        try {
            this.loading = true;
            await this.tenantUtils.uploadTenantAssets(this.directUpload, { files, customPath }, this.notificationService);
            this.tenantBootstrapStore.updateBusinessTenant(finalEdit);
            this.saved.emit();
        }
        catch (error) {
            this.errorHandlerService.handleError(error, { alertUser: true });
        }
        finally {
            this.loading = false;
        }
    }
    save() {
        this.dynamicMainForm.onSubmitClick();
    }
    inviteNewUser(invite) {
        if (!this._tenantModel || !this._tenantModel.customerKey) {
            return;
        }
        const updatedInvite = { ...invite, additionalRoles: this.configProvider.config.additionalTenantCustomerRoles };
        this.tenantBootstrapStore.addInvite({
            ...updatedInvite,
            authTenantId: this._tenantModel.auth.tenantId,
            customerKey: this._tenantModel.customerKey,
        });
        this.modalInviteUser?.close();
    }
    bulkInviteUsers(invites) {
        if (!this._tenantModel || !this._tenantModel.customerKey) {
            return;
        }
        const updatedInvites = { invites, additionalRoles: this.configProvider.config.additionalTenantCustomerRoles };
        this.tenantBootstrapStore.addBulkInvite({
            ...updatedInvites,
            authTenantId: this._tenantModel.auth.tenantId,
            customerKey: this._tenantModel.customerKey,
        });
        this.modalBulkInvite?.close();
    }
    resendInvitation(invitation) {
        if (!this._tenantModel)
            return;
        this.logger.log('resend', invitation);
        this.tenantBootstrapStore.resendInvite({
            authTenantId: this._tenantModel.auth.tenantId,
            customerKey: invitation.customerKey,
            email: invitation.email,
        });
    }
    deleteInvitation(invitation) {
        this.logger.log('delete', invitation);
        this.tenantBootstrapStore.deleteInvite({ id: invitation.id, authTenantId: this._tenantModel.auth.tenantId });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ProvisionEditBootstrapComponent, deps: [{ token: TenantBootstrapStore }, { token: BaseRegistrationConfigProvider }, { token: i6$3.DirectUploadService }, { token: i4$1.NotificationHelper }, { token: i1.E11ErrorHandlerService }, { token: TenantUtils }, { token: i1.E11Logger }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ProvisionEditBootstrapComponent, selector: "sdk-provision-edit-bootstrap", inputs: { tenantModel: "tenantModel" }, outputs: { saved: "saved" }, viewQueries: [{ propertyName: "dynamicMainForm", first: true, predicate: ["dynamicMainForm"], descendants: true }, { propertyName: "modalInviteUser", first: true, predicate: ["modalInviteUser"], descendants: true }, { propertyName: "modalBulkInvite", first: true, predicate: ["modalBulkInvite"], descendants: true }], ngImport: i0, template: `
    <e11-dynamic-form-builder
      #dynamicMainForm
      [initialValue]="formattedForm"
      [fieldGroups]="fieldGroups"
      [hideSubmitMenu]="true"
      [loading]="loading"
      (onSubmit)="onSubmit($event)"
    >
    </e11-dynamic-form-builder>

    <div class="e11-w-full e11-flex e11-items-center">
      <div class="e11-grow">
        <h3>{{ 'Invited Users' }}</h3>
        <p class="e11-text-sm e11-pr-6">
          {{
            'The invitations here are emailed to the email address you provide which then allows those recipients to complete the registration process and use this application.'
          }}
        </p>
      </div>
      <div class="e11-flex e11-justify-end">
        <e11-button
          [size]="'sm'"
          [value]="'Invite User' | translate"
          [color]="'primary-accent'"
          (click)="modalInviteUser.open()"
          class="e11-mr-2"
        ></e11-button>
        <e11-button
          [icon]="'group'"
          [iconPosition]="'left'"
          [size]="'sm'"
          [value]="'Bulk Invite' | translate"
          [color]="'primary-accent'"
          (click)="modalBulkInvite.open()"
        ></e11-button>
      </div>
    </div>

    <ui-invited-user-list
      [invitedUsers]="(invites$ | async) ?? undefined"
      [loading]="(invitesLoading$ | async) ?? false"
      (resend)="resendInvitation($event)"
      (delete)="deleteInvitation($event)"
    ></ui-invited-user-list>
    <e11-modal #modalInviteUser title="{{ 'Invite New User' | translate }}" [showHeader]="true" [showFooter]="false">
      <ng-template e11Template="Body">
        <sdk-provision-invitation-form
          [loading]="(invitesLoading$ | async) ?? false"
          (submitted)="inviteNewUser($event)"
        ></sdk-provision-invitation-form>
      </ng-template>
    </e11-modal>
    <e11-modal #modalBulkInvite title="{{ 'Bulk Invite' | translate }}" [showHeader]="true" [showFooter]="false">
      <ng-template e11Template="Body">
        <sdk-provision-bulk-invitation-form
          [loading]="(invitesLoading$ | async) ?? false"
          (submitted)="bulkInviteUsers($event)"
        ></sdk-provision-bulk-invitation-form>
      </ng-template>
    </e11-modal>
  `, isInline: true, dependencies: [{ kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "directive", type: i8.E11Template, selector: "[e11Template]", inputs: ["type", "e11Template"] }, { kind: "component", type: i1$1.E11ModalComponent, selector: "e11-modal", inputs: ["title", "width", "bodyHeight", "titleAlign", "hideCloseButton", "closer", "bodyClassOverrides", "bodyClass", "modalClassOverrides", "modalClass", "contentClassOverrides", "contentClass", "headerClassOverrides", "headerClass", "footerClassOverrides", "footerClass", "showFooter", "showHeader", "darkMode", "closeOnEscape", "closeOnClickOutside", "headerCTAs", "hasBackdrop", "backdropStyle"], outputs: ["modalOpened", "onModalOpened", "modalClosed", "onModalClosed", "headerCTAClicked", "onHeaderCTAClicked"] }, { kind: "component", type: i3$1.E11DynamicFormBuilderComponent, selector: "e11-dynamic-form-builder", inputs: ["initialValue", "hideSubmitMenu", "loading", "disabled", "disabledText", "submitButtonConfig", "cancelButtonConfig", "deleteButtonConfig", "cancelLinkConfig", "showCancelLink", "showCancelButton", "showDeleteButton", "submitButtonTitle", "cancelLinkTitle", "cancelButtonTitle", "deleteButtonTitle", "buttonColorSubmit", "buttonColorCancel", "buttonColorDelete", "fieldGroups", "errorMessageOverrides"], outputs: ["valueChanges", "onSubmit", "onCancel", "onDelete"] }, { kind: "component", type: FormProvisionInvitationComponent, selector: "sdk-provision-invitation-form", inputs: ["loading"], outputs: ["submitted"] }, { kind: "component", type: FormProvisionBulkInvitationComponent, selector: "sdk-provision-bulk-invitation-form", inputs: ["loading"], outputs: ["submitted"] }, { kind: "component", type: UIInvitedListComponent, selector: "ui-invited-user-list", inputs: ["invitedUsers", "loading", "allowDelete", "allowResend"], outputs: ["resend", "delete"] }, { kind: "pipe", type: i2.AsyncPipe, name: "async" }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ProvisionEditBootstrapComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-provision-edit-bootstrap',
                    template: `
    <e11-dynamic-form-builder
      #dynamicMainForm
      [initialValue]="formattedForm"
      [fieldGroups]="fieldGroups"
      [hideSubmitMenu]="true"
      [loading]="loading"
      (onSubmit)="onSubmit($event)"
    >
    </e11-dynamic-form-builder>

    <div class="e11-w-full e11-flex e11-items-center">
      <div class="e11-grow">
        <h3>{{ 'Invited Users' }}</h3>
        <p class="e11-text-sm e11-pr-6">
          {{
            'The invitations here are emailed to the email address you provide which then allows those recipients to complete the registration process and use this application.'
          }}
        </p>
      </div>
      <div class="e11-flex e11-justify-end">
        <e11-button
          [size]="'sm'"
          [value]="'Invite User' | translate"
          [color]="'primary-accent'"
          (click)="modalInviteUser.open()"
          class="e11-mr-2"
        ></e11-button>
        <e11-button
          [icon]="'group'"
          [iconPosition]="'left'"
          [size]="'sm'"
          [value]="'Bulk Invite' | translate"
          [color]="'primary-accent'"
          (click)="modalBulkInvite.open()"
        ></e11-button>
      </div>
    </div>

    <ui-invited-user-list
      [invitedUsers]="(invites$ | async) ?? undefined"
      [loading]="(invitesLoading$ | async) ?? false"
      (resend)="resendInvitation($event)"
      (delete)="deleteInvitation($event)"
    ></ui-invited-user-list>
    <e11-modal #modalInviteUser title="{{ 'Invite New User' | translate }}" [showHeader]="true" [showFooter]="false">
      <ng-template e11Template="Body">
        <sdk-provision-invitation-form
          [loading]="(invitesLoading$ | async) ?? false"
          (submitted)="inviteNewUser($event)"
        ></sdk-provision-invitation-form>
      </ng-template>
    </e11-modal>
    <e11-modal #modalBulkInvite title="{{ 'Bulk Invite' | translate }}" [showHeader]="true" [showFooter]="false">
      <ng-template e11Template="Body">
        <sdk-provision-bulk-invitation-form
          [loading]="(invitesLoading$ | async) ?? false"
          (submitted)="bulkInviteUsers($event)"
        ></sdk-provision-bulk-invitation-form>
      </ng-template>
    </e11-modal>
  `,
                }]
        }], ctorParameters: () => [{ type: TenantBootstrapStore }, { type: BaseRegistrationConfigProvider }, { type: i6$3.DirectUploadService }, { type: i4$1.NotificationHelper }, { type: i1.E11ErrorHandlerService }, { type: TenantUtils }, { type: i1.E11Logger }], propDecorators: { dynamicMainForm: [{
                type: ViewChild,
                args: ['dynamicMainForm']
            }], modalInviteUser: [{
                type: ViewChild,
                args: ['modalInviteUser']
            }], modalBulkInvite: [{
                type: ViewChild,
                args: ['modalBulkInvite']
            }], tenantModel: [{
                type: Input
            }], saved: [{
                type: Output
            }] } });

class ProvisionedCustomerBootstrapComponent {
    set customerKey(customerKey) {
        this.tenantBootstrapStore.getSelectBootstrap(customerKey);
    }
    constructor(tenantBootstrapStore) {
        this.tenantBootstrapStore = tenantBootstrapStore;
        this.selectedTenant$ = this.tenantBootstrapStore.selectedBootstrap$;
    }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ProvisionedCustomerBootstrapComponent, deps: [{ token: TenantBootstrapStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ProvisionedCustomerBootstrapComponent, selector: "sdk-provisioned-customer-bootstrap", inputs: { customerKey: "customerKey" }, ngImport: i0, template: `
    <ng-container *ngrxLet="selectedTenant$ as bootstrap; suspenseTpl: loading">
      <sdk-provision-edit-bootstrap #edit [tenantModel]="bootstrap"></sdk-provision-edit-bootstrap>
      <div class="e11-w-full e11-text-right">
        <e11-button [value]="'Save'" [buttonGroup]="true" (click)="edit.save()"></e11-button>
      </div>
    </ng-container>

    <ng-template #loading>
      <e11-loader-dots [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i2$4.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "directive", type: i4.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: ProvisionEditBootstrapComponent, selector: "sdk-provision-edit-bootstrap", inputs: ["tenantModel"], outputs: ["saved"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ProvisionedCustomerBootstrapComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-provisioned-customer-bootstrap',
                    template: `
    <ng-container *ngrxLet="selectedTenant$ as bootstrap; suspenseTpl: loading">
      <sdk-provision-edit-bootstrap #edit [tenantModel]="bootstrap"></sdk-provision-edit-bootstrap>
      <div class="e11-w-full e11-text-right">
        <e11-button [value]="'Save'" [buttonGroup]="true" (click)="edit.save()"></e11-button>
      </div>
    </ng-container>

    <ng-template #loading>
      <e11-loader-dots [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-template>
  `,
                }]
        }], ctorParameters: () => [{ type: TenantBootstrapStore }], propDecorators: { customerKey: [{
                type: Input
            }] } });

class FormCustomValidationService extends E11FormValidationService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormCustomValidationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormCustomValidationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormCustomValidationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/**
 * TODO:
 * 1. Support provisioning a regular business account - not a client, needing the full information
 * 2. Support provisioning a client account, needing only the firstName, lastName, and email. Provide this via a modal?
 * 3. Refactor all models to include only what is needed
 */
class FormCustomerProvisionComponent {
    set provisionForm(form) {
        this._provisionForm = form;
        this.addressFormService.init(this._provisionForm);
    }
    get provisionForm() {
        return this._provisionForm;
    }
    constructor(customValidator, logger, addressFormService) {
        this.customValidator = customValidator;
        this.logger = logger;
        this.addressFormService = addressFormService;
        this.provisionBusinessGroups = e11FormFor()([
            e11FormLayoutInlineGrid([
                e11FieldInputText('firstName', 'First Name', undefined, { validatorOrOpts: [Validators.required, this.customValidator.whitespaceValidator()] }),
                e11FieldInputText('lastName', 'Last Name', undefined, { validatorOrOpts: [Validators.required, this.customValidator.whitespaceValidator()] }),
            ]),
            e11FormLayoutInlineGrid([
                e11FieldInputText('email', 'Email', undefined, { validatorOrOpts: [Validators.required, this.customValidator.emailValidator()] }),
                e11FieldInputPhone('phone', 'Primary Phone', undefined, { validatorOrOpts: [Validators.required, this.customValidator.whitespaceValidator()] }),
            ]),
            e11FormLayoutInlineGrid([
                e11FieldInputText('companyName', 'Company Name', undefined, {
                    validatorOrOpts: [Validators.required, this.customValidator.whitespaceValidator()],
                }),
            ]),
            ...this.addressFormService.formGroup({
                validators: {
                    address: [Validators.required, this.customValidator.whitespaceValidator()],
                    city: [Validators.required, this.customValidator.whitespaceValidator()],
                    state: [Validators.required],
                    zip: [Validators.required],
                },
            }),
        ]);
        this.submitted = new EventEmitter();
        this.loading = false; // TODO: Consider wiring up loading
    }
    reset() {
        this.provisionForm.reset();
    }
    onSubmit(formData) {
        const provisionData = { ...this.provisionBusinessData, ...formData };
        this.logger.log({ provisionData });
        this.submitted.emit(provisionData);
    }
    ngOnDestroy() {
        this.addressFormService.ngOnDestroy();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormCustomerProvisionComponent, deps: [{ token: FormCustomValidationService }, { token: i1.E11Logger }, { token: i3$3.AddressFormService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: FormCustomerProvisionComponent, selector: "sdk-provision-form-customer", inputs: { provisionBusinessData: "provisionBusinessData" }, outputs: { submitted: "submitted" }, providers: [AddressFormService], viewQueries: [{ propertyName: "provisionForm", first: true, predicate: ["provisionForm"], descendants: true }], ngImport: i0, template: `
    <e11-dynamic-form-builder
      #provisionForm
      [initialValue]="provisionBusinessData"
      [fieldGroups]="provisionBusinessGroups"
      [hideSubmitMenu]="true"
      [loading]="loading"
      (onSubmit)="onSubmit($event)"
    ></e11-dynamic-form-builder>
    <e11-button
      id="submit_formProvision"
      value="{{ 'Save' | translate }}"
      [color]="'primary-accent'"
      [type]="'submit'"
      [loading]="loading"
      (click)="!loading && provisionForm.onSubmitClick()"
    >
    </e11-button>
  `, isInline: true, dependencies: [{ kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i3$1.E11DynamicFormBuilderComponent, selector: "e11-dynamic-form-builder", inputs: ["initialValue", "hideSubmitMenu", "loading", "disabled", "disabledText", "submitButtonConfig", "cancelButtonConfig", "deleteButtonConfig", "cancelLinkConfig", "showCancelLink", "showCancelButton", "showDeleteButton", "submitButtonTitle", "cancelLinkTitle", "cancelButtonTitle", "deleteButtonTitle", "buttonColorSubmit", "buttonColorCancel", "buttonColorDelete", "fieldGroups", "errorMessageOverrides"], outputs: ["valueChanges", "onSubmit", "onCancel", "onDelete"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormCustomerProvisionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-provision-form-customer',
                    providers: [AddressFormService],
                    template: `
    <e11-dynamic-form-builder
      #provisionForm
      [initialValue]="provisionBusinessData"
      [fieldGroups]="provisionBusinessGroups"
      [hideSubmitMenu]="true"
      [loading]="loading"
      (onSubmit)="onSubmit($event)"
    ></e11-dynamic-form-builder>
    <e11-button
      id="submit_formProvision"
      value="{{ 'Save' | translate }}"
      [color]="'primary-accent'"
      [type]="'submit'"
      [loading]="loading"
      (click)="!loading && provisionForm.onSubmitClick()"
    >
    </e11-button>
  `,
                }]
        }], ctorParameters: () => [{ type: FormCustomValidationService }, { type: i1.E11Logger }, { type: i3$3.AddressFormService }], propDecorators: { provisionForm: [{
                type: ViewChild,
                args: ['provisionForm']
            }], provisionBusinessData: [{
                type: Input
            }], submitted: [{
                type: Output
            }] } });

/**
 * TODO: Externalize this
 */
const NOTIFICATION_DEFAULTS = {
    inviteRegistrationPath: '/#/registration/register-invite',
    verifyEmailPath: '/#/actions/verify-email',
    resetPasswordPath: '/#/actions/reset-password',
};

var KnownEnvironment;
(function (KnownEnvironment) {
    KnownEnvironment["Dev"] = "dev";
    KnownEnvironment["Qa"] = "qa";
    KnownEnvironment["Ci"] = "ci";
    KnownEnvironment["Demo"] = "demo";
    KnownEnvironment["Staging"] = "staging";
    KnownEnvironment["Test"] = "test";
    KnownEnvironment["Production"] = "production";
})(KnownEnvironment || (KnownEnvironment = {}));
var DetectionMethod;
(function (DetectionMethod) {
    DetectionMethod["ExplicitConfig"] = "explicit config";
    DetectionMethod["DomainExtraction"] = "domain extraction";
    DetectionMethod["LocationDetection"] = "location detection";
})(DetectionMethod || (DetectionMethod = {}));
var ConfigSource;
(function (ConfigSource) {
    ConfigSource["TenantConfig"] = "tenant config";
    ConfigSource["BasePlatformHost"] = "basePlatformHost";
})(ConfigSource || (ConfigSource = {}));
class TenantDomainConfigService {
    constructor(injector) {
        this.injector = injector;
        this.domainConfig = this.initializeDomainConfig();
    }
    initializeDomainConfig() {
        const baseDomain = this.extractBaseDomain();
        const environmentPrefix = this.getEnvironmentPrefix();
        return {
            baseDomain,
            environmentPrefix,
            supportedTlds: ['com', 'app', 'io', 'co', 'net'],
        };
    }
    extractBaseDomain() {
        // Try tenant bootstrap config first
        const tenantDomain = this.getTenantBootstrapDomain();
        if (tenantDomain)
            return tenantDomain;
        // Final fallback
        return 'cnected';
    }
    getTenantBootstrapDomain() {
        try {
            const config = this.injector.get(BaseTenantBootstrapConfigProvider, null);
            const defaultTenant = config?.config?.defaultTenant;
            if (!defaultTenant)
                return null;
            return this.extractDomainFromHost(defaultTenant);
        }
        catch {
            return null;
        }
    }
    extractDomainFromHost(host) {
        if (!host)
            return null;
        const platformHost = this.extractPlatformFromHost(host);
        const parts = platformHost.split('.');
        return parts.length >= 1 ? parts[0] : null;
    }
    hasSubdomain(host) {
        return host.split('.').length > 2;
    }
    extractPlatformFromHost(host) {
        const withoutEnv = this.removeEnvironmentPrefix(host);
        const parts = withoutEnv.split('.');
        return parts.length >= 2 ? parts.slice(1).join('.') : host;
    }
    getEnvironmentPrefix() {
        // Try tenant bootstrap config first
        const tenantEnv = this.getTenantBootstrapEnvironment();
        if (tenantEnv)
            return tenantEnv;
        // Final fallback: detect from browser location
        return this.detectEnvironmentFromLocation();
    }
    getTenantBootstrapEnvironment() {
        try {
            const config = this.injector.get(BaseTenantBootstrapConfigProvider, null);
            const defaultTenant = config?.config?.defaultTenant;
            if (!defaultTenant)
                return '';
            return this.extractEnvironmentFromDomain(defaultTenant);
        }
        catch {
            return '';
        }
    }
    extractEnvironmentFromDomain(domain) {
        if (!domain)
            return '';
        const parts = domain.split('.');
        const env = parts[0].toLowerCase();
        return Object.values(KnownEnvironment).includes(env) ? env : '';
    }
    matchesEnv(hostname, env) {
        return hostname.includes(`${env}.`) || hostname.includes(`-${env}.`) || hostname.includes(`${env}-`);
    }
    detectEnvironmentFromLocation() {
        if (typeof window === 'undefined' || !window.location)
            return '';
        const hostname = window.location.hostname.toLowerCase();
        if (hostname === 'localhost' || hostname.startsWith('127.0.0.1'))
            return KnownEnvironment.Dev;
        if (this.matchesEnv(hostname, 'dev'))
            return KnownEnvironment.Dev;
        if (this.matchesEnv(hostname, 'qa'))
            return KnownEnvironment.Qa;
        if (this.matchesEnv(hostname, 'ci'))
            return KnownEnvironment.Ci;
        if (this.matchesEnv(hostname, 'demo'))
            return KnownEnvironment.Demo;
        if (this.matchesEnv(hostname, 'staging'))
            return KnownEnvironment.Staging;
        return '';
    }
    removeEnvironmentPrefix(host) {
        const envPrefixes = ['dev-', 'qa-', 'ci-', 'demo-', 'staging-', 'stage-'];
        for (const prefix of envPrefixes) {
            if (host.startsWith(prefix)) {
                return host.substring(prefix.length);
            }
        }
        const parts = host.split('.');
        const firstPart = parts[0].toLowerCase();
        return Object.values(KnownEnvironment).includes(firstPart) ? parts.slice(1).join('.') : host;
    }
    getBaseDomain() {
        return this.domainConfig.baseDomain;
    }
    getEnvPrefix() {
        return this.domainConfig.environmentPrefix ? `${this.domainConfig.environmentPrefix}.` : '';
    }
    getEnvironmentAwareDomainSuffix() {
        return `${this.getEnvPrefix()}${this.getBaseDomain()}`;
    }
    getFullDomainTemplate() {
        return `{prefix}.${this.getEnvironmentAwareDomainSuffix()}`;
    }
    buildFullHost(subdomain) {
        const cleanSubdomain = subdomain.toLowerCase().trim();
        return `${cleanSubdomain}.${this.getEnvironmentAwareDomainSuffix()}`;
    }
    isValidSubdomain(subdomain) {
        if (!subdomain || subdomain.length < 2 || subdomain.length > 63)
            return false;
        const subdomainRegex = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/;
        return subdomainRegex.test(subdomain);
    }
    getSupportedTlds() {
        return this.domainConfig.supportedTlds;
    }
    getEnvironmentInfo() {
        return {
            env: this.domainConfig.environmentPrefix || KnownEnvironment.Production,
            prefix: this.domainConfig.environmentPrefix || 'none',
            baseDomain: this.domainConfig.baseDomain,
            fullSuffix: this.getEnvironmentAwareDomainSuffix(),
            detectionMethod: DetectionMethod.LocationDetection,
            configSource: ConfigSource.TenantConfig,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TenantDomainConfigService, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TenantDomainConfigService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TenantDomainConfigService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i0.Injector }] });

class SubdomainFieldComponent {
    constructor(domainService) {
        this.domainService = domainService;
        this.hostPrefixControl = new FormControl('', [
            Validators.required,
            Validators.pattern(/^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/),
            Validators.minLength(2),
            Validators.maxLength(63),
        ]);
        this.tldControl = new FormControl('', [Validators.required]);
        this.loading = false;
        this.value = '';
        this.environmentBaseDomain = '';
        this.tldOptions = [];
        this.onChange = () => { };
        this.onTouched = () => { };
        this.subscriptions = [];
    }
    ngOnInit() {
        this.initializeDomainConfig();
        this.setupTldOptions();
        this.parseInitialValue();
        const hostPrefixSub = this.hostPrefixControl.valueChanges.subscribe(() => {
            this.updateFullHost();
        });
        const tldSub = this.tldControl.valueChanges.subscribe(() => {
            this.updateFullHost();
        });
        this.subscriptions.push(hostPrefixSub, tldSub);
    }
    ngOnDestroy() {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
    initializeDomainConfig() {
        // Get the environment-aware domain suffix and remove the TLD
        const fullSuffix = this.domainService.getEnvironmentAwareDomainSuffix();
        this.environmentBaseDomain = this.removeTopLevelDomain(fullSuffix);
    }
    setupTldOptions() {
        const supportedTlds = this.domainService.getSupportedTlds();
        this.tldOptions = supportedTlds.map((tld) => ({
            name: tld,
            value: tld,
        }));
        // Set default TLD if none selected
        if (!this.tldControl.value && this.tldOptions.length > 0) {
            this.tldControl.setValue(this.tldOptions[0].value, { emitEvent: false });
        }
    }
    parseInitialValue() {
        if (this.value) {
            const parsed = this.parseHostValue(this.value);
            if (parsed) {
                this.hostPrefixControl.setValue(parsed.hostPrefix, { emitEvent: false });
                this.tldControl.setValue(parsed.tld, { emitEvent: false });
            }
        }
    }
    parseHostValue(fullHost) {
        if (!fullHost)
            return null;
        // Remove the environment and base domain to get prefix and TLD
        const envBaseDomainWithDot = `.${this.environmentBaseDomain}.`;
        const hostWithoutEnvBase = fullHost.replace(envBaseDomainWithDot, '.');
        const parts = hostWithoutEnvBase.split('.');
        if (parts.length >= 2) {
            const hostPrefix = parts[0];
            const tld = parts[parts.length - 1];
            return { hostPrefix, tld };
        }
        return null;
    }
    removeTopLevelDomain(domain) {
        const supportedTlds = this.domainService.getSupportedTlds();
        for (const tld of supportedTlds) {
            if (domain.endsWith(`.${tld}`)) {
                return domain.substring(0, domain.length - tld.length - 1);
            }
        }
        return domain;
    }
    updateFullHost() {
        const hostPrefix = this.hostPrefixControl.value?.trim();
        const tld = this.tldControl.value;
        if (hostPrefix && tld) {
            const fullHost = `${hostPrefix}.${this.environmentBaseDomain}.${tld}`;
            this.onChange(fullHost);
        }
        else {
            this.onChange('');
        }
    }
    getFullHostPreview() {
        const hostPrefix = this.hostPrefixControl.value?.trim() || '[prefix]';
        const tld = this.tldControl.value || '[tld]';
        return `${hostPrefix}.${this.environmentBaseDomain}.${tld}`;
    }
    hasValidationErrors() {
        return (this.hostPrefixControl.invalid && this.hostPrefixControl.touched) || (this.tldControl.invalid && this.tldControl.touched);
    }
    getHostPrefixErrorMessage() {
        const control = this.hostPrefixControl;
        if (control.hasError('required')) {
            return 'Host prefix is required';
        }
        if (control.hasError('pattern')) {
            return 'Host prefix can only contain letters, numbers, and hyphens';
        }
        if (control.hasError('minlength')) {
            return 'Host prefix must be at least 2 characters';
        }
        if (control.hasError('maxlength')) {
            return 'Host prefix cannot exceed 63 characters';
        }
        return 'Invalid host prefix';
    }
    getValidationErrorMessage() {
        if (this.hostPrefixControl.invalid && this.hostPrefixControl.touched) {
            return this.getHostPrefixErrorMessage();
        }
        if (this.tldControl.invalid && this.tldControl.touched) {
            return 'Please select a valid TLD';
        }
        return '';
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    writeValue(value) {
        this.value = value || '';
        this.parseInitialValue();
    }
    setDisabledState(disabled) {
        if (disabled) {
            this.hostPrefixControl.disable();
            this.tldControl.disable();
        }
        else {
            this.hostPrefixControl.enable();
            this.tldControl.enable();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SubdomainFieldComponent, deps: [{ token: TenantDomainConfigService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: SubdomainFieldComponent, selector: "sdk-subdomain-field", inputs: { loading: "loading", value: "value" }, ngImport: i0, template: `
    <div class="e11-flex e11-flex-row">
      <e11-input
        class="e11-w-2/5 sm:e11-w-full e11-border-transparent e11-p-0"
        label="{{ 'Host (tenantname.platform.com)' | translate }}"
        type="text"
        [required]="true"
        [formControl]="hostPrefixControl"
        [loading]="loading"
        [hasError]="hostPrefixControl.invalid && hostPrefixControl.touched"
      >
        <span *ngIf="hostPrefixControl.invalid && hostPrefixControl.touched" class="e11-text-skin-error e11-text-sm">
          {{ getHostPrefixErrorMessage() }}
        </span>
      </e11-input>

      <div class="e11-flex e11-items-end">
        <span class="e11-text-skin-dark e11-whitespace-nowrap e11-px-1 e11-py-2"> .{{ environmentBaseDomain }}. </span>
      </div>

      <div class="e11-w-40 e11-flex e11-items-end">
        <e11-select
          [options]="tldOptions"
          [formControl]="tldControl"
          [required]="true"
          [loading]="loading"
          [hasError]="tldControl.invalid && tldControl.touched"
          selectMessage="TLD"
          label="&nbsp;"
        >
        </e11-select>
      </div>
    </div>

    <div *ngIf="hasValidationErrors()" class="e11-text-skin-error e11-text-sm e11-mt-1">
      {{ getValidationErrorMessage() }}
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$5.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2$5.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i4$3.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i7.E11SelectComponent, selector: "e11-select", inputs: ["id", "name", "label", "size", "selectMessage", "labelClass", "inputClass", "containerClass", "parentForm", "formControlName", "options", "value", "hasError", "required", "disabled", "loading", "tooltipConfig", "labelTextOptional", "selectClass"], outputs: ["valueChange", "onValueChange"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SubdomainFieldComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-subdomain-field',
                    template: `
    <div class="e11-flex e11-flex-row">
      <e11-input
        class="e11-w-2/5 sm:e11-w-full e11-border-transparent e11-p-0"
        label="{{ 'Host (tenantname.platform.com)' | translate }}"
        type="text"
        [required]="true"
        [formControl]="hostPrefixControl"
        [loading]="loading"
        [hasError]="hostPrefixControl.invalid && hostPrefixControl.touched"
      >
        <span *ngIf="hostPrefixControl.invalid && hostPrefixControl.touched" class="e11-text-skin-error e11-text-sm">
          {{ getHostPrefixErrorMessage() }}
        </span>
      </e11-input>

      <div class="e11-flex e11-items-end">
        <span class="e11-text-skin-dark e11-whitespace-nowrap e11-px-1 e11-py-2"> .{{ environmentBaseDomain }}. </span>
      </div>

      <div class="e11-w-40 e11-flex e11-items-end">
        <e11-select
          [options]="tldOptions"
          [formControl]="tldControl"
          [required]="true"
          [loading]="loading"
          [hasError]="tldControl.invalid && tldControl.touched"
          selectMessage="TLD"
          label="&nbsp;"
        >
        </e11-select>
      </div>
    </div>

    <div *ngIf="hasValidationErrors()" class="e11-text-skin-error e11-text-sm e11-mt-1">
      {{ getValidationErrorMessage() }}
    </div>
  `,
                }]
        }], ctorParameters: () => [{ type: TenantDomainConfigService }], propDecorators: { loading: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

const tenantTemplateKeys = {
    companyInfo: 'companyInfo',
    tenantConfig: 'tenantInfo',
    emailConfig: 'emailConfig',
    invitee: 'invitee',
    tenantTheme: 'tenantTheme',
};
function provisionFormFieldGroups(args, tenantType) {
    const { emailLogo, logoImage, logoImageDark, logoImageLight, favIcon, favIconNotification } = TENANT_IMAGES;
    if (tenantType === TenantType.Consumer) {
        const { defaultEmailDomain, defaultNotificationPaths } = args;
        return e11FormFor()([
            companyInfoForm(),
            brandForm({ favIcon, favIconNotification, logoImage, logoImageDark, logoImageLight }),
            notificationForm({ emailLogo, defaultEmailDomain, defaultNotificationPaths }),
            themeForm(),
        ]);
    }
    else {
        const { addressFormService, defaultEmailDomain, defaultNotificationPaths } = args;
        return e11FormFor()([
            companyInfoForm(),
            ...addressFormService.formGroup({
                validators: {
                    address: [Validators.required],
                    city: [Validators.required],
                    state: [Validators.required],
                    zip: [Validators.required],
                },
            }),
            invitationForm(),
            brandForm({ favIcon, favIconNotification, logoImage, logoImageDark, logoImageLight }),
            notificationForm({ emailLogo, defaultEmailDomain, defaultNotificationPaths }),
            themeForm(),
        ]);
    }
}
function companyInfoForm() {
    return e11FormLayoutInline3Grid([
        e11FieldInputText('companyName', 'Company Name', undefined, {
            validatorOrOpts: [Validators.required, Validators.minLength(2), Validators.maxLength(100)],
        }),
        e11FieldInputPhone('phone', ' Phone', undefined, { validatorOrOpts: [Validators.required] }),
    ], { templateSpec: { templateKey: tenantTemplateKeys.companyInfo } });
}
function invitationForm() {
    return e11FormLayoutInline3Grid([
        e11FieldInputText('firstName', 'First Name', undefined, { validatorOrOpts: [] }),
        e11FieldInputText('lastName', 'Last Name', undefined, { validatorOrOpts: [] }),
        e11FieldInputText('email', ' Email', undefined, { validatorOrOpts: [E11FormValidator.emailValidator()] }),
    ], {
        containerClass: 'e11-flex-wrap e11-mb-4',
        templateSpec: { templateKey: tenantTemplateKeys.invitee },
    });
}
function brandForm({ favIcon, favIconNotification, logoImage, logoImageDark, logoImageLight, }) {
    return e11LayoutGroup([
        e11FormLayoutInlineGrid([
            e11FieldInputText('name', 'Tenant Name', undefined, {
                validatorOrOpts: [Validators.required, Validators.minLength(2), Validators.maxLength(24)],
            }),
            e11FieldInputDynamicComponent('host', 'Tenant Host', SubdomainFieldComponent, '', {
                validatorOrOpts: [Validators.required, Validators.maxLength(253)],
            }),
            e11FieldInputDynamicComponent('additionalHosts', '', AdditionalHostsComponent, []),
            e11FieldInputText('appName', 'App Name (This value will be the app title and show up on the browser tab)', undefined, {
                validatorOrOpts: [Validators.required, Validators.minLength(2), Validators.maxLength(100)],
            }),
        ], {
            containerClass: 'e11-grid e11-grid-cols-1 lg:e11-grid-cols-2 e11-gap-8 e11-mb-4',
            fieldsClass: 'e11-w-full',
        }),
        e11FormLayoutInlineGrid([
            e11FieldInputFile('logoImage', 'Logo Url', undefined, {
                validatorOrOpts: [Validators.required],
                extraInputOption: TenantFileInputUtil.getArgsForFileInput(logoImage),
            }),
            e11FieldInputFile('logoImageDark', 'Logo Url (Dark)', undefined, {
                validatorOrOpts: [Validators.required],
                extraInputOption: TenantFileInputUtil.getArgsForFileInput(logoImageDark),
            }),
            e11FieldInputFile('logoImageLight', 'Logo Url (Light)', undefined, {
                validatorOrOpts: [Validators.required],
                extraInputOption: TenantFileInputUtil.getArgsForFileInput(logoImageLight),
            }),
        ], { containerClass: 'e11-grid e11-grid-cols-1 md:e11-grid-cols-3 e11-gap-8 e11-mb-8', fieldsClass: 'e11-border e11-rounded-md e11-p-4' }),
        e11FormLayoutInlineGrid([
            e11FieldInputFile('favIcon', 'Fav Icon', undefined, {
                validatorOrOpts: [Validators.required],
                extraInputOption: TenantFileInputUtil.getArgsForFileInput(favIcon),
            }),
            e11FieldInputFile('favIconNotification', 'Fav Icon Notification', undefined, {
                validatorOrOpts: [Validators.required],
                extraInputOption: TenantFileInputUtil.getArgsForFileInput(favIconNotification),
            }),
        ], { containerClass: 'e11-grid e11-grid-cols-1 md:e11-grid-cols-2 e11-gap-8 e11-mb-8', fieldsClass: 'e11-border e11-rounded-md e11-p-4' }),
    ], {
        containerClass: 'e11-border-b e11-mb-4',
        templateSpec: { templateKey: tenantTemplateKeys.tenantConfig },
    });
}
function notificationForm({ emailLogo, defaultEmailDomain, defaultNotificationPaths, }) {
    return e11LayoutGroup([
        e11FormLayoutInlineGrid([
            e11FieldInputText('emailFrom', 'Email From (This should not be changed from the default unless the customer has a specific mailing domain they want to use and fully understand the implications of using that domain for automated emails.) ', defaultEmailDomain, {
                validatorOrOpts: [Validators.required, Validators.minLength(2), Validators.maxLength(75), E11FormValidator.emailValidator()],
            }),
            e11FieldInputText('emailCompanyName', 'Email Company Name', undefined, {
                validatorOrOpts: [Validators.required, Validators.minLength(2), Validators.maxLength(100)],
            }),
            e11FieldInputText('emailPlatformName', 'Email Platform Name', undefined, {
                validatorOrOpts: [Validators.required, Validators.minLength(2), Validators.maxLength(100)],
            }),
        ], {
            containerClass: 'e11-flex-wrap e11-mb-4',
            fieldsClass: 'e11-w-[45%]',
        }),
        e11FormLayoutInlineGrid([
            e11FieldInputFile('emailLogo', 'Email Logo', undefined, {
                validatorOrOpts: [Validators.required],
                extraInputOption: TenantFileInputUtil.getArgsForFileInput(emailLogo),
            }),
        ], { containerClass: 'e11-flex e11-items-center e11-justify-start e11-border e11-rounded-md e11-p-4 e11-mb-4 e11-w-full md:e11-w-1/2 e11-mb-8' }),
        e11FormLayoutInlineGrid([
            e11FieldInputText('inviteRegistrationPath', 'Registration path', defaultNotificationPaths?.inviteRegistrationPath ?? NOTIFICATION_DEFAULTS.inviteRegistrationPath, { validatorOrOpts: [Validators.required] }),
            e11FieldInputText('verifyEmailPath', 'Verify email path', defaultNotificationPaths?.verifyEmailPath ?? NOTIFICATION_DEFAULTS.verifyEmailPath, { validatorOrOpts: [Validators.required] }),
            e11FieldInputText('resetPasswordPath', 'Reset password path', defaultNotificationPaths?.resetPasswordPath ?? NOTIFICATION_DEFAULTS.resetPasswordPath, { validatorOrOpts: [Validators.required] }),
        ]),
    ], {
        containerClass: 'e11-border-b e11-mb-4',
        templateSpec: { templateKey: tenantTemplateKeys.emailConfig },
    });
}
function themeForm() {
    return e11FormLayoutInline3Grid([
        e11FieldInputColor('--color-primary', 'Primary color', '#1E5631'),
        e11FieldInputColor('--color-primary-accent', 'Primary accent color', '#2B7C47'),
        e11FieldInputColor('--color-complimentary', 'Complimentary color', '#7C2B60'),
        e11FieldInputColor('--color-secondary', 'Secondary color', '#d3823d'),
        e11FieldInputColor('--color-app-bg', 'App background color', '#ffffff'),
        e11FieldInputColor('--color-app-bg-dark', 'Dark app background color', '#3F3F46'),
        e11FieldInputColor('--color-app-borders', 'App borders color', '#C8C8C8'),
        e11FieldInputColor('--color-info', 'Info color', '#033C6D'),
        e11FieldInputColor('--color-success', 'Success color', '#1E5631'),
        e11FieldInputColor('--color-alert', 'Alert color', '#FDF873'),
        e11FieldInputColor('--color-warning', 'Warning color', '#d3823d'),
        e11FieldInputColor('--color-danger', 'Danger color', '#a52c13'),
        e11FieldInputColor('--color-error', 'Error color', '#a52c13'),
        e11FieldInputColor('--color-text-base', 'Base text color', '#7e7e7e'),
        e11FieldInputColor('--color-text-dark', 'Dark text color', '#333333'),
        e11FieldInputColor('--color-text-light', 'Light text color', '#A1A1A1'),
        e11FieldInputColor('--color-text-extra-light', 'Extra light text color', '#E1E1E1'),
        e11FieldInputColor('--color-text-info', 'Info text color', '#033C6D'),
        e11FieldInputColor('--color-text-success', 'Success text color', '#1E5631'),
        e11FieldInputColor('--color-text-alert', 'Alert text color', '#FDF873'),
        e11FieldInputColor('--color-text-warning', 'Warning text color', '#d3823d'),
        e11FieldInputColor('--color-text-danger', 'Danger text color', '#a52c13'),
        e11FieldInputColor('--color-text-error', 'Error text color', '#a52c13'),
    ], { templateSpec: { templateKey: tenantTemplateKeys.tenantTheme } });
}

class ProvisionConsumerTenantComponent {
    constructor(provisionService, notificationService, errorHandlerService, configProvider, tenantUtils, directUpload, domainService) {
        this.provisionService = provisionService;
        this.notificationService = notificationService;
        this.errorHandlerService = errorHandlerService;
        this.configProvider = configProvider;
        this.tenantUtils = tenantUtils;
        this.directUpload = directUpload;
        this.domainService = domainService;
        this.templateKeys = tenantTemplateKeys;
        this.fieldGroups = provisionFormFieldGroups({
            defaultEmailDomain: this.configProvider.config.defaultEmailDomain,
            defaultNotificationPaths: this.configProvider.config.defaultNotificationPaths,
        }, TenantType.Consumer);
        this.loading = false;
        this.tenantAdded = new EventEmitter();
    }
    async onSubmit(rawTenantFormResult) {
        const fullHost = this.constructFullHost(rawTenantFormResult.hostPrefix);
        const customPath = `bootstrap/${fullHost}`;
        const files = this.tenantUtils.extractFiles(rawTenantFormResult);
        /**
         * NOTE: this is here until we have an upload but even when so, we will want the
         * URLs to be the consistent naming pattern below (e.g) logoImageUrl is always logo.png
         */
        const tenantFormResult = this.tenantUtils.prepareTenantFormResult({
            ...rawTenantFormResult,
            host: fullHost,
        });
        const provisionTenantModel = this.tenantUtils.buildProvisionModel(tenantFormResult, this.configProvider.config);
        try {
            this.loading = true;
            const tenantBootstrap = await lastValueFrom(this.provisionService.provisionConsumerTenant(provisionTenantModel));
            this.notificationService.popNotification({
                title: 'Provisioned',
                message: `The tenant ${tenantBootstrap.name} has been provisioned for the host: ${tenantBootstrap.auth.host}. Uploading images...`,
                type: 'info',
                autoClose: false,
            });
            await this.tenantUtils.uploadTenantAssets(this.directUpload, { files, customPath }, this.notificationService);
            this.tenantFormResult = undefined;
            this.tenantAdded.emit(true);
        }
        catch (error) {
            this.tenantFormResult = rawTenantFormResult;
            this.errorHandlerService.handleError(error, { alertUser: true });
        }
        finally {
            this.loading = false;
        }
    }
    constructFullHost(hostPrefix) {
        const envPrefix = this.domainService.getEnvPrefix();
        const baseDomain = this.domainService.getBaseDomain();
        return `${hostPrefix}.${envPrefix}${baseDomain}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ProvisionConsumerTenantComponent, deps: [{ token: ProvisioningService }, { token: i4$1.NotificationHelper }, { token: i1.E11ErrorHandlerService }, { token: BaseRegistrationConfigProvider }, { token: TenantUtils }, { token: i6$3.DirectUploadService }, { token: TenantDomainConfigService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ProvisionConsumerTenantComponent, selector: "sdk-provision-consumer-tenant", outputs: { tenantAdded: "tenantAdded" }, viewQueries: [{ propertyName: "dynamicForm", first: true, predicate: ["dynamicForm"], descendants: true }], ngImport: i0, template: `
    <e11-dynamic-form-builder
      #dynamicForm
      [fieldGroups]="fieldGroups"
      [loading]="loading"
      [initialValue]="tenantFormResult"
      (onSubmit)="onSubmit($event)"
    >
      <ng-template e11Template="{{ templateKeys.companyInfo }}">
        <h3>{{ 'Company Info' | translate }}</h3>
        <p>{{ 'Company name and contact information' | translate }}</p>
      </ng-template>
      <ng-template e11Template="{{ templateKeys.tenantConfig }}">
        <h3>{{ 'Tenant Configuration' | translate }}</h3>
        <p>{{ "The tenant host and other configuration around how the tenant's site is displayed" | translate }}</p>
      </ng-template>
      <ng-template e11Template="{{ templateKeys.emailConfig }}">
        <h3>{{ 'Tenant Email Configuration' | translate }}</h3>
        <p>{{ 'How emails sent from this tenant are displayed' | translate }}</p>
      </ng-template>
      <ng-template e11Template="{{ templateKeys.tenantTheme }}">
        <h3>{{ 'Tenant Theme' | translate }}</h3>
        <p>{{ 'All the theme colors for this tenant' | translate }}</p>
      </ng-template>
    </e11-dynamic-form-builder>
  `, isInline: true, dependencies: [{ kind: "directive", type: i8.E11Template, selector: "[e11Template]", inputs: ["type", "e11Template"] }, { kind: "component", type: i3$1.E11DynamicFormBuilderComponent, selector: "e11-dynamic-form-builder", inputs: ["initialValue", "hideSubmitMenu", "loading", "disabled", "disabledText", "submitButtonConfig", "cancelButtonConfig", "deleteButtonConfig", "cancelLinkConfig", "showCancelLink", "showCancelButton", "showDeleteButton", "submitButtonTitle", "cancelLinkTitle", "cancelButtonTitle", "deleteButtonTitle", "buttonColorSubmit", "buttonColorCancel", "buttonColorDelete", "fieldGroups", "errorMessageOverrides"], outputs: ["valueChanges", "onSubmit", "onCancel", "onDelete"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ProvisionConsumerTenantComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-provision-consumer-tenant',
                    template: `
    <e11-dynamic-form-builder
      #dynamicForm
      [fieldGroups]="fieldGroups"
      [loading]="loading"
      [initialValue]="tenantFormResult"
      (onSubmit)="onSubmit($event)"
    >
      <ng-template e11Template="{{ templateKeys.companyInfo }}">
        <h3>{{ 'Company Info' | translate }}</h3>
        <p>{{ 'Company name and contact information' | translate }}</p>
      </ng-template>
      <ng-template e11Template="{{ templateKeys.tenantConfig }}">
        <h3>{{ 'Tenant Configuration' | translate }}</h3>
        <p>{{ "The tenant host and other configuration around how the tenant's site is displayed" | translate }}</p>
      </ng-template>
      <ng-template e11Template="{{ templateKeys.emailConfig }}">
        <h3>{{ 'Tenant Email Configuration' | translate }}</h3>
        <p>{{ 'How emails sent from this tenant are displayed' | translate }}</p>
      </ng-template>
      <ng-template e11Template="{{ templateKeys.tenantTheme }}">
        <h3>{{ 'Tenant Theme' | translate }}</h3>
        <p>{{ 'All the theme colors for this tenant' | translate }}</p>
      </ng-template>
    </e11-dynamic-form-builder>
  `,
                }]
        }], ctorParameters: () => [{ type: ProvisioningService }, { type: i4$1.NotificationHelper }, { type: i1.E11ErrorHandlerService }, { type: BaseRegistrationConfigProvider }, { type: TenantUtils }, { type: i6$3.DirectUploadService }, { type: TenantDomainConfigService }], propDecorators: { dynamicForm: [{
                type: ViewChild,
                args: ['dynamicForm']
            }], tenantAdded: [{
                type: Output
            }] } });

class ProvisionCustomerTenantComponent {
    set dynamicForm(form) {
        this._dynamicForm = form;
        this.addressFormService.init(this._dynamicForm);
    }
    get dynamicForm() {
        return this._dynamicForm;
    }
    constructor(provisionService, notificationService, errorHandlerService, configProvider, tenantUtils, directUpload, addressFormService, logger) {
        this.provisionService = provisionService;
        this.notificationService = notificationService;
        this.errorHandlerService = errorHandlerService;
        this.configProvider = configProvider;
        this.tenantUtils = tenantUtils;
        this.directUpload = directUpload;
        this.addressFormService = addressFormService;
        this.logger = logger;
        this.templateKeys = tenantTemplateKeys;
        this.fieldGroups = provisionFormFieldGroups({
            addressFormService: this.addressFormService,
            defaultEmailDomain: this.configProvider.config.defaultEmailDomain,
            defaultNotificationPaths: this.configProvider.config.defaultNotificationPaths,
        }, TenantType.Business);
        this.loading = false;
    }
    ngOnDestroy() {
        this.addressFormService.ngOnDestroy();
    }
    async onSubmit(rawTenantFormResult) {
        if (rawTenantFormResult.host) {
            this.logger.debug('Provisioning with host:', rawTenantFormResult.host);
        }
        else {
            this.errorHandlerService.handleError(new Error('Host is required'), { alertUser: true });
            return;
        }
        const customPath = `bootstrap/${rawTenantFormResult.host}`;
        const files = this.tenantUtils.extractFiles(rawTenantFormResult);
        /**
         * NOTE: this is here until we have an upload but even when so, we will want the
         * URLs to be the consistent naming pattern below (e.g) logoImageUrl is always logo.png
         */
        const tenantFormResult = this.tenantUtils.prepareTenantFormResult(rawTenantFormResult);
        const provisionTenantModel = this.tenantUtils.buildProvisionModel(tenantFormResult, this.configProvider.config);
        try {
            this.loading = true;
            const tenantBootstrap = await lastValueFrom(this.provisionService.provisionCustomerTenant(provisionTenantModel));
            this.notificationService.popNotification({
                title: 'Provisioned',
                message: `The tenant ${tenantBootstrap.name} has been provisioned for the host: ${tenantBootstrap.auth.host}. Uploading images...`,
                type: 'info',
                autoClose: false,
            });
            await this.tenantUtils.uploadTenantAssets(this.directUpload, { files, customPath }, this.notificationService);
            this.tenantFormResult = undefined;
        }
        catch (error) {
            this.tenantFormResult = rawTenantFormResult;
            this.errorHandlerService.handleError(error, { alertUser: true });
        }
        finally {
            this.loading = false;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ProvisionCustomerTenantComponent, deps: [{ token: ProvisioningService }, { token: i4$1.NotificationHelper }, { token: i1.E11ErrorHandlerService }, { token: BaseRegistrationConfigProvider }, { token: TenantUtils }, { token: i6$3.DirectUploadService }, { token: i3$3.AddressFormService }, { token: i1.E11Logger }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ProvisionCustomerTenantComponent, selector: "sdk-provision-customer-tenant", providers: [AddressFormService], viewQueries: [{ propertyName: "dynamicForm", first: true, predicate: ["dynamicForm"], descendants: true }], ngImport: i0, template: `
    <e11-dynamic-form-builder
      #dynamicForm
      [fieldGroups]="fieldGroups"
      [loading]="loading"
      [initialValue]="tenantFormResult"
      (onSubmit)="onSubmit($event)"
    >
      <ng-template e11Template="{{ templateKeys.companyInfo }}">
        <h3>{{ 'Company Info' | translate }}</h3>
        <p>{{ 'Company name and contact information' | translate }}</p>
      </ng-template>
      <ng-template e11Template="{{ templateKeys.tenantConfig }}">
        <h3>{{ 'Tenant Configuration' | translate }}</h3>
        <p>{{ "The tenant host and other configuration around how the tenant's site is displayed" | translate }}</p>
      </ng-template>
      <ng-template e11Template="{{ templateKeys.emailConfig }}">
        <h3>{{ 'Tenant Email Configuration' | translate }}</h3>
        <p>{{ 'How emails sent from this tenant are displayed' | translate }}</p>
      </ng-template>
      <ng-template e11Template="{{ templateKeys.tenantTheme }}">
        <h3>{{ 'Tenant Theme' | translate }}</h3>
        <p>{{ 'All the theme colors for this tenant' | translate }}</p>
      </ng-template>
      <ng-template e11Template="{{ templateKeys.invitee }}">
        <h3>{{ 'Invitee' | translate }}</h3>
        <p>{{ 'The user to invite to administrate the new tenant' | translate }}</p>
      </ng-template>
    </e11-dynamic-form-builder>
  `, isInline: true, dependencies: [{ kind: "directive", type: i8.E11Template, selector: "[e11Template]", inputs: ["type", "e11Template"] }, { kind: "component", type: i3$1.E11DynamicFormBuilderComponent, selector: "e11-dynamic-form-builder", inputs: ["initialValue", "hideSubmitMenu", "loading", "disabled", "disabledText", "submitButtonConfig", "cancelButtonConfig", "deleteButtonConfig", "cancelLinkConfig", "showCancelLink", "showCancelButton", "showDeleteButton", "submitButtonTitle", "cancelLinkTitle", "cancelButtonTitle", "deleteButtonTitle", "buttonColorSubmit", "buttonColorCancel", "buttonColorDelete", "fieldGroups", "errorMessageOverrides"], outputs: ["valueChanges", "onSubmit", "onCancel", "onDelete"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ProvisionCustomerTenantComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-provision-customer-tenant',
                    providers: [AddressFormService],
                    template: `
    <e11-dynamic-form-builder
      #dynamicForm
      [fieldGroups]="fieldGroups"
      [loading]="loading"
      [initialValue]="tenantFormResult"
      (onSubmit)="onSubmit($event)"
    >
      <ng-template e11Template="{{ templateKeys.companyInfo }}">
        <h3>{{ 'Company Info' | translate }}</h3>
        <p>{{ 'Company name and contact information' | translate }}</p>
      </ng-template>
      <ng-template e11Template="{{ templateKeys.tenantConfig }}">
        <h3>{{ 'Tenant Configuration' | translate }}</h3>
        <p>{{ "The tenant host and other configuration around how the tenant's site is displayed" | translate }}</p>
      </ng-template>
      <ng-template e11Template="{{ templateKeys.emailConfig }}">
        <h3>{{ 'Tenant Email Configuration' | translate }}</h3>
        <p>{{ 'How emails sent from this tenant are displayed' | translate }}</p>
      </ng-template>
      <ng-template e11Template="{{ templateKeys.tenantTheme }}">
        <h3>{{ 'Tenant Theme' | translate }}</h3>
        <p>{{ 'All the theme colors for this tenant' | translate }}</p>
      </ng-template>
      <ng-template e11Template="{{ templateKeys.invitee }}">
        <h3>{{ 'Invitee' | translate }}</h3>
        <p>{{ 'The user to invite to administrate the new tenant' | translate }}</p>
      </ng-template>
    </e11-dynamic-form-builder>
  `,
                }]
        }], ctorParameters: () => [{ type: ProvisioningService }, { type: i4$1.NotificationHelper }, { type: i1.E11ErrorHandlerService }, { type: BaseRegistrationConfigProvider }, { type: TenantUtils }, { type: i6$3.DirectUploadService }, { type: i3$3.AddressFormService }, { type: i1.E11Logger }], propDecorators: { dynamicForm: [{
                type: ViewChild,
                args: ['dynamicForm']
            }] } });

class ProvisionCustomerComponent {
    constructor(provisionService, tenantBootstrapRepository, notificationService, errorHandlerService) {
        this.provisionService = provisionService;
        this.tenantBootstrapRepository = tenantBootstrapRepository;
        this.notificationService = notificationService;
        this.errorHandlerService = errorHandlerService;
        this.loading = false;
        this.tenantSelectOptions = [{ name: 'Please select...', value: '' }];
        this.accountCreated = new EventEmitter();
    }
    ngOnInit() {
        this.tenantBootstrapRepository
            .getAll()
            .pipe(take(1))
            .subscribe((tenants) => {
            tenants.forEach((t) => {
                this.tenantSelectOptions?.push({ name: t.name, value: t.auth.tenantId });
            });
        });
    }
    selectTenant(tenantId) {
        this.authTenantId = tenantId;
    }
    async provisionAccount(formData) {
        if (!this.authTenantId) {
            this.sendNotification('Tenant Selection', 'A tenant must be selected', 'warning');
            return;
        }
        const business = {
            companyName: formData.companyName,
            phone: formData.phone,
            address: formData.address,
            address2: formData.address2,
            city: formData.city,
            state: formData.state,
            zip: formData.zip,
            countryCode: formData.countryCode,
        };
        const invite = {
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
        };
        try {
            this.loading = true;
            const customer = await firstValueFrom(this.provisionService.provisionCustomer({ business, invite: invite, authTenantId: this.authTenantId }));
            this.provisionForm?.reset();
            this.sendNotification('Success', 'The customer was provisioned', 'success');
            this.accountCreated.emit(customer);
        }
        catch (error) {
            this.notificationService.popNotificationFromError(error);
            this.errorHandlerService.handleError(error);
        }
        finally {
            this.loading = false;
        }
    }
    sendNotification(title, message, type) {
        const notification = {
            title: title,
            message: message,
            type: type,
            autoClose: true,
            dismissOnRouteChange: true,
        };
        this.notificationService.popNotification(notification);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ProvisionCustomerComponent, deps: [{ token: ProvisioningService }, { token: i2$6.TenantBootstrapRepository }, { token: i4$1.NotificationService }, { token: i1.E11ErrorHandlerService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ProvisionCustomerComponent, selector: "sdk-provision-customer", outputs: { accountCreated: "accountCreated" }, viewQueries: [{ propertyName: "provisionForm", first: true, predicate: ["provisionForm"], descendants: true }], ngImport: i0, template: "<div class=\"e11-flex e11-w-full e11-mb-4\">\n  <div class=\"e11-grow\">\n    <h3>{{ \"Create Customer Account\" | translate }}</h3>\n  </div>\n  <div class=\"e11-flex e11-justify-end\"></div>\n</div>\n\n<div class=\"e11-pb-4\">\n  <e11-select\n    *ngIf=\"tenantSelectOptions\"\n    [value]=\"tenantSelectOptions[0]\"\n    (valueChange)=\"selectTenant($event)\"\n    [options]=\"tenantSelectOptions\"\n    [required]=\"true\"\n    [label]=\"'Select Tenant'\"\n  ></e11-select>\n</div>\n<sdk-provision-form-customer #provisionForm (submitted)=\"provisionAccount($event)\"></sdk-provision-form-customer>\n\n<e11-loader-dots\n  *ngIf=\"loading\"\n  [size]=\"'md'\"\n  [fullScreen]=\"true\"\n  [color]=\"'e11-bg-skin-primary-accent'\"\n  [hasBackdrop]=\"true\"\n  [fontColor]=\"'e11-text-white'\"\n  label=\"{{ 'Creating account...' | translate }}\"\n></e11-loader-dots>\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$4.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i7.E11SelectComponent, selector: "e11-select", inputs: ["id", "name", "label", "size", "selectMessage", "labelClass", "inputClass", "containerClass", "parentForm", "formControlName", "options", "value", "hasError", "required", "disabled", "loading", "tooltipConfig", "labelTextOptional", "selectClass"], outputs: ["valueChange", "onValueChange"] }, { kind: "component", type: FormCustomerProvisionComponent, selector: "sdk-provision-form-customer", inputs: ["provisionBusinessData"], outputs: ["submitted"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ProvisionCustomerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-provision-customer', template: "<div class=\"e11-flex e11-w-full e11-mb-4\">\n  <div class=\"e11-grow\">\n    <h3>{{ \"Create Customer Account\" | translate }}</h3>\n  </div>\n  <div class=\"e11-flex e11-justify-end\"></div>\n</div>\n\n<div class=\"e11-pb-4\">\n  <e11-select\n    *ngIf=\"tenantSelectOptions\"\n    [value]=\"tenantSelectOptions[0]\"\n    (valueChange)=\"selectTenant($event)\"\n    [options]=\"tenantSelectOptions\"\n    [required]=\"true\"\n    [label]=\"'Select Tenant'\"\n  ></e11-select>\n</div>\n<sdk-provision-form-customer #provisionForm (submitted)=\"provisionAccount($event)\"></sdk-provision-form-customer>\n\n<e11-loader-dots\n  *ngIf=\"loading\"\n  [size]=\"'md'\"\n  [fullScreen]=\"true\"\n  [color]=\"'e11-bg-skin-primary-accent'\"\n  [hasBackdrop]=\"true\"\n  [fontColor]=\"'e11-text-white'\"\n  label=\"{{ 'Creating account...' | translate }}\"\n></e11-loader-dots>\n" }]
        }], ctorParameters: () => [{ type: ProvisioningService }, { type: i2$6.TenantBootstrapRepository }, { type: i4$1.NotificationService }, { type: i1.E11ErrorHandlerService }], propDecorators: { accountCreated: [{
                type: Output
            }], provisionForm: [{
                type: ViewChild,
                args: ['provisionForm']
            }] } });

class ProvisionedBootstrapsListComponent {
    constructor(tenantBootstrapStore) {
        this.tenantBootstrapStore = tenantBootstrapStore;
        this.tenantsBootstrap = [];
        this.loading$ = this.tenantBootstrapStore.loading$;
        this.loadingCardRange = range(12);
        this.placeholderTenant = {
            id: 'placeholder',
            name: 'placeholder',
            displayName: 'placeholder',
            hostName: 'placeholder',
            logo: 'placeholder',
            action: 'placeholder',
            tenantId: 'placeholder',
        };
        this.rowClicked = new EventEmitter();
        this.productAction = new EventEmitter();
        this.enableProductOperations = false;
        this.editingStateChanged = new EventEmitter();
        this.initialGridOptions = bootstrapTableOptions;
    }
    ngOnInit() {
        if (this.type && this.type === TenantType.Business) {
            this.tenantBootstrapStore.getAllBusinessTenants();
            this.tenant$ = this.tenantBootstrapStore.businessTenantBootstraps$.pipe(tap((tenantsBootstrap) => (this.tenantsBootstrap = tenantsBootstrap)), map(this.mapFunction));
        }
        else {
            this.tenantBootstrapStore.getAllConsumerTenants();
            this.tenant$ = this.tenantBootstrapStore.consumerTenantBootstraps$.pipe(tap((tenantsBootstrap) => (this.tenantsBootstrap = tenantsBootstrap)), map(this.mapFunction));
        }
    }
    onRowClicked(id) {
        const tenant = this.tenantsBootstrap.find((v) => v.id === id);
        if (!tenant)
            return;
        this.editTenant = tenant;
        this.editingStateChanged.emit(true);
        this.rowClicked.emit(tenant);
    }
    onSaved() {
        this.editTenant = undefined;
        this.editingStateChanged.emit(false);
    }
    cancelEdit() {
        this.editTenant = undefined;
        this.editingStateChanged.emit(false);
    }
    onProductAction(tenant) {
        tenant && this.productAction.emit(tenant);
    }
    mapFunction(tenants) {
        return tenants.map((tenant) => ({
            id: tenant.id,
            name: tenant.name,
            url: tenant.url,
            logo: tenant.brand.logoImageUrl,
            displayName: tenant.auth.displayName,
            hostName: tenant.auth.hostName,
            tenantId: tenant.auth.tenantId,
            action: 'edit',
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ProvisionedBootstrapsListComponent, deps: [{ token: TenantBootstrapStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.9", type: ProvisionedBootstrapsListComponent, selector: "sdk-provisioned-bootstraps-list", inputs: { type: "type", enableProductOperations: "enableProductOperations" }, outputs: { rowClicked: "rowClicked", productAction: "productAction", editingStateChanged: "editingStateChanged" }, ngImport: i0, template: `
    <ng-container *ngIf="!editTenant">
      <ng-template let-data #tenantListCard>
        <e11-card [isLoading]="data.loading" [isClickable]="false">
          <div class="e11-flex e11-flex-col e11-justify-between e11-gap-6">
            <div
              class="e11-flex e11-flex-row e11-flex-wrap-reverse"
              [ngClass]="{
              'e11-text-transparent e11-skeleton e11-cursor-not-allowed': data.loading,
              }"
            >
              <div class="e11-flex-grow e11-flex e11-flex-col">
                <div class="e11-font-bold e11-text-lg">{{ data.tenant.name }}</div>
                <span class="e11-font-semibold">{{ data.tenant.displayName }}</span>
                <span>{{ 'Document ID:' | translate }} {{ data.tenant.id }}</span>
                <span>{{ 'Tenant ID:' | translate }} {{ data.tenant.tenantId }}</span>
                <span [ngClass]="{ 'e11-text-skin-primary-accent': !data.loading }">{{ data.tenant.hostName }}</span>
              </div>
              <img [src]="data.tenant.logo" alt="" class="e11-w-20 e11-h-20 e11-object-contain" *ngIf="!data.loading" />
            </div>
            <div class="e11-flex e11-items-center e11-justify-between e11-gap-1">
              <button
                [disabled]="data.loading"
                class="e11-flex e11-items-center e11-gap-3 e11-text-skin-primary-accent hover:e11-text-skin-primary e11-font-semibold"
                (click)="onRowClicked(data.tenant.id)"
              >
                <span class="material-icons-outlined md-18">edit</span>
                <span>{{ 'Edit' | translate }}</span>
              </button>
              <button
                *ngIf="enableProductOperations"
                [disabled]="data.loading"
                class="e11-flex e11-items-center e11-gap-3 e11-text-skin-primary-accent hover:e11-text-skin-primary e11-font-semibold"
                (click)="onProductAction(data.tenant)"
              >
                <span class="material-icons-outlined md-18">category</span>
                <span>{{ 'Products' | translate }}</span>
              </button>
            </div>
          </div>
        </e11-card>
      </ng-template>
      <div *ngrxLet="loading$ as loading">
        <div class="e11-grid e11-grid-cols-1 lg:e11-grid-cols-2 xl:e11-grid-cols-3 e11-gap-6" *ngrxLet="tenant$ as tenants">
          <ng-container *ngIf="!loading">
            @for (tenant of tenants; track tenant.id) {
            <ng-container *ngTemplateOutlet="tenantListCard; context: { $implicit: { tenant: tenant || [], loading: false } }"></ng-container>
            } @empty {
            <div class="e11-col-span-full">
              <e11-empty-state title="No tenant found." icon="find_in_page" iconSize="md-36"></e11-empty-state>
            </div>
            }
          </ng-container>
          <ng-container *ngIf="loading">
            @for (tenant of loadingCardRange; track $index) {
            <ng-container
              [ngTemplateOutletContext]="{ $implicit: { tenant: placeholderTenant, loading: true } }"
              [ngTemplateOutlet]="tenantListCard"
            ></ng-container>
            }
          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="editTenant">
      <div class="e11-mb-4">
        <sdk-provision-edit-bootstrap #edit [tenantModel]="editTenant" (saved)="onSaved()"></sdk-provision-edit-bootstrap>
      </div>

      <div class="e11-w-full e11-text-right">
        <e11-button [value]="'Cancel'" [buttonGroup]="true" (click)="cancelEdit()"></e11-button>
        <e11-button [value]="'Save'" [buttonGroup]="true" (click)="edit.save()"></e11-button>
      </div>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i3$2.E11EmptyStateComponent, selector: "e11-empty-state", inputs: ["icon", "iconType", "iconSize", "customImageUrl", "customImageAltText", "showButton", "borderColor", "buttonValue", "buttonColor", "buttonDisabled", "buttonIcon", "border", "title", "subtitle", "clickable", "disabled", "disabledText", "containerClass", "contentClass", "containerClassOverrides", "contentClassOverrides", "htmlSubtitle"], outputs: ["buttonClicked"] }, { kind: "component", type: i5.E11CardComponent, selector: "e11-card", inputs: ["isClickable", "status", "state", "arrow", "borderDashed", "width", "height", "containerClassOverrides", "containerClass", "customStateCss", "isLoading"] }, { kind: "directive", type: i4.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: ProvisionEditBootstrapComponent, selector: "sdk-provision-edit-bootstrap", inputs: ["tenantModel"], outputs: ["saved"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ProvisionedBootstrapsListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-provisioned-bootstraps-list',
                    template: `
    <ng-container *ngIf="!editTenant">
      <ng-template let-data #tenantListCard>
        <e11-card [isLoading]="data.loading" [isClickable]="false">
          <div class="e11-flex e11-flex-col e11-justify-between e11-gap-6">
            <div
              class="e11-flex e11-flex-row e11-flex-wrap-reverse"
              [ngClass]="{
              'e11-text-transparent e11-skeleton e11-cursor-not-allowed': data.loading,
              }"
            >
              <div class="e11-flex-grow e11-flex e11-flex-col">
                <div class="e11-font-bold e11-text-lg">{{ data.tenant.name }}</div>
                <span class="e11-font-semibold">{{ data.tenant.displayName }}</span>
                <span>{{ 'Document ID:' | translate }} {{ data.tenant.id }}</span>
                <span>{{ 'Tenant ID:' | translate }} {{ data.tenant.tenantId }}</span>
                <span [ngClass]="{ 'e11-text-skin-primary-accent': !data.loading }">{{ data.tenant.hostName }}</span>
              </div>
              <img [src]="data.tenant.logo" alt="" class="e11-w-20 e11-h-20 e11-object-contain" *ngIf="!data.loading" />
            </div>
            <div class="e11-flex e11-items-center e11-justify-between e11-gap-1">
              <button
                [disabled]="data.loading"
                class="e11-flex e11-items-center e11-gap-3 e11-text-skin-primary-accent hover:e11-text-skin-primary e11-font-semibold"
                (click)="onRowClicked(data.tenant.id)"
              >
                <span class="material-icons-outlined md-18">edit</span>
                <span>{{ 'Edit' | translate }}</span>
              </button>
              <button
                *ngIf="enableProductOperations"
                [disabled]="data.loading"
                class="e11-flex e11-items-center e11-gap-3 e11-text-skin-primary-accent hover:e11-text-skin-primary e11-font-semibold"
                (click)="onProductAction(data.tenant)"
              >
                <span class="material-icons-outlined md-18">category</span>
                <span>{{ 'Products' | translate }}</span>
              </button>
            </div>
          </div>
        </e11-card>
      </ng-template>
      <div *ngrxLet="loading$ as loading">
        <div class="e11-grid e11-grid-cols-1 lg:e11-grid-cols-2 xl:e11-grid-cols-3 e11-gap-6" *ngrxLet="tenant$ as tenants">
          <ng-container *ngIf="!loading">
            @for (tenant of tenants; track tenant.id) {
            <ng-container *ngTemplateOutlet="tenantListCard; context: { $implicit: { tenant: tenant || [], loading: false } }"></ng-container>
            } @empty {
            <div class="e11-col-span-full">
              <e11-empty-state title="No tenant found." icon="find_in_page" iconSize="md-36"></e11-empty-state>
            </div>
            }
          </ng-container>
          <ng-container *ngIf="loading">
            @for (tenant of loadingCardRange; track $index) {
            <ng-container
              [ngTemplateOutletContext]="{ $implicit: { tenant: placeholderTenant, loading: true } }"
              [ngTemplateOutlet]="tenantListCard"
            ></ng-container>
            }
          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="editTenant">
      <div class="e11-mb-4">
        <sdk-provision-edit-bootstrap #edit [tenantModel]="editTenant" (saved)="onSaved()"></sdk-provision-edit-bootstrap>
      </div>

      <div class="e11-w-full e11-text-right">
        <e11-button [value]="'Cancel'" [buttonGroup]="true" (click)="cancelEdit()"></e11-button>
        <e11-button [value]="'Save'" [buttonGroup]="true" (click)="edit.save()"></e11-button>
      </div>
    </ng-container>
  `,
                }]
        }], ctorParameters: () => [{ type: TenantBootstrapStore }], propDecorators: { type: [{
                type: Input
            }], rowClicked: [{
                type: Output
            }], productAction: [{
                type: Output
            }], enableProductOperations: [{
                type: Input
            }], editingStateChanged: [{
                type: Output
            }] } });
const bootstrapTableOptions = {
    keyField: 'id',
    selectable: false,
    enableDynamicFields: false,
    enableFilter: false,
    enableSorting: false,
    columns: [
        {
            key: 'id',
            title: 'ID',
            type: DataType.CharField,
            visible: true,
            optional: false,
        },
        {
            key: 'logo',
            title: 'Logo',
            type: DataType.TemplateField,
            visible: true,
        },
        {
            key: 'name',
            title: 'Tenant Name',
            type: DataType.CharField,
            visible: true,
            enableSort: false,
        },
        {
            key: 'displayName',
            title: 'Display name',
            type: DataType.CharField,
            visible: true,
        },
        {
            key: 'hostName',
            title: 'Host name',
            type: DataType.CharField,
            visible: true,
        },
        {
            key: 'tenantId',
            title: 'Tenant ID',
            type: DataType.CharField,
            visible: true,
        },
        {
            key: 'url',
            title: 'URL',
            type: DataType.TemplateField,
            visible: true,
        },
        {
            key: 'action',
            title: 'Action',
            type: DataType.TemplateField,
            visible: true,
            enableFilter: false,
            enableSort: false,
        },
    ],
    paginationSettings: {
        enabled: true,
        serverSide: false,
        rowCount: 10,
        pageLinks: 5,
        rowsPerPageOptions: [10, 25, 50, 100],
    },
};

var UserType;
(function (UserType) {
    UserType["Business"] = "Business";
    UserType["Consumer"] = "Consumer";
})(UserType || (UserType = {}));

class IRegistrationService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IRegistrationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IRegistrationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IRegistrationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

var RegistrationPage;
(function (RegistrationPage) {
    RegistrationPage["Fake"] = "Fake";
    RegistrationPage["Email"] = "Email";
    RegistrationPage["User"] = "User";
    RegistrationPage["Business"] = "Business";
})(RegistrationPage || (RegistrationPage = {}));
const initialState = {
    registrationComplete: null,
    workingEmailForm: {},
    workingUserForm: {},
    workingBusinessForm: {},
    displayPager: new DisplayPager([
        { registrationPage: RegistrationPage.Fake, display: false }, //WTF??
        { registrationPage: RegistrationPage.Email },
        { registrationPage: RegistrationPage.User },
        { registrationPage: RegistrationPage.Business },
    ]),
};
class BusinessRegistrationComponentStore extends ComponentStore {
    constructor(logger, configProvider) {
        super(initialState);
        this.logger = logger;
        this.configProvider = configProvider;
        // Selectors
        this.state$ = this.select((s) => s);
        this.displayPager$ = this.select((s) => s.displayPager);
        this.emailForm$ = this.select((s) => s.emailForm);
        this.userForm$ = this.select((s) => s.userForm);
        this.businessForm$ = this.select((s) => s.businessForm);
        this.registrationComplete$ = this.select((s) => s.registrationComplete);
        this.workingEmailForm$ = this.select((s) => s.workingEmailForm);
        this.workingUserForm$ = this.select((s) => s.workingUserForm);
        this.workingBusinessForm$ = this.select((s) => s.workingBusinessForm);
        // Effects
        this.emailNext = this.effect((emailForm$) => emailForm$.pipe(withLatestFrom(this.displayPager$), mergeMap(([emailForm, displayPager]) => {
            this.logger.log('setting email form', emailForm);
            this.setEmailForm(emailForm);
            return this.nextOrComplete(displayPager);
        })));
        this.userNext = this.effect((userForm$) => userForm$.pipe(withLatestFrom(this.displayPager$), mergeMap(([userForm, displayPager]) => {
            this.logger.log('setting user form', userForm);
            this.setUserForm(userForm);
            return this.nextOrComplete(displayPager);
        })));
        this.businessNext = this.effect((businessForm$) => businessForm$.pipe(withLatestFrom(this.displayPager$), mergeMap(([businessForm, displayPager]) => {
            this.logger.log('setting business form', businessForm);
            this.setBusinessForm(businessForm);
            return this.nextOrComplete(displayPager);
        })));
        this.saveWorkingEmailForm = this.effect((workingEmailForm$) => workingEmailForm$.pipe(tap((patch) => {
            this.setWorkingEmailForm(patch);
            return of(true);
        })));
        this.saveWorkingUserForm = this.effect((workingUserForm$) => workingUserForm$.pipe(tap((patch) => {
            this.setWorkingUserForm(patch);
            return of(true);
        })));
        this.saveWorkingBusinessForm = this.effect((workingBusinessForm$) => workingBusinessForm$.pipe(tap((patch) => {
            this.setWorkingBusinessForm(patch);
            return of(true);
        })));
        // Updaters
        this.setEmailForm = this.updater((state, email) => ({
            ...state,
            emailForm: email,
        }));
        this.setUserForm = this.updater((state, userForm) => ({
            ...state,
            userForm: userForm,
        }));
        this.setBusinessForm = this.updater((state, businessForm) => ({
            ...state,
            businessForm: businessForm,
        }));
        this.setWorkingEmailForm = this.updater((state, email) => ({
            ...state,
            workingEmailForm: email,
        }));
        this.setWorkingUserForm = this.updater((state, userForm) => ({
            ...state,
            workingUserForm: userForm,
        }));
        this.setWorkingBusinessForm = this.updater((state, businessForm) => ({
            ...state,
            workingBusinessForm: businessForm,
        }));
        this.setRegistrationComplete = this.updater((state, model) => ({
            ...state,
            registrationComplete: model,
        }));
    }
    nextOrComplete(displayPager) {
        if (displayPager.peekNext() === null) {
            return of(true).pipe(withLatestFrom(this.emailForm$, this.userForm$, this.businessForm$), mergeMap(([ignore, emailForm, userForm, businessForm]) => {
                const registrationModel = this.buildRegistrationModel(emailForm, userForm, businessForm);
                this.setRegistrationComplete(registrationModel || null);
                return of(true);
            }));
        }
        displayPager.next();
        this.setRegistrationComplete(null);
        return of(true);
    }
    buildRegistrationModel(emailForm, userForm, businessForm) {
        if (!emailForm || !userForm || !businessForm) {
            return undefined;
        }
        const registrationModel = {
            userType: UserType.Business,
            firstName: userForm.firstName,
            lastName: userForm.lastName,
            companyName: businessForm.name,
            address: businessForm.address,
            address2: businessForm.address2,
            city: businessForm.city,
            state: businessForm.state,
            zip: businessForm.zip,
            phone: businessForm.phone,
            email: emailForm.email,
            password: userForm.password,
            authTenantId: this.configProvider.config.authTenantId,
        };
        return registrationModel;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BusinessRegistrationComponentStore, deps: [{ token: LOGGER_TOKEN }, { token: BaseRegistrationConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BusinessRegistrationComponentStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BusinessRegistrationComponentStore, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOGGER_TOKEN]
                }] }, { type: BaseRegistrationConfigProvider }] });

class EmailComponent {
    constructor(store, authService) {
        this.store = store;
        this.authService = authService;
        this.formEmail = new FormGroup({
            email: new FormControl('', [Validators.required, E11FormValidator.emailValidator()]),
        });
        this.loading = false;
        this.userEmailInUse = false;
        this.formEmailSubmitted = false;
        this.destroy$ = new Subject();
        this.emailFormData$ = this.store.workingEmailForm$;
    }
    ngOnInit() {
        this.emailFormData$.pipe(takeUntil(this.destroy$)).subscribe((formData) => {
            if (formData) {
                this.formEmail.patchValue(formData);
            }
        });
    }
    ngOnDestroy() {
        this.store.saveWorkingEmailForm(this.map());
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    get fc() {
        return this.formEmail.controls;
    }
    async onSubmitFormEmail() {
        if (this.formEmail.valid) {
            let { res, err } = await this.authService.fetchSignInMethodsForEmail(this.formEmail.value.email.trim());
            if (err) {
                return;
            }
            if (res && res.length > 0) {
                this.userEmailInUse = true;
                return;
            }
            else {
                this.userEmailInUse = false;
            }
            this.formEmailSubmitted = true;
            this.store.emailNext(this.map());
        }
        else {
            // Fire off a validation check on individual fields
            Object.keys(this.formEmail.controls).forEach((field) => {
                const control = this.formEmail.get(field);
                control?.updateValueAndValidity();
            });
        }
    }
    map() {
        const emailForm = {
            email: this.formEmail.value.email,
        };
        return emailForm;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: EmailComponent, deps: [{ token: BusinessRegistrationComponentStore }, { token: i2$1.IAuthService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: EmailComponent, selector: "email-form", ngImport: i0, template: "<!-- Email check -->\n<form class=\"form email e11-mb-8\" [formGroup]=\"formEmail\" (ngSubmit)=\"onSubmitFormEmail()\" novalidate>\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'email'\"\n      name=\"email\"\n      id=\"email_formEmail\"\n      label=\"{{ 'Email' | translate }}\"\n      value=\"userEmail\"\n      [size]=\"'md'\"\n      [parentForm]=\"formEmail\"\n      formControlName=\"email\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [hasError]=\"(fc.email.errors && fc.email.dirty) || (fc.email.invalid && formEmailSubmitted)\"\n    >\n      <e11-input-errors [parentForm]=\"formEmail\" [formControl]=\"fc.email\" [formSubmitted]=\"formEmailSubmitted\" label=\"{{ 'Email' | translate }}\">\n      </e11-input-errors>\n    </e11-input>\n  </div>\n  <div\n    class=\"e11-rounded-md e11-bg-yellow-50 e11-p-4\"\n    *ngIf=\"userEmailInUse\"\n    [ngClass]=\"{ 'e11-opacity-100': userEmailInUse, 'e11-opacity-0': !userEmailInUse }\"\n  >\n    <div class=\"e11-flex\">\n      <div class=\"e11-flex-shrink-0\">\n        <svg\n          class=\"e11-h-5 e11-w-5 e11-text-yellow-400\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n          viewBox=\"0 0 20 20\"\n          fill=\"currentColor\"\n          aria-hidden=\"true\"\n        >\n          <path\n            fill-rule=\"evenodd\"\n            d=\"M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z\"\n            clip-rule=\"evenodd\"\n          />\n        </svg>\n      </div>\n      <div class=\"e11-ml-3\">\n        <div class=\"e11-text-sm\">\n          <p>{{ \"It appears that we already have an account using this email address.\" | translate }}</p>\n        </div>\n        <div class=\"e11-mt-4\"></div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"\">\n    <e11-button\n      id=\"submit_formEmail\"\n      [disabled]=\"loading\"\n      value=\"{{ loading ? 'Loading..' : ('Check Email' | translate) }}\"\n      color=\"primary-accent\"\n      [type]=\"'submit'\"\n      [display]=\"'block'\"\n      [loading]=\"loading\"\n    >\n    </e11-button>\n  </div>\n</form>\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$5.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$5.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$5.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2$5.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$5.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$5.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i4$3.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i7$1.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: EmailComponent, decorators: [{
            type: Component,
            args: [{ selector: 'email-form', template: "<!-- Email check -->\n<form class=\"form email e11-mb-8\" [formGroup]=\"formEmail\" (ngSubmit)=\"onSubmitFormEmail()\" novalidate>\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'email'\"\n      name=\"email\"\n      id=\"email_formEmail\"\n      label=\"{{ 'Email' | translate }}\"\n      value=\"userEmail\"\n      [size]=\"'md'\"\n      [parentForm]=\"formEmail\"\n      formControlName=\"email\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [hasError]=\"(fc.email.errors && fc.email.dirty) || (fc.email.invalid && formEmailSubmitted)\"\n    >\n      <e11-input-errors [parentForm]=\"formEmail\" [formControl]=\"fc.email\" [formSubmitted]=\"formEmailSubmitted\" label=\"{{ 'Email' | translate }}\">\n      </e11-input-errors>\n    </e11-input>\n  </div>\n  <div\n    class=\"e11-rounded-md e11-bg-yellow-50 e11-p-4\"\n    *ngIf=\"userEmailInUse\"\n    [ngClass]=\"{ 'e11-opacity-100': userEmailInUse, 'e11-opacity-0': !userEmailInUse }\"\n  >\n    <div class=\"e11-flex\">\n      <div class=\"e11-flex-shrink-0\">\n        <svg\n          class=\"e11-h-5 e11-w-5 e11-text-yellow-400\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n          viewBox=\"0 0 20 20\"\n          fill=\"currentColor\"\n          aria-hidden=\"true\"\n        >\n          <path\n            fill-rule=\"evenodd\"\n            d=\"M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z\"\n            clip-rule=\"evenodd\"\n          />\n        </svg>\n      </div>\n      <div class=\"e11-ml-3\">\n        <div class=\"e11-text-sm\">\n          <p>{{ \"It appears that we already have an account using this email address.\" | translate }}</p>\n        </div>\n        <div class=\"e11-mt-4\"></div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"\">\n    <e11-button\n      id=\"submit_formEmail\"\n      [disabled]=\"loading\"\n      value=\"{{ loading ? 'Loading..' : ('Check Email' | translate) }}\"\n      color=\"primary-accent\"\n      [type]=\"'submit'\"\n      [display]=\"'block'\"\n      [loading]=\"loading\"\n    >\n    </e11-button>\n  </div>\n</form>\n" }]
        }], ctorParameters: () => [{ type: BusinessRegistrationComponentStore }, { type: i2$1.IAuthService }] });

class UserComponent {
    constructor(store) {
        this.store = store;
        this.formRegister = new FormGroup({
            firstName: new FormControl('', [Validators.required, E11FormValidator.nameValidator(), E11FormValidator.minLengthAlphanumeric(1)]),
            lastName: new FormControl('', [Validators.required, E11FormValidator.nameValidator(), E11FormValidator.minLengthAlphanumeric(1)]),
            password: new FormControl('', [Validators.required, Validators.minLength(8), E11FormValidator.hasNumberValidator()]),
            passwordConfirm: new FormControl('', [Validators.required, Validators.minLength(8)]),
        }, [E11FormValidator.passwordMatch('password', 'passwordConfirm')]);
        this.loading = false;
        this.formRegisterSubmitted = false;
        this.passwordMinLength = { value: 8 };
        this.destroy$ = new Subject();
        this.userFormData$ = this.store.workingUserForm$;
    }
    ngOnInit() {
        this.userFormData$.pipe(takeUntil(this.destroy$)).subscribe((formData) => {
            if (formData) {
                this.formRegister.patchValue(formData);
            }
        });
    }
    ngOnDestroy() {
        this.store.saveWorkingUserForm(this.map());
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    get fr() {
        return this.formRegister.controls;
    }
    onSubmitFormRegister() {
        this.formRegisterSubmitted = true;
        if (this.formRegister.valid) {
            this.store.userNext(this.map());
        }
        else {
            // Fire off a validation check on individual fields
            Object.keys(this.formRegister.controls).forEach((field) => {
                const control = this.formRegister.get(field);
                control?.updateValueAndValidity();
            });
        }
    }
    map() {
        const userForm = {
            firstName: this.formRegister.value.firstName,
            lastName: this.formRegister.value.lastName,
            password: this.formRegister.value.password,
            passwordConfirm: this.formRegister.value.passwordConfirm,
        };
        return userForm;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserComponent, deps: [{ token: BusinessRegistrationComponentStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UserComponent, selector: "user-form", ngImport: i0, template: "<form id=\"form_register\" class=\"form register e11-mb-8\" [formGroup]=\"formRegister\" (ngSubmit)=\"onSubmitFormRegister()\" novalidate autocomplete=\"off\">\n  <div class=\"e11-w-full\">\n    <p class=\"e11-mb-4 e11-font-semibold\">{{ \"Next, please provide your name and create a good secure password.\" | translate }}</p>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"firstName\"\n      id=\"firstName\"\n      label=\"{{ 'First Name' | translate }}\"\n      [size]=\"'md'\"\n      [parentForm]=\"formRegister\"\n      formControlName=\"firstName\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [hasError]=\"(fr.firstName.errors && fr.firstName.dirty) || (fr.firstName.invalid && formRegisterSubmitted)\"\n    >\n      <e11-input-errors\n        [parentForm]=\"formRegister\"\n        [formControl]=\"fr.firstName\"\n        [formSubmitted]=\"formRegisterSubmitted\"\n        label=\"{{ 'First Name' | translate }}\"\n      >\n      </e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"lastName\"\n      id=\"lastName\"\n      label=\"{{ 'Last Name' | translate }}\"\n      value=\"lastName\"\n      [size]=\"'md'\"\n      [parentForm]=\"formRegister\"\n      formControlName=\"lastName\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [hasError]=\"(fr.lastName.errors && fr.lastName.dirty) || (fr.lastName.invalid && formRegisterSubmitted)\"\n    >\n      <e11-input-errors\n        [parentForm]=\"formRegister\"\n        [formControl]=\"fr.lastName\"\n        [formSubmitted]=\"formRegisterSubmitted\"\n        label=\"{{ 'Last Name' | translate }}\"\n      >\n      </e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'password'\"\n      name=\"password\"\n      id=\"password\"\n      label=\"{{ 'Password' | translate }}\"\n      [size]=\"'md'\"\n      [parentForm]=\"formRegister\"\n      formControlName=\"password\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [togglePassword]=\"true\"\n      [hasError]=\"(fr.password.errors && fr.password.dirty) || (fr.password.invalid && formRegisterSubmitted)\"\n    >\n      <e11-input-errors\n        [parentForm]=\"formRegister\"\n        [formControl]=\"fr.password\"\n        [formSubmitted]=\"formRegisterSubmitted\"\n        label=\"{{ 'Password' | translate }}\"\n      >\n      </e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div class=\"e11-w-full e11-mb-8\">\n    <e11-input\n      [type]=\"'password'\"\n      name=\"passwordConfirm\"\n      id=\"password_formConfirmPassword\"\n      label=\"{{ 'Confirm Password' | translate }}\"\n      [size]=\"'md'\"\n      [parentForm]=\"formRegister\"\n      formControlName=\"passwordConfirm\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [togglePassword]=\"true\"\n      [hasError]=\"fr.passwordConfirm.hasError('passwordMatchError')\"\n    >\n      <e11-input-errors\n        [parentForm]=\"formRegister\"\n        [formControl]=\"fr.passwordConfirm\"\n        [formSubmitted]=\"formRegisterSubmitted\"\n        label=\"{{ 'Password confirmation' | translate }}\"\n      >\n      </e11-input-errors>\n    </e11-input>\n\n    <div class=\"error-message-password-list e11-mt-0 e11-mb-4 e11-p-4 e11-border e11-border-skin-app-borders\">\n      <p class=\"e11-font-semibold e11-mb-4\">\n        {{ \"Your password must meet the following requirements:\" | translate }}\n      </p>\n      <p\n        class=\"e11-mb-4 e11-flex e11-items-center e11-h-6\"\n        [ngClass]=\"{\n          'e11-text-skin-error': fr.password.hasError('minlength') || (formRegisterSubmitted && fr.password.invalid),\n          'e11-text-skin-success': !fr.password.hasError('minlength') && fr.password.dirty && fr.password.value.length > 0\n        }\"\n      >\n        {{ 'Minimum length is {{value}} characters' | translate: passwordMinLength }}\n        <span\n          class=\"e11-hidden md:e11-block material-icons-outlined e11-text-skin-success e11-ml-2 md-18\"\n          *ngIf=\"!fr.password.hasError('minlength') && fr.password.dirty && fr.password.value.length > 0\"\n        >\n          done\n        </span>\n      </p>\n      <p\n        class=\"e11-mb-4 e11-flex e11-items-center e11-h-6\"\n        [ngClass]=\"{\n          'e11-text-skin-error': fr.password.hasError('hasNumberError') || (formRegisterSubmitted && fr.password.invalid),\n          'e11-text-skin-success': !fr.password.hasError('hasNumberError') && fr.password.dirty && fr.password.value.length > 0\n        }\"\n      >\n        {{ \"Include 1 number\" | translate }}\n        <span\n          class=\"e11-hidden md:e11-block material-icons-outlined e11-text-skin-success e11-ml-2 md-18\"\n          *ngIf=\"!fr.password.hasError('hasNumberError') && fr.password.dirty && fr.password.value.length > 0\"\n        >\n          done\n        </span>\n      </p>\n      <p\n        class=\"e11-mb-4 e11-flex e11-items-center e11-h-6\"\n        [ngClass]=\"{\n          'e11-text-skin-error': fr.passwordConfirm.invalid || fr.password.value !== fr.passwordConfirm.value,\n          'e11-text-skin-success': fr.passwordConfirm.valid && fr.password.value === fr.passwordConfirm.value\n        }\"\n      >\n        {{ \"Password and confirmation must match\" | translate }}\n        <span\n          class=\"e11-hidden md:e11-block material-icons-outlined e11-text-skin-success e11-ml-2 md-18\"\n          *ngIf=\"fr.passwordConfirm.valid && !fr.passwordConfirm.hasError('passwordMatchError')\"\n        >\n          done\n        </span>\n      </p>\n    </div>\n  </div>\n  <e11-button id=\"submit_formRegister\" value=\"{{ 'Next' | translate }}\" [color]=\"'primary-accent'\" [type]=\"'submit'\" [display]=\"'block'\">\n  </e11-button>\n</form>\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$5.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$5.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$5.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2$5.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$5.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$5.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i4$3.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i7$1.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserComponent, decorators: [{
            type: Component,
            args: [{ selector: 'user-form', template: "<form id=\"form_register\" class=\"form register e11-mb-8\" [formGroup]=\"formRegister\" (ngSubmit)=\"onSubmitFormRegister()\" novalidate autocomplete=\"off\">\n  <div class=\"e11-w-full\">\n    <p class=\"e11-mb-4 e11-font-semibold\">{{ \"Next, please provide your name and create a good secure password.\" | translate }}</p>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"firstName\"\n      id=\"firstName\"\n      label=\"{{ 'First Name' | translate }}\"\n      [size]=\"'md'\"\n      [parentForm]=\"formRegister\"\n      formControlName=\"firstName\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [hasError]=\"(fr.firstName.errors && fr.firstName.dirty) || (fr.firstName.invalid && formRegisterSubmitted)\"\n    >\n      <e11-input-errors\n        [parentForm]=\"formRegister\"\n        [formControl]=\"fr.firstName\"\n        [formSubmitted]=\"formRegisterSubmitted\"\n        label=\"{{ 'First Name' | translate }}\"\n      >\n      </e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"lastName\"\n      id=\"lastName\"\n      label=\"{{ 'Last Name' | translate }}\"\n      value=\"lastName\"\n      [size]=\"'md'\"\n      [parentForm]=\"formRegister\"\n      formControlName=\"lastName\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [hasError]=\"(fr.lastName.errors && fr.lastName.dirty) || (fr.lastName.invalid && formRegisterSubmitted)\"\n    >\n      <e11-input-errors\n        [parentForm]=\"formRegister\"\n        [formControl]=\"fr.lastName\"\n        [formSubmitted]=\"formRegisterSubmitted\"\n        label=\"{{ 'Last Name' | translate }}\"\n      >\n      </e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'password'\"\n      name=\"password\"\n      id=\"password\"\n      label=\"{{ 'Password' | translate }}\"\n      [size]=\"'md'\"\n      [parentForm]=\"formRegister\"\n      formControlName=\"password\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [togglePassword]=\"true\"\n      [hasError]=\"(fr.password.errors && fr.password.dirty) || (fr.password.invalid && formRegisterSubmitted)\"\n    >\n      <e11-input-errors\n        [parentForm]=\"formRegister\"\n        [formControl]=\"fr.password\"\n        [formSubmitted]=\"formRegisterSubmitted\"\n        label=\"{{ 'Password' | translate }}\"\n      >\n      </e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div class=\"e11-w-full e11-mb-8\">\n    <e11-input\n      [type]=\"'password'\"\n      name=\"passwordConfirm\"\n      id=\"password_formConfirmPassword\"\n      label=\"{{ 'Confirm Password' | translate }}\"\n      [size]=\"'md'\"\n      [parentForm]=\"formRegister\"\n      formControlName=\"passwordConfirm\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [togglePassword]=\"true\"\n      [hasError]=\"fr.passwordConfirm.hasError('passwordMatchError')\"\n    >\n      <e11-input-errors\n        [parentForm]=\"formRegister\"\n        [formControl]=\"fr.passwordConfirm\"\n        [formSubmitted]=\"formRegisterSubmitted\"\n        label=\"{{ 'Password confirmation' | translate }}\"\n      >\n      </e11-input-errors>\n    </e11-input>\n\n    <div class=\"error-message-password-list e11-mt-0 e11-mb-4 e11-p-4 e11-border e11-border-skin-app-borders\">\n      <p class=\"e11-font-semibold e11-mb-4\">\n        {{ \"Your password must meet the following requirements:\" | translate }}\n      </p>\n      <p\n        class=\"e11-mb-4 e11-flex e11-items-center e11-h-6\"\n        [ngClass]=\"{\n          'e11-text-skin-error': fr.password.hasError('minlength') || (formRegisterSubmitted && fr.password.invalid),\n          'e11-text-skin-success': !fr.password.hasError('minlength') && fr.password.dirty && fr.password.value.length > 0\n        }\"\n      >\n        {{ 'Minimum length is {{value}} characters' | translate: passwordMinLength }}\n        <span\n          class=\"e11-hidden md:e11-block material-icons-outlined e11-text-skin-success e11-ml-2 md-18\"\n          *ngIf=\"!fr.password.hasError('minlength') && fr.password.dirty && fr.password.value.length > 0\"\n        >\n          done\n        </span>\n      </p>\n      <p\n        class=\"e11-mb-4 e11-flex e11-items-center e11-h-6\"\n        [ngClass]=\"{\n          'e11-text-skin-error': fr.password.hasError('hasNumberError') || (formRegisterSubmitted && fr.password.invalid),\n          'e11-text-skin-success': !fr.password.hasError('hasNumberError') && fr.password.dirty && fr.password.value.length > 0\n        }\"\n      >\n        {{ \"Include 1 number\" | translate }}\n        <span\n          class=\"e11-hidden md:e11-block material-icons-outlined e11-text-skin-success e11-ml-2 md-18\"\n          *ngIf=\"!fr.password.hasError('hasNumberError') && fr.password.dirty && fr.password.value.length > 0\"\n        >\n          done\n        </span>\n      </p>\n      <p\n        class=\"e11-mb-4 e11-flex e11-items-center e11-h-6\"\n        [ngClass]=\"{\n          'e11-text-skin-error': fr.passwordConfirm.invalid || fr.password.value !== fr.passwordConfirm.value,\n          'e11-text-skin-success': fr.passwordConfirm.valid && fr.password.value === fr.passwordConfirm.value\n        }\"\n      >\n        {{ \"Password and confirmation must match\" | translate }}\n        <span\n          class=\"e11-hidden md:e11-block material-icons-outlined e11-text-skin-success e11-ml-2 md-18\"\n          *ngIf=\"fr.passwordConfirm.valid && !fr.passwordConfirm.hasError('passwordMatchError')\"\n        >\n          done\n        </span>\n      </p>\n    </div>\n  </div>\n  <e11-button id=\"submit_formRegister\" value=\"{{ 'Next' | translate }}\" [color]=\"'primary-accent'\" [type]=\"'submit'\" [display]=\"'block'\">\n  </e11-button>\n</form>\n" }]
        }], ctorParameters: () => [{ type: BusinessRegistrationComponentStore }] });

const ERROR_HANDLING = {
    USER_NAME_MIN_LENGTH: 8,
    USER_NAME_MAX_LENGTH: 50,
    PASSWORD_MIN_LENGTH: 8,
    PASSWORD_MAX_LENGTH: 24,
    EMAIL_MIN_LENGTH: 7,
    EMAIL_MAX_LENGTH: 100,
    FIRST_NAME_MIN_LENGTH: 1,
    FIRST_NAME_MAX_LENGTH: 100,
    LAST_NAME_MIN_LENGTH: 1,
    LAST_NAME_MAX_LENGTH: 100,
    COMPANY_NAME_MIN_LENGTH: 1,
    COMPANY_NAME_MAX_LENGTH: 100,
    PHONE_MIN_LENGTH: 10,
    PHONE_MAX_LENGTH: 20,
    ADDRESS_MIN_LENGTH: 4,
    ADDRESS_MAX_LENGTH: 100,
    STATE_REQUIRED_LENGTH: 2,
    ZIP_MIN_LENGTH: 5,
    ZIP_MAX_LENGTH: 10,
    COUNTRY_REQUIRED_LENGTH: 2,
};

/**
 *
 *
 * @export
 * @class UserRegistrationModel
 * @implements {IBusinessRegistrationModel}
 */
class UserRegistrationModel {
    constructor(userType = UserType.Business, firstName, lastName, companyName, phone, address, city, state, zip, termsVersionAccepted = null, authTenantId) {
        this.userType = userType;
        this.firstName = firstName;
        this.lastName = lastName;
        this.companyName = companyName;
        this.phone = phone;
        this.address = address;
        this.city = city;
        this.state = state;
        this.zip = zip;
        this.termsVersionAccepted = termsVersionAccepted;
        this.authTenantId = authTenantId;
    }
}
class ConsumerRegistrationModel {
    constructor(userType = UserType.Consumer, firstName, lastName, tenantId, phoneNumber, termsVersionAccepted = null) {
        this.userType = userType;
        this.firstName = firstName;
        this.lastName = lastName;
        this.tenantId = tenantId;
        this.phoneNumber = phoneNumber;
        this.termsVersionAccepted = termsVersionAccepted;
    }
}

class SelectStates {
    constructor(value, name) {
        this.value = value;
        this.name = name;
    }
}

const DEFAULT_DEACTIVATED_PATH = 'account-deactivated';

class DataService {
    constructor(translate) {
        this.translate = translate;
        this.pleaseSelectState = '';
        translate.get('General.PleaseSelectFollowing').subscribe((res) => {
            this.pleaseSelectState = res;
        });
    }
    getStates() {
        return [
            // new SelectStates('', this.pleaseSelectState),
            new SelectStates('AL', 'Alabama'),
            new SelectStates('AK', 'Alaska'),
            new SelectStates('AZ', 'Arizona'),
            new SelectStates('AR', 'Arkansas'),
            new SelectStates('CA', 'California'),
            new SelectStates('CO', 'Colorado'),
            new SelectStates('CT', 'Connecticut'),
            new SelectStates('DE', 'Delaware'),
            new SelectStates('DC', 'District of Columbia'),
            new SelectStates('FL', 'Florida'),
            new SelectStates('GA', 'Georgia'),
            new SelectStates('HI', 'Hawaii'),
            new SelectStates('ID', 'Idaho'),
            new SelectStates('IL', 'Illinois'),
            new SelectStates('IN', 'Indiana'),
            new SelectStates('IA', 'Iowa'),
            new SelectStates('KS', 'Kansas'),
            new SelectStates('KY', 'Kentucky'),
            new SelectStates('LA', 'Louisiana'),
            new SelectStates('ME', 'Maine'),
            new SelectStates('MD', 'Maryland'),
            new SelectStates('MA', 'Massachusetts'),
            new SelectStates('MI', 'Michigan'),
            new SelectStates('MN', 'Minnesota'),
            new SelectStates('MS', 'Mississippi'),
            new SelectStates('MO', 'Missouri'),
            new SelectStates('MT', 'Montana'),
            new SelectStates('NE', 'Nebraska'),
            new SelectStates('NV', 'Nevada'),
            new SelectStates('NH', 'New Hampshire'),
            new SelectStates('NJ', 'New Jersey'),
            new SelectStates('NM', 'New Mexico'),
            new SelectStates('NY', 'New York'),
            new SelectStates('NC', 'North Carolina'),
            new SelectStates('ND', 'North Dakota'),
            new SelectStates('OH', 'Ohio'),
            new SelectStates('OK', 'Oklahoma'),
            new SelectStates('OR', 'Oregon'),
            new SelectStates('PA', 'Pennsylvania'),
            new SelectStates('RI', 'Rhode Island'),
            new SelectStates('SC', 'South Carolina'),
            new SelectStates('SD', 'South Dakota'),
            new SelectStates('TN', 'Tennessee'),
            new SelectStates('TX', 'Texas'),
            new SelectStates('UT', 'Utah'),
            new SelectStates('VT', 'Vermont'),
            new SelectStates('VA', 'Virginia'),
            new SelectStates('WA', 'Washington'),
            new SelectStates('WV', 'West Virginia'),
            new SelectStates('WI', 'Wisconsin'),
            new SelectStates('WY', 'Wyoming'),
        ];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DataService, deps: [{ token: i6$1.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DataService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i6$1.TranslateService }] });

class BusinessComponent {
    constructor(dataService, customValidator, store) {
        this.dataService = dataService;
        this.customValidator = customValidator;
        this.store = store;
        this.userRegistration = [];
        this.stateList = [];
        this.selectDefaultAddressState = 'Please Select';
        // Registration form for company info:
        this.formCompany = new FormGroup({
            name: new FormControl('', [Validators.required, this.customValidator.whitespaceValidator()]),
            address: new FormControl('', [Validators.required, this.customValidator.whitespaceValidator()]),
            address2: new FormControl('', []),
            city: new FormControl('', [Validators.required, this.customValidator.validateAddressCity()]),
            state: new FormControl('', [Validators.required, Validators.minLength(ERROR_HANDLING.STATE_REQUIRED_LENGTH)]),
            zip: new FormControl('', [Validators.required, this.customValidator.validateAddressZip()]),
            phone: new FormControl(null, [Validators.minLength(ERROR_HANDLING.PHONE_MIN_LENGTH)]),
        });
        this.formCompanySubmitted = false;
        this.loading = false;
        this.companyNameMinLength = { value: ERROR_HANDLING.COMPANY_NAME_MIN_LENGTH };
        this.zipMinLength = { value: ERROR_HANDLING.ZIP_MIN_LENGTH };
        this.zipMaxLength = { value: ERROR_HANDLING.ZIP_MAX_LENGTH };
        this.destroy$ = new Subject();
        this.workingFormData$ = this.store.workingBusinessForm$;
        this.stateList = this.dataService.getStates();
    }
    ngOnInit() {
        this.workingFormData$.pipe(takeUntil(this.destroy$)).subscribe((formData) => {
            if (formData) {
                this.formCompany.patchValue(formData);
            }
        });
    }
    ngOnDestroy() {
        this.store.saveWorkingBusinessForm(this.map());
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    get f() {
        return this.formCompany.controls;
    }
    /**
     *
     *
     * @memberof AuthenticationRegisterCompanyComponent
     */
    async onSubmitFormCompany() {
        this.formCompanySubmitted = true;
        if (this.formCompany.valid) {
            this.store.businessNext(this.map());
        }
        else {
            // Fire off a validation check on individual fields
            Object.keys(this.formCompany.controls).forEach((field) => {
                const control = this.formCompany.get(field);
                control?.updateValueAndValidity();
            });
        }
    }
    map() {
        const businessForm = {
            name: this.formCompany.value.name,
            address: this.formCompany.value.address,
            address2: this.formCompany.value.address2 || undefined,
            city: this.formCompany.value.city,
            state: this.formCompany.value.state,
            zip: this.formCompany.value.zip,
            phone: this.formCompany.value.phone,
        };
        return businessForm;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BusinessComponent, deps: [{ token: DataService }, { token: FormCustomValidationService }, { token: BusinessRegistrationComponentStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: BusinessComponent, selector: "business-form", ngImport: i0, template: "<!-- Company info -->\n<form class=\"form register\" [formGroup]=\"formCompany\" (ngSubmit)=\"onSubmitFormCompany()\" novalidate>\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"name\"\n      id=\"companyName_formCompany\"\n      label=\"{{ 'Company Name' | translate }}\"\n      [size]=\"'md'\"\n      [parentForm]=\"formCompany\"\n      formControlName=\"name\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [hasError]=\"(f.name.errors && f.name.dirty) || (f.name.invalid && formCompanySubmitted)\"\n    >\n      <e11-input-errors\n        [parentForm]=\"formCompany\"\n        [formControl]=\"f.name\"\n        [formSubmitted]=\"formCompanySubmitted\"\n        label=\"{{ 'Company Name' | translate }}\"\n      >\n      </e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"address\"\n      id=\"address_formCompany\"\n      label=\"{{ 'Address' | translate }}\"\n      [size]=\"'md'\"\n      [parentForm]=\"formCompany\"\n      formControlName=\"address\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [hasError]=\"(f.address.errors && f.address.dirty) || (f.address.invalid && formCompanySubmitted)\"\n    >\n      <e11-input-errors\n        [parentForm]=\"formCompany\"\n        [formControl]=\"f.address\"\n        [formSubmitted]=\"formCompanySubmitted\"\n        label=\"{{ 'Company Address' | translate }}\"\n      >\n      </e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"address2\"\n      id=\"address_formCompany2\"\n      label=\"{{ 'Address 2' | translate }}\"\n      [size]=\"'md'\"\n      [parentForm]=\"formCompany\"\n      formControlName=\"address2\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [hasError]=\"(f.address2.errors && f.address2.dirty) || (f.address2.invalid && formCompanySubmitted)\"\n    >\n      <e11-input-errors\n        [parentForm]=\"formCompany\"\n        [formControl]=\"f.address2\"\n        [formSubmitted]=\"formCompanySubmitted\"\n        label=\"{{ 'Company Address 2' | translate }}\"\n      >\n      </e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"city\"\n      id=\"city_formCompany\"\n      label=\"{{ 'City' | translate }}\"\n      [size]=\"'md'\"\n      [parentForm]=\"formCompany\"\n      formControlName=\"city\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [hasError]=\"(f.city.errors && f.city.dirty) || (f.city.invalid && formCompanySubmitted)\"\n    >\n      <e11-input-errors [parentForm]=\"formCompany\" [formControl]=\"f.city\" [formSubmitted]=\"formCompanySubmitted\" label=\"{{ 'City' | translate }}\">\n      </e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-select\n      name=\"select\"\n      id=\"id_select\"\n      label=\"{{ 'State' | translate }}\"\n      labelPosition=\"top\"\n      [required]=\"true\"\n      [size]=\"'md'\"\n      [options]=\"stateList\"\n      formControlName=\"state\"\n      selectMessage=\"{{ 'Please select' | translate }}\"\n      [hasError]=\"(f.state.errors && f.state.dirty) || (f.state.invalid && formCompanySubmitted)\"\n    >\n    </e11-select>\n    <e11-input-errors [parentForm]=\"formCompany\" [formControl]=\"f.state\" [formSubmitted]=\"formCompanySubmitted\" label=\"{{ 'State' | translate }}\">\n    </e11-input-errors>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"zip\"\n      id=\"zip_formCompany\"\n      label=\"{{ 'Zip' | translate }}\"\n      [size]=\"'md'\"\n      [parentForm]=\"formCompany\"\n      formControlName=\"zip\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [hasError]=\"(f.zip.errors && f.zip.dirty) || (f.zip.invalid && formCompanySubmitted)\"\n    >\n      <e11-input-errors [parentForm]=\"formCompany\" [formControl]=\"f.zip\" [formSubmitted]=\"formCompanySubmitted\" label=\"{{ 'Zip' | translate }}\">\n      </e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div>\n    <e11-phone-number\n      id=\"phone_formAccount\"\n      label=\"{{ 'Phone' | translate }}\"\n      formControlName=\"phone\"\n      inputClass=\"e11-mt-0\"\n      [countryCodes]=\"['US', 'GB']\"\n    >\n    </e11-phone-number>\n    <e11-input-errors [parentForm]=\"formCompany\" [formControl]=\"f.phone\" label=\"{{ 'Phone' | translate }}\"></e11-input-errors>\n  </div>\n\n  <e11-button\n    id=\"submit_formCompany\"\n    value=\"{{ loading ? 'Loading...' : ('Create Account' | translate) }}\"\n    [color]=\"'primary'\"\n    [type]=\"'submit'\"\n    [display]=\"'block'\"\n  >\n  </e11-button>\n</form>\n", styles: [""], dependencies: [{ kind: "directive", type: i2$5.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$5.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$5.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2$5.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$5.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$5.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i4$3.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i7.E11SelectComponent, selector: "e11-select", inputs: ["id", "name", "label", "size", "selectMessage", "labelClass", "inputClass", "containerClass", "parentForm", "formControlName", "options", "value", "hasError", "required", "disabled", "loading", "tooltipConfig", "labelTextOptional", "selectClass"], outputs: ["valueChange", "onValueChange"] }, { kind: "component", type: i8$1.E11PhoneNumberComponent, selector: "e11-phone-number", inputs: ["label", "id", "placeholder", "inputClass", "hasError", "disabled", "labelClass", "value", "country", "countryCodes", "showCountrySearch", "shouldValidate", "required", "labelSize", "formControlName", "parentForm", "loading", "tooltipConfig", "labelTextOptional"], outputs: ["valueUpdated"] }, { kind: "component", type: i7$1.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BusinessComponent, decorators: [{
            type: Component,
            args: [{ selector: 'business-form', template: "<!-- Company info -->\n<form class=\"form register\" [formGroup]=\"formCompany\" (ngSubmit)=\"onSubmitFormCompany()\" novalidate>\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"name\"\n      id=\"companyName_formCompany\"\n      label=\"{{ 'Company Name' | translate }}\"\n      [size]=\"'md'\"\n      [parentForm]=\"formCompany\"\n      formControlName=\"name\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [hasError]=\"(f.name.errors && f.name.dirty) || (f.name.invalid && formCompanySubmitted)\"\n    >\n      <e11-input-errors\n        [parentForm]=\"formCompany\"\n        [formControl]=\"f.name\"\n        [formSubmitted]=\"formCompanySubmitted\"\n        label=\"{{ 'Company Name' | translate }}\"\n      >\n      </e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"address\"\n      id=\"address_formCompany\"\n      label=\"{{ 'Address' | translate }}\"\n      [size]=\"'md'\"\n      [parentForm]=\"formCompany\"\n      formControlName=\"address\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [hasError]=\"(f.address.errors && f.address.dirty) || (f.address.invalid && formCompanySubmitted)\"\n    >\n      <e11-input-errors\n        [parentForm]=\"formCompany\"\n        [formControl]=\"f.address\"\n        [formSubmitted]=\"formCompanySubmitted\"\n        label=\"{{ 'Company Address' | translate }}\"\n      >\n      </e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"address2\"\n      id=\"address_formCompany2\"\n      label=\"{{ 'Address 2' | translate }}\"\n      [size]=\"'md'\"\n      [parentForm]=\"formCompany\"\n      formControlName=\"address2\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [hasError]=\"(f.address2.errors && f.address2.dirty) || (f.address2.invalid && formCompanySubmitted)\"\n    >\n      <e11-input-errors\n        [parentForm]=\"formCompany\"\n        [formControl]=\"f.address2\"\n        [formSubmitted]=\"formCompanySubmitted\"\n        label=\"{{ 'Company Address 2' | translate }}\"\n      >\n      </e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"city\"\n      id=\"city_formCompany\"\n      label=\"{{ 'City' | translate }}\"\n      [size]=\"'md'\"\n      [parentForm]=\"formCompany\"\n      formControlName=\"city\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [hasError]=\"(f.city.errors && f.city.dirty) || (f.city.invalid && formCompanySubmitted)\"\n    >\n      <e11-input-errors [parentForm]=\"formCompany\" [formControl]=\"f.city\" [formSubmitted]=\"formCompanySubmitted\" label=\"{{ 'City' | translate }}\">\n      </e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-select\n      name=\"select\"\n      id=\"id_select\"\n      label=\"{{ 'State' | translate }}\"\n      labelPosition=\"top\"\n      [required]=\"true\"\n      [size]=\"'md'\"\n      [options]=\"stateList\"\n      formControlName=\"state\"\n      selectMessage=\"{{ 'Please select' | translate }}\"\n      [hasError]=\"(f.state.errors && f.state.dirty) || (f.state.invalid && formCompanySubmitted)\"\n    >\n    </e11-select>\n    <e11-input-errors [parentForm]=\"formCompany\" [formControl]=\"f.state\" [formSubmitted]=\"formCompanySubmitted\" label=\"{{ 'State' | translate }}\">\n    </e11-input-errors>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"zip\"\n      id=\"zip_formCompany\"\n      label=\"{{ 'Zip' | translate }}\"\n      [size]=\"'md'\"\n      [parentForm]=\"formCompany\"\n      formControlName=\"zip\"\n      autocomplete=\"off\"\n      borderGlow=\"primary\"\n      [required]=\"true\"\n      [hasError]=\"(f.zip.errors && f.zip.dirty) || (f.zip.invalid && formCompanySubmitted)\"\n    >\n      <e11-input-errors [parentForm]=\"formCompany\" [formControl]=\"f.zip\" [formSubmitted]=\"formCompanySubmitted\" label=\"{{ 'Zip' | translate }}\">\n      </e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div>\n    <e11-phone-number\n      id=\"phone_formAccount\"\n      label=\"{{ 'Phone' | translate }}\"\n      formControlName=\"phone\"\n      inputClass=\"e11-mt-0\"\n      [countryCodes]=\"['US', 'GB']\"\n    >\n    </e11-phone-number>\n    <e11-input-errors [parentForm]=\"formCompany\" [formControl]=\"f.phone\" label=\"{{ 'Phone' | translate }}\"></e11-input-errors>\n  </div>\n\n  <e11-button\n    id=\"submit_formCompany\"\n    value=\"{{ loading ? 'Loading...' : ('Create Account' | translate) }}\"\n    [color]=\"'primary'\"\n    [type]=\"'submit'\"\n    [display]=\"'block'\"\n  >\n  </e11-button>\n</form>\n" }]
        }], ctorParameters: () => [{ type: DataService }, { type: FormCustomValidationService }, { type: BusinessRegistrationComponentStore }] });

class RegistrationBusiness {
    constructor(store, registrationService, termsService, _sanitizer, logger, errorHandler) {
        this.store = store;
        this.registrationService = registrationService;
        this.termsService = termsService;
        this._sanitizer = _sanitizer;
        this.logger = logger;
        this.errorHandler = errorHandler;
        this.onSubmit = new EventEmitter();
        this.onError = new EventEmitter();
        this.destroy$ = new Subject();
        this.loading = false;
        this.displayPager$ = this.store.displayPager$;
        this.registrationPageEnum = RegistrationPage;
        this.registrationComplete$ = this.store.registrationComplete$;
    }
    ngOnInit() {
        this.termsService
            .getMostRecentTerms()
            .pipe(takeUntil(this.destroy$))
            .subscribe((termsModels) => {
            this.termsModel = termsModels[0];
            this.termsOfUse = this._sanitizer.bypassSecurityTrustHtml(termsModels[0].terms);
        });
        this.registrationComplete$.pipe(takeUntil(this.destroy$)).subscribe((registrationModel) => {
            if (registrationModel) {
                this.registrationModel = { ...registrationModel, termsVersionAccepted: this.termsModel?.version || null };
                this.captchaRef.execute();
            }
        });
    }
    async resolved(captchaResponse) {
        if (captchaResponse) {
            await this.processSubmission(captchaResponse);
            this.captchaRef?.reset();
        }
    }
    async processSubmission(captchaResponse) {
        this.loading = true;
        this.logger.log('registration model', this.registrationModel);
        if (this.registrationModel) {
            try {
                const result = await this.registrationService.registerBusinessUserV2(this.registrationModel, captchaResponse);
                this.onSubmit.emit({ appUser: result.appUser, authToken: result.authToken });
            }
            catch (err) {
                this.loading = false;
                this.errorHandler.handleError(err, { alertUser: true });
                this.onError.emit(err);
            }
        }
        else {
            this.logger.error('The registration model is empty, something went wrong');
        }
        this.loading = false;
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RegistrationBusiness, deps: [{ token: BusinessRegistrationComponentStore }, { token: RegistrationService }, { token: i6.TermsService }, { token: i4$4.DomSanitizer }, { token: i1.E11Logger }, { token: i1.E11ErrorHandlerService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: RegistrationBusiness, selector: "sdk-registration-business", outputs: { onSubmit: "onSubmit", onError: "onError" }, providers: [BusinessRegistrationComponentStore], viewQueries: [{ propertyName: "captchaRef", first: true, predicate: ["captchaRef"], descendants: true }], ngImport: i0, template: "<ng-container *ngrxLet=\"displayPager$ as displayPager\">\n  <ng-container *ngIf=\"displayPager.getCurrent()?.registrationPage === registrationPageEnum.Email\">\n    <email-form></email-form>\n  </ng-container>\n\n  <ng-container *ngIf=\"displayPager.getCurrent()?.registrationPage === registrationPageEnum.User\">\n    <user-form></user-form>\n    <div class=\"e11-w-full e11-text-xs e11-text-center\">\n      <p>\n        <span class=\"e11-text-skin-primary-accent e11-cursor-pointer\" (click)=\"displayPager.previous()\">{{ \"Previous\" | translate }}</span>\n      </p>\n    </div>\n  </ng-container>\n\n  <ng-container *ngIf=\"displayPager.getCurrent()?.registrationPage === registrationPageEnum.Business\">\n    <business-form #businessForm></business-form>\n    <div class=\"e11-w-full e11-text-xs e11-text-center e11-pt-2\">\n      <p>\n        <span class=\"e11-text-skin-primary-accent e11-cursor-pointer\" (click)=\"displayPager.previous()\">{{ \"Previous\" | translate }}</span>\n      </p>\n    </div>\n  </ng-container>\n\n  <div class=\"e11-w-full e11-text-xs e11-text-center\" *ngIf=\"displayPager.getCurrent()?.registrationPage === registrationPageEnum.Business\">\n    <p>\n      {{ \"By continuing you are agreeing to our\" | translate }}\n      <span class=\"e11-text-skin-primary-accent e11-cursor-pointer\" (click)=\"modalTerms.open()\">{{ \"Terms of Use\" | translate }}</span\n      >.\n    </p>\n  </div>\n</ng-container>\n\n<re-captcha #captchaRef=\"reCaptcha\" size=\"invisible\" (resolved)=\"resolved($event)\"></re-captcha>\n\n<e11-loader-dots\n  *ngIf=\"loading\"\n  [size]=\"'md'\"\n  [fullScreen]=\"true\"\n  [color]=\"'e11-bg-skin-primary-accent'\"\n  [hasBackdrop]=\"true\"\n  [fontColor]=\"'e11-text-white'\"\n  label=\"{{ 'Creating account...' | translate }}\"\n></e11-loader-dots>\n\n<e11-modal\n  #modalTerms\n  [title]=\"'Terms of Use' | translate\"\n  [showHeader]=\"true\"\n  [hideCloseButton]=\"false\"\n  [width]=\"'lg'\"\n  [bodyClassOverrides]=\"'e11-h-[55vh]'\"\n>\n  <div modal-body>\n    <ng-container *ngIf=\"termsOfUse\">\n      <div [innerHTML]=\"termsOfUse\"></div>\n    </ng-container>\n  </div>\n\n  <div modal-footer>\n    <div class=\"e11-text-center\">\n      <e11-button [type]=\"'button'\" value=\"{{ 'Close' | translate }}\" color=\"neutral\" (click)=\"modalTerms.close()\"> </e11-button>\n    </div>\n  </div>\n</e11-modal>\n", styles: [".form.email{margin-bottom:2rem}.form.register{position:relative;margin-bottom:0;transition:all .25s ease-in-out 0s;opacity:0;max-height:0}.form.register.active{margin-bottom:4rem;transition:all .25s ease-in-out 0s;opacity:1;max-height:1000px}.email-unavailable{display:flex;flex-direction:column;padding:0;opacity:0;max-height:0}.email-unavailable.active{padding:2rem;opacity:1;max-height:400px}.error-message-password-list{position:relative;margin-top:-1.5rem;margin-bottom:1rem}.error-message-password-list .error-message{line-height:1.5rem}.error-message-password-list .error-message i{margin-left:5px;opacity:0;transition:opacity .4s ease-in-out 0s}.error-message-password-list .error-message.pass i{opacity:1;transition:opacity .4s ease-in-out 0s}\n"], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i7$2.RecaptchaComponent, selector: "re-captcha", inputs: ["id", "siteKey", "theme", "type", "size", "tabIndex", "badge", "errorMode"], outputs: ["resolved", "error", "errored"], exportAs: ["reCaptcha"] }, { kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i2$4.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i1$1.E11ModalComponent, selector: "e11-modal", inputs: ["title", "width", "bodyHeight", "titleAlign", "hideCloseButton", "closer", "bodyClassOverrides", "bodyClass", "modalClassOverrides", "modalClass", "contentClassOverrides", "contentClass", "headerClassOverrides", "headerClass", "footerClassOverrides", "footerClass", "showFooter", "showHeader", "darkMode", "closeOnEscape", "closeOnClickOutside", "headerCTAs", "hasBackdrop", "backdropStyle"], outputs: ["modalOpened", "onModalOpened", "modalClosed", "onModalClosed", "headerCTAClicked", "onHeaderCTAClicked"] }, { kind: "directive", type: i4.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: EmailComponent, selector: "email-form" }, { kind: "component", type: UserComponent, selector: "user-form" }, { kind: "component", type: BusinessComponent, selector: "business-form" }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RegistrationBusiness, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-registration-business', providers: [BusinessRegistrationComponentStore], template: "<ng-container *ngrxLet=\"displayPager$ as displayPager\">\n  <ng-container *ngIf=\"displayPager.getCurrent()?.registrationPage === registrationPageEnum.Email\">\n    <email-form></email-form>\n  </ng-container>\n\n  <ng-container *ngIf=\"displayPager.getCurrent()?.registrationPage === registrationPageEnum.User\">\n    <user-form></user-form>\n    <div class=\"e11-w-full e11-text-xs e11-text-center\">\n      <p>\n        <span class=\"e11-text-skin-primary-accent e11-cursor-pointer\" (click)=\"displayPager.previous()\">{{ \"Previous\" | translate }}</span>\n      </p>\n    </div>\n  </ng-container>\n\n  <ng-container *ngIf=\"displayPager.getCurrent()?.registrationPage === registrationPageEnum.Business\">\n    <business-form #businessForm></business-form>\n    <div class=\"e11-w-full e11-text-xs e11-text-center e11-pt-2\">\n      <p>\n        <span class=\"e11-text-skin-primary-accent e11-cursor-pointer\" (click)=\"displayPager.previous()\">{{ \"Previous\" | translate }}</span>\n      </p>\n    </div>\n  </ng-container>\n\n  <div class=\"e11-w-full e11-text-xs e11-text-center\" *ngIf=\"displayPager.getCurrent()?.registrationPage === registrationPageEnum.Business\">\n    <p>\n      {{ \"By continuing you are agreeing to our\" | translate }}\n      <span class=\"e11-text-skin-primary-accent e11-cursor-pointer\" (click)=\"modalTerms.open()\">{{ \"Terms of Use\" | translate }}</span\n      >.\n    </p>\n  </div>\n</ng-container>\n\n<re-captcha #captchaRef=\"reCaptcha\" size=\"invisible\" (resolved)=\"resolved($event)\"></re-captcha>\n\n<e11-loader-dots\n  *ngIf=\"loading\"\n  [size]=\"'md'\"\n  [fullScreen]=\"true\"\n  [color]=\"'e11-bg-skin-primary-accent'\"\n  [hasBackdrop]=\"true\"\n  [fontColor]=\"'e11-text-white'\"\n  label=\"{{ 'Creating account...' | translate }}\"\n></e11-loader-dots>\n\n<e11-modal\n  #modalTerms\n  [title]=\"'Terms of Use' | translate\"\n  [showHeader]=\"true\"\n  [hideCloseButton]=\"false\"\n  [width]=\"'lg'\"\n  [bodyClassOverrides]=\"'e11-h-[55vh]'\"\n>\n  <div modal-body>\n    <ng-container *ngIf=\"termsOfUse\">\n      <div [innerHTML]=\"termsOfUse\"></div>\n    </ng-container>\n  </div>\n\n  <div modal-footer>\n    <div class=\"e11-text-center\">\n      <e11-button [type]=\"'button'\" value=\"{{ 'Close' | translate }}\" color=\"neutral\" (click)=\"modalTerms.close()\"> </e11-button>\n    </div>\n  </div>\n</e11-modal>\n", styles: [".form.email{margin-bottom:2rem}.form.register{position:relative;margin-bottom:0;transition:all .25s ease-in-out 0s;opacity:0;max-height:0}.form.register.active{margin-bottom:4rem;transition:all .25s ease-in-out 0s;opacity:1;max-height:1000px}.email-unavailable{display:flex;flex-direction:column;padding:0;opacity:0;max-height:0}.email-unavailable.active{padding:2rem;opacity:1;max-height:400px}.error-message-password-list{position:relative;margin-top:-1.5rem;margin-bottom:1rem}.error-message-password-list .error-message{line-height:1.5rem}.error-message-password-list .error-message i{margin-left:5px;opacity:0;transition:opacity .4s ease-in-out 0s}.error-message-password-list .error-message.pass i{opacity:1;transition:opacity .4s ease-in-out 0s}\n"] }]
        }], ctorParameters: () => [{ type: BusinessRegistrationComponentStore }, { type: RegistrationService }, { type: i6.TermsService }, { type: i4$4.DomSanitizer }, { type: i1.E11Logger }, { type: i1.E11ErrorHandlerService }], propDecorators: { captchaRef: [{
                type: ViewChild,
                args: ['captchaRef']
            }], onSubmit: [{
                type: Output
            }], onError: [{
                type: Output
            }] } });

class PlatformAdminRegistrationInviteService {
    constructor(configProvider) {
        this.configProvider = configProvider;
        this.restClient = this.createRestClient();
    }
    deleteInviteProvisioned(invite, customerKey) {
        throw new Error('Method not implemented.');
    }
    getProvisionedInvites(clientCustomerKey) {
        throw new Error('Method not implemented.');
    }
    async checkForExistingInvitation(email, customerKey) {
        const response = await firstValueFrom(this.restClient.post(`platform-admin/invitations/${customerKey}/${email}/exists`, {}));
        return response?.data;
    }
    async inviteUser(invite, customerKey) {
        await lastValueFrom(this.restClient.post(`platform-admin/invitations/${customerKey}/create`, invite));
    }
    async resendInvite(invite, customerKey) {
        await lastValueFrom(this.restClient.post(`platform-admin/invitations/${customerKey}/${invite.email}/resend`, {}));
    }
    async resendInviteProvisioned(invite, customerKey) {
        await lastValueFrom(this.restClient.post(`platform-admin/invitations/${customerKey}/${invite.email}/resend/${invite.customerKey}`, {}));
    }
    async deleteInvite(invite, customerKey) {
        await lastValueFrom(this.restClient.delete(`platform-admin/invitations/${customerKey}/${invite.email}/delete`));
    }
    getInvitedUsers(customerKey) {
        return this.restClient.get(`platform-admin/invitations/${customerKey}`).pipe(map$1((item) => item.data));
    }
    /**
     * @param {IPlatformAdminRegistrationClientModel} user
     * @returns {Promise<string>}
     */
    async createPlatformAdminUser(user, authToken) {
        const response = await firstValueFrom(this.restClient.post('registration/platform-admin', user));
        return response.data;
    }
    createRestClient() {
        if (!this.configProvider.config.registrationBaseURL)
            throw e11Error(configMissingErr('registrationBaseURL'));
        if (!this.configProvider.config.token$)
            throw e11Error(configMissingErr('token$'));
        return new RestApiClient({
            baseUrl: this.configProvider.config.registrationBaseURL,
            token: this.configProvider.config.token$.pipe(filter$1(isNotNil)),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminRegistrationInviteService, deps: [{ token: BaseRegistrationConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminRegistrationInviteService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminRegistrationInviteService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BaseRegistrationConfigProvider }] });
const configMissingErr = (field) => ({
    title: 'Configuration Error',
    message: `Missing configuration, ${field} is undefined. Configure Registration module with an IRegistrationConfig model`,
    type: 'registration/config-error',
});

class IRegistrationInviteService {
}

class CreateBusinessUserInviteComponent {
    constructor(logger, formBuilder, customValidator, authService, registrationInviteService, notificationsService, tenantBootstrapRepository) {
        this.logger = logger;
        this.formBuilder = formBuilder;
        this.customValidator = customValidator;
        this.authService = authService;
        this.registrationInviteService = registrationInviteService;
        this.notificationsService = notificationsService;
        this.tenantBootstrapRepository = tenantBootstrapRepository;
        this.submitInvite = new EventEmitter();
        this.cancelInvite = new EventEmitter();
        this.departmentOptions = [];
        this.roleOptions = [];
        this.userEmailInUse = false;
        this.loading = false;
    }
    ngOnInit() {
        if (!this.availableRoles || this.availableRoles.length < 1)
            throw new Error('availableRoles is required.');
        this.loadSelectOptions();
        this.createForm();
    }
    ngOnChanges(changes) {
        if (changes.customerKey?.currentValue || changes.availableRoles.currentValue || changes.departments.currentValue) {
            this.createForm();
            this.loadSelectOptions();
        }
    }
    get f() {
        return this.formInvite.controls;
    }
    createForm() {
        this.formInvite = this.formBuilder.group({
            firstName: new FormControl('', [Validators.required, this.customValidator.nameValidator(), this.customValidator.whitespaceValidator()]),
            lastName: new FormControl('', [Validators.required, this.customValidator.nameValidator(), this.customValidator.whitespaceValidator()]),
            email: new FormControl({ value: '', disabled: false }, [Validators.required, this.customValidator.emailValidator()]),
            companyRole: new FormControl('', [Validators.maxLength(100)]),
            department: new FormControl('', []),
            roles: new FormControl([], [Validators.required]),
        });
    }
    loadSelectOptions() {
        this.departmentOptions = [];
        if (this.departments) {
            this.departments.forEach((d) => {
                this.departmentOptions.push({ name: d, value: d });
            });
        }
    }
    cancel() {
        this.resetState();
        this.cancelInvite.emit();
    }
    async onSubmit() {
        if (this.formInvite && !this.formInvite.valid) {
            this.formInvite.updateValueAndValidity();
            Validation.validateAll(this.formInvite);
        }
        else {
            if (this.formInvite && this.formInvite.valid && this.customerKey && this.formInvite.dirty) {
                const cleanEmail = this.formInvite.value.email.trim().toLowerCase();
                this.loading = true;
                const adminTenantKey = this.bootstrapTenantKey ? await this.authService.getTenantId() : undefined;
                try {
                    if (this.bootstrapTenantKey) {
                        const bootstrap = await firstValueFrom(this.tenantBootstrapRepository.getOrError(this.bootstrapTenantKey));
                        this.authService.setTenantId(bootstrap.auth.tenantId);
                    }
                    this.userEmailInUse = await this.checkForExistingEmail(cleanEmail);
                }
                catch (err) {
                    this.showGeneralError();
                    return;
                }
                finally {
                    this.loading = false;
                    if (adminTenantKey)
                        this.authService.setTenantId(adminTenantKey);
                }
                if (this.userEmailInUse)
                    return;
                const invite = {
                    firstName: this.formInvite.value.firstName,
                    lastName: this.formInvite.value.lastName,
                    email: cleanEmail,
                    roles: this.formInvite.value.roles,
                    additionalUserAttributes: {
                        companyRole: this.formInvite.value.companyRole,
                        department: this.formInvite.value.department,
                    },
                    customerKey: this.customerKey,
                };
                this.resetState();
                this.submitInvite.emit(invite);
                return;
            }
        }
        // this.markAllFieldsAsDirty()
    }
    markAllFieldsAsDirty() {
        this.formInvite?.markAllAsTouched();
        for (let controlsKey in this.formInvite?.controls) {
            this.formInvite?.controls[controlsKey].markAsDirty();
        }
        this.formInvite?.updateValueAndValidity();
    }
    async checkForExistingEmail(email) {
        const existsInAuth = await this.checkAuthForExistingEmail(email);
        this.logger.log(`Invite email exists in auth: ${existsInAuth}`);
        const existsInInvite = await this.checkForExistingInvitation(email);
        this.logger.log(`Invite email exists in existing invite: ${existsInInvite}`);
        return existsInAuth || existsInInvite;
    }
    async checkForExistingInvitation(email) {
        const result = await this.registrationInviteService.checkForExistingInvitation(email);
        return result.invitationExists;
    }
    async checkAuthForExistingEmail(email) {
        let { res, err } = await this.authService.fetchSignInMethodsForEmail(email.trim());
        if (err)
            return true;
        if (res && res.length > 0)
            return true;
        return false;
    }
    showGeneralError() {
        const message = {
            title: 'Error',
            message: `An error occurred reaching the server.`,
            type: 'error',
            autoClose: true,
            dismissOnRouteChange: true,
        };
        this.notificationsService.popNotificationMessage(message);
    }
    resetState() {
        this.formInvite?.reset();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CreateBusinessUserInviteComponent, deps: [{ token: i1.E11Logger }, { token: i2$5.FormBuilder }, { token: FormCustomValidationService }, { token: i2$1.IAuthService }, { token: IRegistrationInviteService }, { token: i3$4.E11NotificationsService }, { token: i2$6.TenantBootstrapRepository }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CreateBusinessUserInviteComponent, selector: "sdk-create-business-user-invite", inputs: { customerKey: "customerKey", bootstrapTenantKey: "bootstrapTenantKey", availableRoles: "availableRoles", departments: "departments", authToken: "authToken" }, outputs: { submitInvite: "submitInvite", cancelInvite: "cancelInvite" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"e11-h-full e11-divide-y e11-divide-gray-200 e11-flex e11-flex-col e11-bg-white e11-shadow-xl\">\n  <div class=\"e11-flex-1 e11-h-0 e11-overflow-y-auto e11-overscroll-none\">\n    <div class=\"e11-py-6 e11-px-4 e11-bg-skin-primary sm:e11-px-6\">\n      <div class=\"e11-flex e11-items-center e11-justify-between e11-mb-2\">\n        <h3 class=\"e11-text-skin-white\" id=\"slide-over-title\">\n          {{ \"Invite User\" | translate }}\n        </h3>\n        <div class=\"e11-ml-3 e11-h-7 e11-flex e11-items-center\">\n          <button\n            (click)=\"cancelInvite.emit()\"\n            type=\"button\"\n            class=\"e11-flex e11-items-center e11-justify-center e11-bg-skin-primary e11-h-6 e11-w-6 e11-rounded-md e11-text-white/70 hover:e11-text-white focus:e11-outline-none focus:e11-ring-1 focus:e11-ring-white hover:e11-ring-1 hover:e11-ring-white\"\n          >\n            <span class=\"e11-sr-only\">Close panel</span>\n            <span class=\"material-icons-outlined md-18\"> close </span>\n          </button>\n        </div>\n      </div>\n    </div>\n\n    <form *ngIf=\"formInvite\" class=\"e11-py-6 e11-px-4\" [formGroup]=\"formInvite\" novalidate>\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"firstName\"\n          id=\"firstName\"\n          label=\"{{ 'First Name' | translate }}\"\n          [size]=\"'md'\"\n          [required]=\"true\"\n          [borderGlow]=\"'primary'\"\n          [parentForm]=\"formInvite\"\n          [autofocus]=\"false\"\n          formControlName=\"firstName\"\n          autocomplete=\"off\"\n          [hasError]=\"f.firstName.invalid && f.firstName.dirty\"\n        >\n          <e11-input-errors [parentForm]=\"formInvite\" [formControl]=\"f.firstName\" label=\"{{ 'First Name' | translate }}\"></e11-input-errors>\n        </e11-input>\n      </div>\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"lastName\"\n          id=\"lastName\"\n          label=\"{{ 'Last Name' | translate }}\"\n          [size]=\"'md'\"\n          [required]=\"true\"\n          [borderGlow]=\"'primary'\"\n          [parentForm]=\"formInvite\"\n          [autofocus]=\"false\"\n          formControlName=\"lastName\"\n          autocomplete=\"off\"\n          [hasError]=\"f.lastName.invalid && f.lastName.dirty\"\n        >\n          <e11-input-errors [parentForm]=\"formInvite\" [formControl]=\"f.lastName\" label=\"{{ 'Last Name' | translate }}\"></e11-input-errors>\n        </e11-input>\n      </div>\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'email'\"\n          name=\"email\"\n          id=\"email_formLogin_body\"\n          label=\"{{ 'Email' | translate }}\"\n          [size]=\"'md'\"\n          [borderGlow]=\"'primary'\"\n          [required]=\"true\"\n          [parentForm]=\"formInvite\"\n          [autofocus]=\"false\"\n          formControlName=\"email\"\n          autocomplete=\"off\"\n          [hasError]=\"f.email.invalid && f.email.dirty\"\n        >\n          <e11-input-errors [parentForm]=\"formInvite\" [formControl]=\"f.email\" label=\"{{ 'Email' | translate }}\"></e11-input-errors>\n        </e11-input>\n        <div\n          class=\"e11-rounded-md e11-bg-yellow-50 e11-p-4\"\n          *ngIf=\"userEmailInUse\"\n          [ngClass]=\"{ 'e11-opacity-100': userEmailInUse, 'e11-opacity-0': !userEmailInUse }\"\n        >\n          <div class=\"e11-flex\">\n            <div class=\"e11-flex-shrink-0\">\n              <svg\n                class=\"e11-h-5 e11-w-5 e11-text-yellow-400\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                viewBox=\"0 0 20 20\"\n                fill=\"currentColor\"\n                aria-hidden=\"true\"\n              >\n                <path\n                  fill-rule=\"evenodd\"\n                  d=\"M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z\"\n                  clip-rule=\"evenodd\"\n                />\n              </svg>\n            </div>\n            <div class=\"e11-ml-3\">\n              <div class=\"e11-text-sm\">\n                <p>{{ \"It appears that we already have an account using this email address.\" | translate }}</p>\n              </div>\n              <div class=\"e11-mt-4\"></div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"e11-w-full\">\n        <e11-multi-select\n          id=\"rolesSelect\"\n          name=\"rolesSelect\"\n          [label]=\"'Roles' | translate\"\n          [options]=\"availableRoles!\"\n          selectMessage=\"Select Roles\"\n          [hasError]=\"f.roles.invalid && f.roles.dirty\"\n          [required]=\"true\"\n          formControlName=\"roles\"\n        ></e11-multi-select>\n        <e11-input-errors [parentForm]=\"formInvite\" [formControl]=\"f.roles\" label=\"{{ 'Roles' | translate }}\"></e11-input-errors>\n      </div>\n\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"companyRole\"\n          id=\"companyRole\"\n          label=\"{{ 'Company Role' | translate }}\"\n          [size]=\"'md'\"\n          [borderGlow]=\"'primary'\"\n          [parentForm]=\"formInvite\"\n          [autofocus]=\"false\"\n          formControlName=\"companyRole\"\n          autocomplete=\"off\"\n          [hasError]=\"f.companyRole.invalid && f.companyRole.dirty\"\n        >\n          <e11-input-errors [parentForm]=\"formInvite\" [formControl]=\"f.companyRole\" label=\"{{ 'Company Role' | translate }}\"></e11-input-errors>\n        </e11-input>\n      </div>\n\n      <div class=\"e11-w-full e11-pb-6\" *ngIf=\"departments && departments.length\">\n        <e11-select\n          name=\"departments\"\n          id=\"departments\"\n          [label]=\"'Department' | translate\"\n          [required]=\"false\"\n          [options]=\"departmentOptions\"\n          formControlName=\"department\"\n        >\n        </e11-select>\n      </div>\n    </form>\n  </div>\n\n  <div class=\"e11-flex e11-justify-end e11-p-4 e11-flex-shrink-0\">\n    <e11-button [value]=\"'Cancel' | translate\" [color]=\"'neutral'\" [ghost]=\"true\" (click)=\"cancel()\" [buttonGroup]=\"true\"> </e11-button>\n\n    <e11-button\n      (click)=\"onSubmit()\"\n      value=\"{{ loading ? 'Inviting...' : ('Invite User' | translate) }}\"\n      [color]=\"'primary-accent'\"\n      [disabled]=\"loading\"\n    >\n    </e11-button>\n  </div>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$5.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$5.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$5.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2$5.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$5.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$5.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i4$3.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i7.E11SelectComponent, selector: "e11-select", inputs: ["id", "name", "label", "size", "selectMessage", "labelClass", "inputClass", "containerClass", "parentForm", "formControlName", "options", "value", "hasError", "required", "disabled", "loading", "tooltipConfig", "labelTextOptional", "selectClass"], outputs: ["valueChange", "onValueChange"] }, { kind: "component", type: i12.E11MultiSelectComponent, selector: "e11-multi-select", inputs: ["id", "name", "label", "selectMessage", "labelClassOverrides", "checkboxClassOverrides", "inputClass", "containerClass", "parentForm", "formControlName", "options", "value", "hasError", "required", "disabled", "loading", "tooltipConfig", "labelTextOptional", "searchable", "searchResultsEmpty", "isDropdownSelect", "dropdownContainerClass", "inputClassOverrides"], outputs: ["valueChange"] }, { kind: "component", type: i7$1.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CreateBusinessUserInviteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-create-business-user-invite', template: "<div class=\"e11-h-full e11-divide-y e11-divide-gray-200 e11-flex e11-flex-col e11-bg-white e11-shadow-xl\">\n  <div class=\"e11-flex-1 e11-h-0 e11-overflow-y-auto e11-overscroll-none\">\n    <div class=\"e11-py-6 e11-px-4 e11-bg-skin-primary sm:e11-px-6\">\n      <div class=\"e11-flex e11-items-center e11-justify-between e11-mb-2\">\n        <h3 class=\"e11-text-skin-white\" id=\"slide-over-title\">\n          {{ \"Invite User\" | translate }}\n        </h3>\n        <div class=\"e11-ml-3 e11-h-7 e11-flex e11-items-center\">\n          <button\n            (click)=\"cancelInvite.emit()\"\n            type=\"button\"\n            class=\"e11-flex e11-items-center e11-justify-center e11-bg-skin-primary e11-h-6 e11-w-6 e11-rounded-md e11-text-white/70 hover:e11-text-white focus:e11-outline-none focus:e11-ring-1 focus:e11-ring-white hover:e11-ring-1 hover:e11-ring-white\"\n          >\n            <span class=\"e11-sr-only\">Close panel</span>\n            <span class=\"material-icons-outlined md-18\"> close </span>\n          </button>\n        </div>\n      </div>\n    </div>\n\n    <form *ngIf=\"formInvite\" class=\"e11-py-6 e11-px-4\" [formGroup]=\"formInvite\" novalidate>\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"firstName\"\n          id=\"firstName\"\n          label=\"{{ 'First Name' | translate }}\"\n          [size]=\"'md'\"\n          [required]=\"true\"\n          [borderGlow]=\"'primary'\"\n          [parentForm]=\"formInvite\"\n          [autofocus]=\"false\"\n          formControlName=\"firstName\"\n          autocomplete=\"off\"\n          [hasError]=\"f.firstName.invalid && f.firstName.dirty\"\n        >\n          <e11-input-errors [parentForm]=\"formInvite\" [formControl]=\"f.firstName\" label=\"{{ 'First Name' | translate }}\"></e11-input-errors>\n        </e11-input>\n      </div>\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"lastName\"\n          id=\"lastName\"\n          label=\"{{ 'Last Name' | translate }}\"\n          [size]=\"'md'\"\n          [required]=\"true\"\n          [borderGlow]=\"'primary'\"\n          [parentForm]=\"formInvite\"\n          [autofocus]=\"false\"\n          formControlName=\"lastName\"\n          autocomplete=\"off\"\n          [hasError]=\"f.lastName.invalid && f.lastName.dirty\"\n        >\n          <e11-input-errors [parentForm]=\"formInvite\" [formControl]=\"f.lastName\" label=\"{{ 'Last Name' | translate }}\"></e11-input-errors>\n        </e11-input>\n      </div>\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'email'\"\n          name=\"email\"\n          id=\"email_formLogin_body\"\n          label=\"{{ 'Email' | translate }}\"\n          [size]=\"'md'\"\n          [borderGlow]=\"'primary'\"\n          [required]=\"true\"\n          [parentForm]=\"formInvite\"\n          [autofocus]=\"false\"\n          formControlName=\"email\"\n          autocomplete=\"off\"\n          [hasError]=\"f.email.invalid && f.email.dirty\"\n        >\n          <e11-input-errors [parentForm]=\"formInvite\" [formControl]=\"f.email\" label=\"{{ 'Email' | translate }}\"></e11-input-errors>\n        </e11-input>\n        <div\n          class=\"e11-rounded-md e11-bg-yellow-50 e11-p-4\"\n          *ngIf=\"userEmailInUse\"\n          [ngClass]=\"{ 'e11-opacity-100': userEmailInUse, 'e11-opacity-0': !userEmailInUse }\"\n        >\n          <div class=\"e11-flex\">\n            <div class=\"e11-flex-shrink-0\">\n              <svg\n                class=\"e11-h-5 e11-w-5 e11-text-yellow-400\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                viewBox=\"0 0 20 20\"\n                fill=\"currentColor\"\n                aria-hidden=\"true\"\n              >\n                <path\n                  fill-rule=\"evenodd\"\n                  d=\"M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z\"\n                  clip-rule=\"evenodd\"\n                />\n              </svg>\n            </div>\n            <div class=\"e11-ml-3\">\n              <div class=\"e11-text-sm\">\n                <p>{{ \"It appears that we already have an account using this email address.\" | translate }}</p>\n              </div>\n              <div class=\"e11-mt-4\"></div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"e11-w-full\">\n        <e11-multi-select\n          id=\"rolesSelect\"\n          name=\"rolesSelect\"\n          [label]=\"'Roles' | translate\"\n          [options]=\"availableRoles!\"\n          selectMessage=\"Select Roles\"\n          [hasError]=\"f.roles.invalid && f.roles.dirty\"\n          [required]=\"true\"\n          formControlName=\"roles\"\n        ></e11-multi-select>\n        <e11-input-errors [parentForm]=\"formInvite\" [formControl]=\"f.roles\" label=\"{{ 'Roles' | translate }}\"></e11-input-errors>\n      </div>\n\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"companyRole\"\n          id=\"companyRole\"\n          label=\"{{ 'Company Role' | translate }}\"\n          [size]=\"'md'\"\n          [borderGlow]=\"'primary'\"\n          [parentForm]=\"formInvite\"\n          [autofocus]=\"false\"\n          formControlName=\"companyRole\"\n          autocomplete=\"off\"\n          [hasError]=\"f.companyRole.invalid && f.companyRole.dirty\"\n        >\n          <e11-input-errors [parentForm]=\"formInvite\" [formControl]=\"f.companyRole\" label=\"{{ 'Company Role' | translate }}\"></e11-input-errors>\n        </e11-input>\n      </div>\n\n      <div class=\"e11-w-full e11-pb-6\" *ngIf=\"departments && departments.length\">\n        <e11-select\n          name=\"departments\"\n          id=\"departments\"\n          [label]=\"'Department' | translate\"\n          [required]=\"false\"\n          [options]=\"departmentOptions\"\n          formControlName=\"department\"\n        >\n        </e11-select>\n      </div>\n    </form>\n  </div>\n\n  <div class=\"e11-flex e11-justify-end e11-p-4 e11-flex-shrink-0\">\n    <e11-button [value]=\"'Cancel' | translate\" [color]=\"'neutral'\" [ghost]=\"true\" (click)=\"cancel()\" [buttonGroup]=\"true\"> </e11-button>\n\n    <e11-button\n      (click)=\"onSubmit()\"\n      value=\"{{ loading ? 'Inviting...' : ('Invite User' | translate) }}\"\n      [color]=\"'primary-accent'\"\n      [disabled]=\"loading\"\n    >\n    </e11-button>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1.E11Logger }, { type: i2$5.FormBuilder }, { type: FormCustomValidationService }, { type: i2$1.IAuthService }, { type: IRegistrationInviteService }, { type: i3$4.E11NotificationsService }, { type: i2$6.TenantBootstrapRepository }], propDecorators: { customerKey: [{
                type: Input
            }], bootstrapTenantKey: [{
                type: Input
            }], availableRoles: [{
                type: Input
            }], departments: [{
                type: Input
            }], authToken: [{
                type: Input
            }], submitInvite: [{
                type: Output
            }], cancelInvite: [{
                type: Output
            }] } });

class PlatformAdminBusinessUserInviteComponent {
    constructor(sideOverService, inviteService, notificationsService, scrollLockService) {
        this.sideOverService = sideOverService;
        this.inviteService = inviteService;
        this.notificationsService = notificationsService;
        this.scrollLockService = scrollLockService;
        this.userInvited = new EventEmitter();
        this.loading = false;
    }
    ngOnChanges(changes) { }
    ngOnInit() { }
    openInviteEdit() {
        this.sideOverService.overlayToggle(true, this.createInviteSideOver);
        this.scrollLockService.scrollLock(true);
    }
    async onInvite(request) {
        if (!this.customerKey)
            return;
        this.sideOverService.overlayToggle(false);
        this.scrollLockService.scrollLock(false);
        this.loading = true;
        let message;
        this.addAdditionalRequiredRoles(request);
        try {
            await this.inviteService.inviteUser(request, this.customerKey);
            message = {
                title: 'Changes Saved',
                message: `${request.firstName} ${request.lastName} has been Invited.`,
                type: 'success',
                autoClose: true,
                dismissOnRouteChange: true,
            };
            this.userInvited.emit(true);
        }
        catch (err) {
            message = {
                title: 'Error',
                message: `The invite for ${request.firstName} ${request.lastName} incurred an error.`,
                type: 'error',
                autoClose: true,
                dismissOnRouteChange: true,
            };
        }
        this.loading = false;
        this.notificationsService.popNotificationMessage(message);
    }
    addAdditionalRequiredRoles(request) {
        if (this.additionalRequiredRoles) {
            this.additionalRequiredRoles.forEach((r) => {
                if (!request.roles.includes(r)) {
                    request.roles.push(r);
                }
            });
        }
    }
    onCancel() {
        this.sideOverService.overlayToggle(false);
        this.scrollLockService.scrollLock(false);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminBusinessUserInviteComponent, deps: [{ token: i1$2.E11SideOverService }, { token: PlatformAdminRegistrationInviteService }, { token: i3$4.E11NotificationsService }, { token: i4$5.UiScrollLockingService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: PlatformAdminBusinessUserInviteComponent, selector: "sdk-business-user-invite-platform-admin", inputs: { customerKey: "customerKey", bootstrapTenantKey: "bootstrapTenantKey", availableRoles: "availableRoles", departments: "departments", additionalRequiredRoles: "additionalRequiredRoles" }, outputs: { userInvited: "userInvited" }, providers: [{ provide: IRegistrationInviteService, useClass: PlatformAdminRegistrationInviteService }], viewQueries: [{ propertyName: "createInviteSideOver", first: true, predicate: ["createInviteSideOver"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `<div class="parent-container e11-relative">
      <e11-button
        color="primary-accent"
        value="{{ loading ? 'Sending invite...' : ('Add Team Member' | translate) }}"
        [disabled]="loading"
        (click)="openInviteEdit()"
      >
      </e11-button>
    </div>
    <ng-template #createInviteSideOver>
      <div class="e11-h-full e11-bg-white">
        <sdk-create-business-user-invite
          [customerKey]="customerKey"
          [bootstrapTenantKey]="bootstrapTenantKey"
          [departments]="departments"
          [availableRoles]="availableRoles"
          (submitInvite)="onInvite($event)"
          (cancelInvite)="onCancel()"
        ></sdk-create-business-user-invite>
      </div>
    </ng-template> `, isInline: true, styles: [".e11-loader-fading{position:absolute;opacity:0;z-index:-2;top:13rem;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out 1.2s}.e11-loader-fading.active{opacity:1;z-index:2;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out 0s}\n"], dependencies: [{ kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: CreateBusinessUserInviteComponent, selector: "sdk-create-business-user-invite", inputs: ["customerKey", "bootstrapTenantKey", "availableRoles", "departments", "authToken"], outputs: ["submitInvite", "cancelInvite"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminBusinessUserInviteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-business-user-invite-platform-admin', template: `<div class="parent-container e11-relative">
      <e11-button
        color="primary-accent"
        value="{{ loading ? 'Sending invite...' : ('Add Team Member' | translate) }}"
        [disabled]="loading"
        (click)="openInviteEdit()"
      >
      </e11-button>
    </div>
    <ng-template #createInviteSideOver>
      <div class="e11-h-full e11-bg-white">
        <sdk-create-business-user-invite
          [customerKey]="customerKey"
          [bootstrapTenantKey]="bootstrapTenantKey"
          [departments]="departments"
          [availableRoles]="availableRoles"
          (submitInvite)="onInvite($event)"
          (cancelInvite)="onCancel()"
        ></sdk-create-business-user-invite>
      </div>
    </ng-template> `, providers: [{ provide: IRegistrationInviteService, useClass: PlatformAdminRegistrationInviteService }], styles: [".e11-loader-fading{position:absolute;opacity:0;z-index:-2;top:13rem;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out 1.2s}.e11-loader-fading.active{opacity:1;z-index:2;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out 0s}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.E11SideOverService }, { type: PlatformAdminRegistrationInviteService }, { type: i3$4.E11NotificationsService }, { type: i4$5.UiScrollLockingService }], propDecorators: { customerKey: [{
                type: Input
            }], bootstrapTenantKey: [{
                type: Input
            }], availableRoles: [{
                type: Input
            }], departments: [{
                type: Input
            }], additionalRequiredRoles: [{
                type: Input
            }], userInvited: [{
                type: Output
            }], createInviteSideOver: [{
                type: ViewChild,
                args: ['createInviteSideOver']
            }] } });

class BusinessUserInviteComponent {
    constructor(sideOverService, inviteService, notificationsService, scrollLockService, configProvider) {
        this.sideOverService = sideOverService;
        this.inviteService = inviteService;
        this.notificationsService = notificationsService;
        this.scrollLockService = scrollLockService;
        this.configProvider = configProvider;
        this.userInvited = new EventEmitter();
        this.loading = false;
        this.destroy$ = new Subject();
    }
    ngOnChanges(changes) { }
    ngOnInit() {
        this.configProvider
            .getCurrentUserCustomerKey()
            .pipe(filter(isNotNil), takeUntil(this.destroy$))
            .subscribe((customerKey) => (this.customerKey = customerKey));
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    openInviteEdit() {
        this.sideOverService.overlayToggle(true, this.createInviteSideOver);
        this.scrollLockService.scrollLock(true);
    }
    async onInvite(request) {
        this.sideOverService.overlayToggle(false);
        this.scrollLockService.scrollLock(false);
        this.loading = true;
        let message;
        this.addAdditionalRequiredRoles(request);
        try {
            await this.inviteService.inviteUser(request);
            message = {
                title: 'Changes Saved',
                message: `${request.firstName} ${request.lastName} has been Invited.`,
                type: 'success',
                autoClose: true,
                dismissOnRouteChange: true,
            };
            this.userInvited.emit(true);
        }
        catch (err) {
            message = {
                title: 'Error',
                message: `The invite for ${request.firstName} ${request.lastName} incurred an error.`,
                type: 'error',
                autoClose: true,
                dismissOnRouteChange: true,
            };
        }
        this.loading = false;
        this.notificationsService.popNotificationMessage(message);
    }
    addAdditionalRequiredRoles(request) {
        if (this.additionalRequiredRoles) {
            this.additionalRequiredRoles.forEach((r) => {
                if (!request.roles.includes(r)) {
                    request.roles.push(r);
                }
            });
        }
    }
    onCancel() {
        this.sideOverService.overlayToggle(false);
        this.scrollLockService.scrollLock(false);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BusinessUserInviteComponent, deps: [{ token: i1$2.E11SideOverService }, { token: RegistrationInviteService }, { token: i3$4.E11NotificationsService }, { token: i4$5.UiScrollLockingService }, { token: BaseRegistrationConfigProvider }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: BusinessUserInviteComponent, selector: "sdk-business-user-invite", inputs: { availableRoles: "availableRoles", departments: "departments", additionalRequiredRoles: "additionalRequiredRoles" }, outputs: { userInvited: "userInvited" }, providers: [{ provide: IRegistrationInviteService, useClass: RegistrationInviteService }], viewQueries: [{ propertyName: "createInviteSideOver", first: true, predicate: ["createInviteSideOver"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `<div class="parent-container e11-relative">
      <e11-button
        color="primary-accent"
        value="{{ loading ? 'Sending invite...' : ('Add Team Member' | translate) }}"
        [disabled]="loading"
        (click)="openInviteEdit()"
      >
      </e11-button>
    </div>
    <ng-template #createInviteSideOver>
      <div class="e11-h-full e11-bg-white">
        <sdk-create-business-user-invite
          *ngIf="customerKey"
          [customerKey]="customerKey"
          [departments]="departments"
          [availableRoles]="availableRoles"
          (submitInvite)="onInvite($event)"
          (cancelInvite)="onCancel()"
        ></sdk-create-business-user-invite>
      </div>
    </ng-template> `, isInline: true, styles: [".e11-loader-fading{position:absolute;opacity:0;z-index:-2;top:13rem;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out 1.2s}.e11-loader-fading.active{opacity:1;z-index:2;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out 0s}\n"], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: CreateBusinessUserInviteComponent, selector: "sdk-create-business-user-invite", inputs: ["customerKey", "bootstrapTenantKey", "availableRoles", "departments", "authToken"], outputs: ["submitInvite", "cancelInvite"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BusinessUserInviteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-business-user-invite', template: `<div class="parent-container e11-relative">
      <e11-button
        color="primary-accent"
        value="{{ loading ? 'Sending invite...' : ('Add Team Member' | translate) }}"
        [disabled]="loading"
        (click)="openInviteEdit()"
      >
      </e11-button>
    </div>
    <ng-template #createInviteSideOver>
      <div class="e11-h-full e11-bg-white">
        <sdk-create-business-user-invite
          *ngIf="customerKey"
          [customerKey]="customerKey"
          [departments]="departments"
          [availableRoles]="availableRoles"
          (submitInvite)="onInvite($event)"
          (cancelInvite)="onCancel()"
        ></sdk-create-business-user-invite>
      </div>
    </ng-template> `, providers: [{ provide: IRegistrationInviteService, useClass: RegistrationInviteService }], styles: [".e11-loader-fading{position:absolute;opacity:0;z-index:-2;top:13rem;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out 1.2s}.e11-loader-fading.active{opacity:1;z-index:2;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out 0s}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.E11SideOverService }, { type: RegistrationInviteService }, { type: i3$4.E11NotificationsService }, { type: i4$5.UiScrollLockingService }, { type: BaseRegistrationConfigProvider }], propDecorators: { availableRoles: [{
                type: Input
            }], departments: [{
                type: Input
            }], additionalRequiredRoles: [{
                type: Input
            }], userInvited: [{
                type: Output
            }], createInviteSideOver: [{
                type: ViewChild,
                args: ['createInviteSideOver']
            }] } });

class ConsumerRegistrationQuickComponent {
    onKeydownHandler(event) {
        this.passwordHelper ? (this.passwordHelper = false) : null;
    }
    constructor(configProvider, formBuilder, customValidator, registrationService, authService, termsService, errorHandler, _sanitizer, logger) {
        this.configProvider = configProvider;
        this.formBuilder = formBuilder;
        this.customValidator = customValidator;
        this.registrationService = registrationService;
        this.authService = authService;
        this.termsService = termsService;
        this.errorHandler = errorHandler;
        this._sanitizer = _sanitizer;
        this.logger = logger;
        this.includeDisplayName = true; // On by default - value falls back to firstName + lastName when turned off
        this.submitButtonText = 'Create Account';
        this.destroy$ = new Subject();
        this.formRegister = new FormGroup({}); // ! Do NOT type new forms as "any" - this is from the Angular 14 migration
        this.formRegisterSubmitted = false;
        this.passwordMinLength = { value: 8 };
        this.loading = false;
        this.isProcessing = false;
        this.passwordHelper = false;
        this.userEmailInUse = false;
        this.onSubmit = new EventEmitter();
        this.onError = new EventEmitter();
        this.termsClicked = new EventEmitter();
    }
    ngOnInit() {
        this.initRegistrationForm();
        this.termsService
            .getMostRecentTerms()
            .pipe(takeUntil$1(this.destroy$))
            .subscribe((termsModels) => {
            this.termsModel = termsModels[0];
            this.termsOfUse = this._sanitizer.bypassSecurityTrustHtml(termsModels[0].terms);
        });
    }
    get fr() {
        return this.formRegister.controls;
    }
    async resolved(captchaResponse) {
        if (captchaResponse) {
            await this.processRegistration(captchaResponse);
            this.captchaRef?.reset();
        }
    }
    async onSubmitFormRegister() {
        this.logger.log('onSubmitFormRegister', this.formRegister);
        this.formRegisterSubmitted = true;
        if (this.formRegister.valid) {
            this.captchaRef?.execute();
        }
        else {
            // Fire off a validation check on individual fields
            Object.keys(this.formRegister.controls).forEach((field) => {
                const control = this.formRegister.get(field);
                control?.updateValueAndValidity();
            });
        }
    }
    async processRegistration(captchaResponse) {
        if (!(this.formRegister.valid && this.termsModel)) {
            this.isProcessing = false;
            this.formRegister.enable();
            // Fire off a validation check on individual fields
            Object.keys(this.formRegister.controls).forEach((field) => {
                const control = this.formRegister.get(field);
                control?.updateValueAndValidity();
            });
            return;
        }
        const email = this.formRegister.value.email.trim().toLowerCase();
        this.userEmailInUse = !(await this.authService.isEmailAvailable(email));
        if (this.userEmailInUse)
            return;
        this.formRegisterSubmitted = true;
        this.isProcessing = true;
        this.formRegister.disable();
        const { firstName, lastName, password, displayName } = this.formRegister.value;
        const quickRegistration = {
            email,
            firstName,
            lastName,
            password,
            termsVersionAccepted: this.termsModel.version,
            displayName: displayName.trim() || `${firstName} ${lastName}`,
            captchaResponse,
            authTenantId: this.configProvider.config.authTenantId,
        };
        try {
            const result = await this.registrationService.registerConsumerUserV2(quickRegistration, captchaResponse);
            this.onSubmit.emit(result);
        }
        catch (e) {
            this.errorHandler.handleError(e, { alertUser: true });
            this.formRegister.enable();
        }
        finally {
            this.isProcessing = false;
        }
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    focusPassword() {
        this.passwordHelperFunction();
    }
    blurPassword() {
        this.passwordHelper = false;
    }
    focusPasswordConfirm() {
        this.passwordHelperFunction();
    }
    blurPasswordConfirm() {
        this.passwordHelper = false;
    }
    passwordHelperFunction() {
        if (this.fr['passwordConfirm'].value !== this.fr['password'].value) {
            this.passwordHelper = true;
        }
        else {
            setTimeout(() => {
                this.passwordHelper = false;
            }, 1000);
        }
    }
    initRegistrationForm() {
        const displayNameValidators = this.includeDisplayName
            ? [
                Validators.required,
                Validators.maxLength(24),
                Validators.minLength(2),
                this.customValidator.isAlphaNumericValidator(),
                this.customValidator.minLengthAlphanumeric(1),
            ]
            : [];
        this.formRegister = this.formBuilder.group({
            firstName: new FormControl('', [
                Validators.required,
                Validators.maxLength(20),
                Validators.minLength(1),
                this.customValidator.nameValidator(),
                this.customValidator.minLengthAlphanumeric(1),
            ]),
            lastName: new FormControl('', [
                Validators.required,
                Validators.maxLength(20),
                Validators.minLength(1),
                this.customValidator.nameValidator(),
                this.customValidator.minLengthAlphanumeric(1),
            ]),
            displayName: new FormControl('', displayNameValidators),
            password: new FormControl('', [Validators.required, Validators.minLength(8), this.customValidator.hasNumberValidator()]),
            passwordConfirm: new FormControl('', [Validators.required, Validators.minLength(8)]),
            email: new FormControl('', [Validators.required, this.customValidator.emailValidator()]),
        }, {
            validator: [this.customValidator.emailMatch('email', 'emailConfirm'), this.customValidator.passwordMatch('password', 'passwordConfirm')],
        });
        this.formRegister.get('password').valueChanges.subscribe((changes) => {
            this.passwordHelperFunction();
        });
        this.formRegister.get('passwordConfirm').valueChanges.subscribe((changes) => {
            this.passwordHelperFunction();
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConsumerRegistrationQuickComponent, deps: [{ token: BaseRegistrationConfigProvider }, { token: i2$5.FormBuilder }, { token: FormCustomValidationService }, { token: IRegistrationService }, { token: i2$1.IAuthService }, { token: i6.TermsService }, { token: i1.E11ErrorHandlerService }, { token: i4$4.DomSanitizer }, { token: i1.E11Logger }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ConsumerRegistrationQuickComponent, selector: "sdk-registration-consumer", inputs: { includeDisplayName: "includeDisplayName", submitButtonText: "submitButtonText" }, outputs: { onSubmit: "onSubmit", onError: "onError", termsClicked: "termsClicked" }, host: { listeners: { "document:keydown.escape": "onKeydownHandler($event)" } }, viewQueries: [{ propertyName: "captchaRef", first: true, predicate: ["captchaRef"], descendants: true }], ngImport: i0, template: "<div class=\"e11-relative registration-single-step\">\n  <div\n    class=\"registration-single-step-processing e11-absolute e11-w-full e11-h-full e11-left-0 e11-top-0 e11-flex e11-items-center e11-justify-center active\"\n    [ngClass]=\"{ active: isProcessing }\"\n  >\n    <e11-loader-dots [size]=\"'md'\" [color]=\"'e11-bg-skin-primary-accent'\" [label]=\"'Creating your account...'\"></e11-loader-dots>\n  </div>\n  <!-- Registration Form -->\n  <form\n    id=\"form_register\"\n    class=\"registration-single-step-form e11-mb-8 in-active\"\n    [formGroup]=\"formRegister\"\n    (ngSubmit)=\"onSubmitFormRegister()\"\n    novalidate\n    autocomplete=\"off\"\n    [ngClass]=\"{ 'in-active': isProcessing }\"\n  >\n    <div class=\"e11-w-full\">\n      <e11-input\n        [type]=\"'email'\"\n        name=\"email\"\n        id=\"email_formEmail\"\n        label=\"{{ 'Email' | translate }}\"\n        value=\"userEmail\"\n        [size]=\"'md'\"\n        [parentForm]=\"formRegister\"\n        formControlName=\"email\"\n        autocomplete=\"off\"\n        [autofocus]=\"true\"\n        borderGlow=\"primary\"\n        [required]=\"true\"\n        [hasError]=\"(fr.email.errors && fr.email.dirty) || (fr.email.invalid && formRegisterSubmitted)\"\n      >\n        <e11-input-errors\n          [parentForm]=\"formRegister\"\n          [formControl]=\"fr.email\"\n          [formSubmitted]=\"formRegisterSubmitted\"\n          label=\"{{ 'Email' | translate }}\"\n        >\n        </e11-input-errors>\n      </e11-input>\n      <div\n        class=\"e11-rounded-md e11-bg-yellow-50 e11-p-4\"\n        *ngIf=\"userEmailInUse\"\n        [ngClass]=\"{ 'e11-opacity-100': userEmailInUse, 'e11-opacity-0': !userEmailInUse }\"\n      >\n        <div class=\"e11-flex\">\n          <div class=\"e11-flex-shrink-0\">\n            <!-- Heroicon name: solid/exclamation -->\n            <svg\n              class=\"e11-h-5 e11-w-5 e11-text-yellow-400\"\n              xmlns=\"http://www.w3.org/2000/svg\"\n              viewBox=\"0 0 20 20\"\n              fill=\"currentColor\"\n              aria-hidden=\"true\"\n            >\n              <path\n                fill-rule=\"evenodd\"\n                d=\"M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z\"\n                clip-rule=\"evenodd\"\n              />\n            </svg>\n          </div>\n          <div class=\"e11-ml-3\">\n            <div class=\"e11-text-sm\">\n              <p>{{ \"It appears that we already have an account using this email address.\" | translate }}</p>\n            </div>\n            <div class=\"e11-mt-4\"></div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"e11-w-full\">\n      <div class=\"e11-grid e11-grid-cols-1 sm:e11-grid-cols-2 e11-gap-4\">\n        <div>\n          <e11-input\n            [type]=\"'text'\"\n            name=\"firstName\"\n            id=\"firstName\"\n            label=\"{{ 'First Name' | translate }}\"\n            [size]=\"'md'\"\n            [parentForm]=\"formRegister\"\n            formControlName=\"firstName\"\n            autocomplete=\"off\"\n            borderGlow=\"primary\"\n            [required]=\"true\"\n            [hasError]=\"(fr.firstName.errors && fr.firstName.dirty) || (fr.firstName.invalid && formRegisterSubmitted)\"\n          >\n            <e11-input-errors\n              [parentForm]=\"formRegister\"\n              [formControl]=\"fr.firstName\"\n              [formSubmitted]=\"formRegisterSubmitted\"\n              label=\"{{ 'First Name' | translate }}\"\n            >\n            </e11-input-errors>\n          </e11-input>\n        </div>\n        <div>\n          <e11-input\n            [type]=\"'text'\"\n            name=\"lastName\"\n            id=\"lastName\"\n            label=\"{{ 'Last Name' | translate }}\"\n            value=\"lastName\"\n            [size]=\"'md'\"\n            [parentForm]=\"formRegister\"\n            formControlName=\"lastName\"\n            autocomplete=\"off\"\n            borderGlow=\"primary\"\n            [required]=\"true\"\n            [hasError]=\"(fr.lastName.errors && fr.lastName.dirty) || (fr.lastName.invalid && formRegisterSubmitted)\"\n          >\n            <e11-input-errors\n              [parentForm]=\"formRegister\"\n              [formControl]=\"fr.lastName\"\n              [formSubmitted]=\"formRegisterSubmitted\"\n              label=\"{{ 'Last Name' | translate }}\"\n            >\n            </e11-input-errors>\n          </e11-input>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"e11-w-full\">\n      <e11-input\n        *ngIf=\"includeDisplayName\"\n        [type]=\"'text'\"\n        name=\"displayName\"\n        id=\"displayName\"\n        label=\"{{ 'Display Name' | translate }}\"\n        value=\"displayName\"\n        [size]=\"'md'\"\n        [parentForm]=\"formRegister\"\n        formControlName=\"displayName\"\n        autocomplete=\"off\"\n        borderGlow=\"primary\"\n        [required]=\"true\"\n        [placeholder]=\"'Your \\'screen name\\'. Ex: user42'\"\n        [hasError]=\"(fr.displayName.errors && fr.displayName.dirty) || (fr.displayName.invalid && formRegisterSubmitted)\"\n      >\n        <e11-input-errors\n          [parentForm]=\"formRegister\"\n          [formControl]=\"fr.displayName\"\n          [formSubmitted]=\"formRegisterSubmitted\"\n          label=\"{{ 'Display Name' | translate }}\"\n        >\n        </e11-input-errors>\n      </e11-input>\n    </div>\n\n    <div class=\"e11-w-full e11-relative\">\n      <div class=\"e11-grid e11-grid-cols-1 sm:e11-grid-cols-2 e11-gap-4\">\n        <div>\n          <e11-input\n            [type]=\"'password'\"\n            name=\"password\"\n            id=\"password\"\n            label=\"{{ 'Password' | translate }}\"\n            [size]=\"'md'\"\n            [parentForm]=\"formRegister\"\n            formControlName=\"password\"\n            autocomplete=\"off\"\n            [autofocus]=\"false\"\n            borderGlow=\"primary\"\n            [required]=\"true\"\n            [togglePassword]=\"true\"\n            [hasError]=\"(fr.password.errors && fr.password.dirty) || (fr.password.invalid && formRegisterSubmitted)\"\n            (focus)=\"focusPassword()\"\n            (blur)=\"blurPassword()\"\n          >\n            <e11-input-errors\n              [parentForm]=\"formRegister\"\n              [formControl]=\"fr.password\"\n              [formSubmitted]=\"formRegisterSubmitted\"\n              label=\"{{ 'Password' | translate }}\"\n            >\n            </e11-input-errors>\n          </e11-input>\n        </div>\n\n        <div>\n          <e11-input\n            [type]=\"'password'\"\n            name=\"passwordConfirm\"\n            id=\"password_formConfirmPassword\"\n            label=\"{{ 'Confirm Password' | translate }}\"\n            [size]=\"'md'\"\n            [parentForm]=\"formRegister\"\n            formControlName=\"passwordConfirm\"\n            autocomplete=\"off\"\n            borderGlow=\"primary\"\n            [required]=\"true\"\n            [togglePassword]=\"true\"\n            [hasError]=\"fr.passwordConfirm.hasError('passwordMatchError')\"\n            (focus)=\"focusPasswordConfirm()\"\n            (blur)=\"blurPasswordConfirm()\"\n          >\n            <e11-input-errors\n              [parentForm]=\"formRegister\"\n              [formControl]=\"fr.passwordConfirm\"\n              [formSubmitted]=\"formRegisterSubmitted\"\n              label=\"{{ 'Password confirmation' | translate }}\"\n            >\n            </e11-input-errors>\n          </e11-input>\n        </div>\n      </div>\n\n      <!-- Password error handling -->\n      <div\n        class=\"error-message-password-list e11-mt-0 e11-mb-4 e11-p-4 e11-border e11-border-skin-grey e11-shadow-md e11-rounded-sm e11-bg-white active\"\n        [ngClass]=\"{ active: passwordHelper }\"\n      >\n        <div class=\"e11-absolute e11-top-1 e11-right-1 error-message-password-list-closer e11-cursor-pointer e11-opacity-60 hover:e11-opacity-100\">\n          <span class=\"material-icons-outlined e11-text-skin-base md-24\"> cancel </span>\n        </div>\n        <p class=\"e11-font-semibold e11-mb-1\">\n          {{ \"Your password must meet the following requirements:\" | translate }}\n        </p>\n        <p\n          class=\"e11-mb-0 e11-flex e11-items-center e11-h-6\"\n          [ngClass]=\"{\n            'e11-text-skin-error': fr.password.hasError('minlength') || (formRegisterSubmitted && fr.password.invalid),\n            'e11-text-skin-success': !fr.password.hasError('minlength') && fr.password.dirty && fr.password.value.length > 0\n          }\"\n        >\n          {{ 'Minimum length is {{value}} characters' | translate: passwordMinLength }}\n          <span\n            class=\"material-icons-outlined e11-text-skin-success e11-ml-2 md-18\"\n            *ngIf=\"!fr.password.hasError('minlength') && fr.password.dirty && fr.password.value.length > 0\"\n          >\n            done\n          </span>\n        </p>\n        <p\n          class=\"e11-mb-0 e11-flex e11-items-center e11-h-6\"\n          [ngClass]=\"{\n            'e11-text-skin-error': fr.password.hasError('hasNumberError') || (formRegisterSubmitted && fr.password.invalid),\n            'e11-text-skin-success': !fr.password.hasError('hasNumberError') && fr.password.dirty && fr.password.value.length > 0\n          }\"\n        >\n          {{ \"Include 1 number\" | translate }}\n          <span\n            class=\"material-icons-outlined e11-text-skin-success e11-ml-2 md-18\"\n            *ngIf=\"!fr.password.hasError('hasNumberError') && fr.password.dirty && fr.password.value.length > 0\"\n          >\n            done\n          </span>\n        </p>\n        <p\n          class=\"e11-mb-0 e11-flex e11-items-center e11-h-6\"\n          [ngClass]=\"{\n            'e11-text-skin-error': fr.passwordConfirm.invalid || fr.password.value !== fr.passwordConfirm.value,\n            'e11-text-skin-success': fr.passwordConfirm.valid && fr.password.value === fr.passwordConfirm.value\n          }\"\n        >\n          {{ \"Password and confirmation must match\" | translate }}\n          <span\n            class=\"material-icons-outlined e11-text-skin-success e11-ml-2 md-18\"\n            *ngIf=\"fr.passwordConfirm.valid && !fr.passwordConfirm.hasError('passwordMatchError')\"\n          >\n            done\n          </span>\n        </p>\n      </div>\n    </div>\n\n    <div class=\"e11-w-full\">\n      <e11-button\n        id=\"submit_formRegister\"\n        value=\"{{ isProcessing ? 'Processing...' : (submitButtonText | translate) }}\"\n        [color]=\"'primary-accent'\"\n        [type]=\"'submit'\"\n        [display]=\"'block'\"\n        [disabled]=\"isProcessing\"\n      >\n      </e11-button>\n\n      <div class=\"e11-w-full e11-text-xs e11-text-center\">\n        <p>\n          {{ \"By continuing you are agreeing to our\" | translate }}\n          <span class=\"e11-text-skin-primary-accent e11-cursor-pointer\" (click)=\"modalTerms.open()\">{{ \"Terms of Use\" | translate }}</span\n          >.\n        </p>\n      </div>\n    </div>\n\n    <re-captcha #captchaRef=\"reCaptcha\" size=\"invisible\" (resolved)=\"resolved($event)\"></re-captcha>\n  </form>\n</div>\n\n<!-- Modal(s) -->\n<e11-modal\n  #modalTerms\n  [title]=\"'Terms of Use' | translate\"\n  [showHeader]=\"true\"\n  [hideCloseButton]=\"false\"\n  [width]=\"'lg'\"\n  [bodyClassOverrides]=\"'e11-h-[55vh]'\"\n>\n  <div modal-body>\n    <ng-container *ngIf=\"termsOfUse\">\n      <div [innerHTML]=\"termsOfUse\"></div>\n    </ng-container>\n  </div>\n\n  <div modal-footer>\n    <div class=\"e11-text-center\">\n      <e11-button [type]=\"'button'\" value=\"{{ 'Close' | translate }}\" color=\"neutral\" (click)=\"modalTerms.close()\"> </e11-button>\n    </div>\n  </div>\n</e11-modal>\n", styles: [".registration-single-step{position:relative}.registration-single-step .registration-single-step-processing{opacity:0;z-index:-2;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out .4s}.registration-single-step .registration-single-step-processing.active{opacity:1;z-index:2;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out 0s}.registration-single-step .registration-single-step-form{opacity:1;z-index:1;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out .4s}.registration-single-step .registration-single-step-form.in-active{opacity:.3;z-index:0;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out 0s}.error-message-password-list{position:absolute;top:-125%;width:100%;opacity:0;z-index:-2;transition:opacity .4s ease-in-out 0s,top .4s ease-in-out 0s,z-index 0s ease-in-out .4s}.error-message-password-list.active{top:-150%;opacity:1;z-index:2;transition:opacity .4s ease-in-out 0s,top .4s ease-in-out 0s,z-index 0s ease-in-out 0s}@media screen and (max-width: 640px){.error-message-password-list{top:-65%}.error-message-password-list.active{top:-75%}}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$5.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$5.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$5.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2$5.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$5.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$5.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i7$2.RecaptchaComponent, selector: "re-captcha", inputs: ["id", "siteKey", "theme", "type", "size", "tabIndex", "badge", "errorMode"], outputs: ["resolved", "error", "errored"], exportAs: ["reCaptcha"] }, { kind: "component", type: i4$3.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i2$4.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i1$1.E11ModalComponent, selector: "e11-modal", inputs: ["title", "width", "bodyHeight", "titleAlign", "hideCloseButton", "closer", "bodyClassOverrides", "bodyClass", "modalClassOverrides", "modalClass", "contentClassOverrides", "contentClass", "headerClassOverrides", "headerClass", "footerClassOverrides", "footerClass", "showFooter", "showHeader", "darkMode", "closeOnEscape", "closeOnClickOutside", "headerCTAs", "hasBackdrop", "backdropStyle"], outputs: ["modalOpened", "onModalOpened", "modalClosed", "onModalClosed", "headerCTAClicked", "onHeaderCTAClicked"] }, { kind: "component", type: i7$1.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConsumerRegistrationQuickComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-registration-consumer', template: "<div class=\"e11-relative registration-single-step\">\n  <div\n    class=\"registration-single-step-processing e11-absolute e11-w-full e11-h-full e11-left-0 e11-top-0 e11-flex e11-items-center e11-justify-center active\"\n    [ngClass]=\"{ active: isProcessing }\"\n  >\n    <e11-loader-dots [size]=\"'md'\" [color]=\"'e11-bg-skin-primary-accent'\" [label]=\"'Creating your account...'\"></e11-loader-dots>\n  </div>\n  <!-- Registration Form -->\n  <form\n    id=\"form_register\"\n    class=\"registration-single-step-form e11-mb-8 in-active\"\n    [formGroup]=\"formRegister\"\n    (ngSubmit)=\"onSubmitFormRegister()\"\n    novalidate\n    autocomplete=\"off\"\n    [ngClass]=\"{ 'in-active': isProcessing }\"\n  >\n    <div class=\"e11-w-full\">\n      <e11-input\n        [type]=\"'email'\"\n        name=\"email\"\n        id=\"email_formEmail\"\n        label=\"{{ 'Email' | translate }}\"\n        value=\"userEmail\"\n        [size]=\"'md'\"\n        [parentForm]=\"formRegister\"\n        formControlName=\"email\"\n        autocomplete=\"off\"\n        [autofocus]=\"true\"\n        borderGlow=\"primary\"\n        [required]=\"true\"\n        [hasError]=\"(fr.email.errors && fr.email.dirty) || (fr.email.invalid && formRegisterSubmitted)\"\n      >\n        <e11-input-errors\n          [parentForm]=\"formRegister\"\n          [formControl]=\"fr.email\"\n          [formSubmitted]=\"formRegisterSubmitted\"\n          label=\"{{ 'Email' | translate }}\"\n        >\n        </e11-input-errors>\n      </e11-input>\n      <div\n        class=\"e11-rounded-md e11-bg-yellow-50 e11-p-4\"\n        *ngIf=\"userEmailInUse\"\n        [ngClass]=\"{ 'e11-opacity-100': userEmailInUse, 'e11-opacity-0': !userEmailInUse }\"\n      >\n        <div class=\"e11-flex\">\n          <div class=\"e11-flex-shrink-0\">\n            <!-- Heroicon name: solid/exclamation -->\n            <svg\n              class=\"e11-h-5 e11-w-5 e11-text-yellow-400\"\n              xmlns=\"http://www.w3.org/2000/svg\"\n              viewBox=\"0 0 20 20\"\n              fill=\"currentColor\"\n              aria-hidden=\"true\"\n            >\n              <path\n                fill-rule=\"evenodd\"\n                d=\"M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z\"\n                clip-rule=\"evenodd\"\n              />\n            </svg>\n          </div>\n          <div class=\"e11-ml-3\">\n            <div class=\"e11-text-sm\">\n              <p>{{ \"It appears that we already have an account using this email address.\" | translate }}</p>\n            </div>\n            <div class=\"e11-mt-4\"></div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"e11-w-full\">\n      <div class=\"e11-grid e11-grid-cols-1 sm:e11-grid-cols-2 e11-gap-4\">\n        <div>\n          <e11-input\n            [type]=\"'text'\"\n            name=\"firstName\"\n            id=\"firstName\"\n            label=\"{{ 'First Name' | translate }}\"\n            [size]=\"'md'\"\n            [parentForm]=\"formRegister\"\n            formControlName=\"firstName\"\n            autocomplete=\"off\"\n            borderGlow=\"primary\"\n            [required]=\"true\"\n            [hasError]=\"(fr.firstName.errors && fr.firstName.dirty) || (fr.firstName.invalid && formRegisterSubmitted)\"\n          >\n            <e11-input-errors\n              [parentForm]=\"formRegister\"\n              [formControl]=\"fr.firstName\"\n              [formSubmitted]=\"formRegisterSubmitted\"\n              label=\"{{ 'First Name' | translate }}\"\n            >\n            </e11-input-errors>\n          </e11-input>\n        </div>\n        <div>\n          <e11-input\n            [type]=\"'text'\"\n            name=\"lastName\"\n            id=\"lastName\"\n            label=\"{{ 'Last Name' | translate }}\"\n            value=\"lastName\"\n            [size]=\"'md'\"\n            [parentForm]=\"formRegister\"\n            formControlName=\"lastName\"\n            autocomplete=\"off\"\n            borderGlow=\"primary\"\n            [required]=\"true\"\n            [hasError]=\"(fr.lastName.errors && fr.lastName.dirty) || (fr.lastName.invalid && formRegisterSubmitted)\"\n          >\n            <e11-input-errors\n              [parentForm]=\"formRegister\"\n              [formControl]=\"fr.lastName\"\n              [formSubmitted]=\"formRegisterSubmitted\"\n              label=\"{{ 'Last Name' | translate }}\"\n            >\n            </e11-input-errors>\n          </e11-input>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"e11-w-full\">\n      <e11-input\n        *ngIf=\"includeDisplayName\"\n        [type]=\"'text'\"\n        name=\"displayName\"\n        id=\"displayName\"\n        label=\"{{ 'Display Name' | translate }}\"\n        value=\"displayName\"\n        [size]=\"'md'\"\n        [parentForm]=\"formRegister\"\n        formControlName=\"displayName\"\n        autocomplete=\"off\"\n        borderGlow=\"primary\"\n        [required]=\"true\"\n        [placeholder]=\"'Your \\'screen name\\'. Ex: user42'\"\n        [hasError]=\"(fr.displayName.errors && fr.displayName.dirty) || (fr.displayName.invalid && formRegisterSubmitted)\"\n      >\n        <e11-input-errors\n          [parentForm]=\"formRegister\"\n          [formControl]=\"fr.displayName\"\n          [formSubmitted]=\"formRegisterSubmitted\"\n          label=\"{{ 'Display Name' | translate }}\"\n        >\n        </e11-input-errors>\n      </e11-input>\n    </div>\n\n    <div class=\"e11-w-full e11-relative\">\n      <div class=\"e11-grid e11-grid-cols-1 sm:e11-grid-cols-2 e11-gap-4\">\n        <div>\n          <e11-input\n            [type]=\"'password'\"\n            name=\"password\"\n            id=\"password\"\n            label=\"{{ 'Password' | translate }}\"\n            [size]=\"'md'\"\n            [parentForm]=\"formRegister\"\n            formControlName=\"password\"\n            autocomplete=\"off\"\n            [autofocus]=\"false\"\n            borderGlow=\"primary\"\n            [required]=\"true\"\n            [togglePassword]=\"true\"\n            [hasError]=\"(fr.password.errors && fr.password.dirty) || (fr.password.invalid && formRegisterSubmitted)\"\n            (focus)=\"focusPassword()\"\n            (blur)=\"blurPassword()\"\n          >\n            <e11-input-errors\n              [parentForm]=\"formRegister\"\n              [formControl]=\"fr.password\"\n              [formSubmitted]=\"formRegisterSubmitted\"\n              label=\"{{ 'Password' | translate }}\"\n            >\n            </e11-input-errors>\n          </e11-input>\n        </div>\n\n        <div>\n          <e11-input\n            [type]=\"'password'\"\n            name=\"passwordConfirm\"\n            id=\"password_formConfirmPassword\"\n            label=\"{{ 'Confirm Password' | translate }}\"\n            [size]=\"'md'\"\n            [parentForm]=\"formRegister\"\n            formControlName=\"passwordConfirm\"\n            autocomplete=\"off\"\n            borderGlow=\"primary\"\n            [required]=\"true\"\n            [togglePassword]=\"true\"\n            [hasError]=\"fr.passwordConfirm.hasError('passwordMatchError')\"\n            (focus)=\"focusPasswordConfirm()\"\n            (blur)=\"blurPasswordConfirm()\"\n          >\n            <e11-input-errors\n              [parentForm]=\"formRegister\"\n              [formControl]=\"fr.passwordConfirm\"\n              [formSubmitted]=\"formRegisterSubmitted\"\n              label=\"{{ 'Password confirmation' | translate }}\"\n            >\n            </e11-input-errors>\n          </e11-input>\n        </div>\n      </div>\n\n      <!-- Password error handling -->\n      <div\n        class=\"error-message-password-list e11-mt-0 e11-mb-4 e11-p-4 e11-border e11-border-skin-grey e11-shadow-md e11-rounded-sm e11-bg-white active\"\n        [ngClass]=\"{ active: passwordHelper }\"\n      >\n        <div class=\"e11-absolute e11-top-1 e11-right-1 error-message-password-list-closer e11-cursor-pointer e11-opacity-60 hover:e11-opacity-100\">\n          <span class=\"material-icons-outlined e11-text-skin-base md-24\"> cancel </span>\n        </div>\n        <p class=\"e11-font-semibold e11-mb-1\">\n          {{ \"Your password must meet the following requirements:\" | translate }}\n        </p>\n        <p\n          class=\"e11-mb-0 e11-flex e11-items-center e11-h-6\"\n          [ngClass]=\"{\n            'e11-text-skin-error': fr.password.hasError('minlength') || (formRegisterSubmitted && fr.password.invalid),\n            'e11-text-skin-success': !fr.password.hasError('minlength') && fr.password.dirty && fr.password.value.length > 0\n          }\"\n        >\n          {{ 'Minimum length is {{value}} characters' | translate: passwordMinLength }}\n          <span\n            class=\"material-icons-outlined e11-text-skin-success e11-ml-2 md-18\"\n            *ngIf=\"!fr.password.hasError('minlength') && fr.password.dirty && fr.password.value.length > 0\"\n          >\n            done\n          </span>\n        </p>\n        <p\n          class=\"e11-mb-0 e11-flex e11-items-center e11-h-6\"\n          [ngClass]=\"{\n            'e11-text-skin-error': fr.password.hasError('hasNumberError') || (formRegisterSubmitted && fr.password.invalid),\n            'e11-text-skin-success': !fr.password.hasError('hasNumberError') && fr.password.dirty && fr.password.value.length > 0\n          }\"\n        >\n          {{ \"Include 1 number\" | translate }}\n          <span\n            class=\"material-icons-outlined e11-text-skin-success e11-ml-2 md-18\"\n            *ngIf=\"!fr.password.hasError('hasNumberError') && fr.password.dirty && fr.password.value.length > 0\"\n          >\n            done\n          </span>\n        </p>\n        <p\n          class=\"e11-mb-0 e11-flex e11-items-center e11-h-6\"\n          [ngClass]=\"{\n            'e11-text-skin-error': fr.passwordConfirm.invalid || fr.password.value !== fr.passwordConfirm.value,\n            'e11-text-skin-success': fr.passwordConfirm.valid && fr.password.value === fr.passwordConfirm.value\n          }\"\n        >\n          {{ \"Password and confirmation must match\" | translate }}\n          <span\n            class=\"material-icons-outlined e11-text-skin-success e11-ml-2 md-18\"\n            *ngIf=\"fr.passwordConfirm.valid && !fr.passwordConfirm.hasError('passwordMatchError')\"\n          >\n            done\n          </span>\n        </p>\n      </div>\n    </div>\n\n    <div class=\"e11-w-full\">\n      <e11-button\n        id=\"submit_formRegister\"\n        value=\"{{ isProcessing ? 'Processing...' : (submitButtonText | translate) }}\"\n        [color]=\"'primary-accent'\"\n        [type]=\"'submit'\"\n        [display]=\"'block'\"\n        [disabled]=\"isProcessing\"\n      >\n      </e11-button>\n\n      <div class=\"e11-w-full e11-text-xs e11-text-center\">\n        <p>\n          {{ \"By continuing you are agreeing to our\" | translate }}\n          <span class=\"e11-text-skin-primary-accent e11-cursor-pointer\" (click)=\"modalTerms.open()\">{{ \"Terms of Use\" | translate }}</span\n          >.\n        </p>\n      </div>\n    </div>\n\n    <re-captcha #captchaRef=\"reCaptcha\" size=\"invisible\" (resolved)=\"resolved($event)\"></re-captcha>\n  </form>\n</div>\n\n<!-- Modal(s) -->\n<e11-modal\n  #modalTerms\n  [title]=\"'Terms of Use' | translate\"\n  [showHeader]=\"true\"\n  [hideCloseButton]=\"false\"\n  [width]=\"'lg'\"\n  [bodyClassOverrides]=\"'e11-h-[55vh]'\"\n>\n  <div modal-body>\n    <ng-container *ngIf=\"termsOfUse\">\n      <div [innerHTML]=\"termsOfUse\"></div>\n    </ng-container>\n  </div>\n\n  <div modal-footer>\n    <div class=\"e11-text-center\">\n      <e11-button [type]=\"'button'\" value=\"{{ 'Close' | translate }}\" color=\"neutral\" (click)=\"modalTerms.close()\"> </e11-button>\n    </div>\n  </div>\n</e11-modal>\n", styles: [".registration-single-step{position:relative}.registration-single-step .registration-single-step-processing{opacity:0;z-index:-2;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out .4s}.registration-single-step .registration-single-step-processing.active{opacity:1;z-index:2;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out 0s}.registration-single-step .registration-single-step-form{opacity:1;z-index:1;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out .4s}.registration-single-step .registration-single-step-form.in-active{opacity:.3;z-index:0;transition:opacity .4s ease-in-out 0s,z-index 0s ease-in-out 0s}.error-message-password-list{position:absolute;top:-125%;width:100%;opacity:0;z-index:-2;transition:opacity .4s ease-in-out 0s,top .4s ease-in-out 0s,z-index 0s ease-in-out .4s}.error-message-password-list.active{top:-150%;opacity:1;z-index:2;transition:opacity .4s ease-in-out 0s,top .4s ease-in-out 0s,z-index 0s ease-in-out 0s}@media screen and (max-width: 640px){.error-message-password-list{top:-65%}.error-message-password-list.active{top:-75%}}\n"] }]
        }], ctorParameters: () => [{ type: BaseRegistrationConfigProvider }, { type: i2$5.FormBuilder }, { type: FormCustomValidationService }, { type: IRegistrationService }, { type: i2$1.IAuthService }, { type: i6.TermsService }, { type: i1.E11ErrorHandlerService }, { type: i4$4.DomSanitizer }, { type: i1.E11Logger }], propDecorators: { includeDisplayName: [{
                type: Input
            }], submitButtonText: [{
                type: Input
            }], captchaRef: [{
                type: ViewChild,
                args: ['captchaRef']
            }], onSubmit: [{
                type: Output
            }], onError: [{
                type: Output
            }], termsClicked: [{
                type: Output
            }], onKeydownHandler: [{
                type: HostListener,
                args: ['document:keydown.escape', ['$event']]
            }] } });

class DeregisterBaseComponent {
    set confirmationPhrase(confirmationPhrase) {
        this._confirmationPhrase = confirmationPhrase;
    }
    constructor(modalGlobal) {
        this.modalGlobal = modalGlobal;
        this._confirmationPhrase = 'Deactivate';
        this.size = 'md';
        this.loading = false;
        this.deactivate = new EventEmitter();
        this.skippedSurvey = null;
        this.destroy$ = new Subject();
        this.registrationService = inject(RegistrationService);
    }
    async ngOnInit() { }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    async confirm(event) {
        event ? await this.deregister() : null;
    }
    async deregister() {
        if (this.customerKey) {
            this.loading = true;
            const deactivationData = {
                reason: this.selectedCustomReason,
                recommendScore: this.recommendScore,
                otherText: this.otherText,
            };
            // deregister
            await this.registrationService.deregister({ customerKey: this.customerKey, deactivationData: deactivationData });
            this.loading = false;
            this.deactivate.emit({ customerKey: this.customerKey, deactivationData: deactivationData });
            this.modalGlobal.closeModal();
        }
    }
    confirmDeactivation(result) {
        if (!result) {
            return;
        }
        this.openModal();
    }
    openModal() {
        const modalType = 'deactivation-modal';
        this.modalGlobal.openModal({
            bodyHeight: 'large',
            type: modalType,
            body: this.deactivationModal,
            showHeader: false,
            showFooter: false,
        });
        // reset form values on close
        this.modalGlobal.modalClosed$.subscribe((type) => {
            if (type !== modalType) {
                return;
            }
            this.skippedSurvey = null;
            this.selectedCustomReason = undefined;
            this.recommendScore = undefined;
            this.otherText = undefined;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DeregisterBaseComponent, deps: [{ token: i1$1.E11ModalGlobalService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: DeregisterBaseComponent, selector: "sdk-deregister-base", inputs: { customDeactivationReasons: "customDeactivationReasons", confirmationPhrase: "confirmationPhrase", size: "size", customerKey: "customerKey" }, outputs: { deactivate: "deactivate" }, viewQueries: [{ propertyName: "deactivationModal", first: true, predicate: ["deactivationModal"], descendants: true }], ngImport: i0, template: "<div>\n  <e11-button\n    (click)=\"confirmation.open()\"\n    [color]=\"'secondary'\"\n    [disabled]=\"loading\"\n    [iconPosition]=\"'left'\"\n    [iconSize]=\"'md-18'\"\n    [icon]=\"'no_accounts'\"\n    [type]=\"'button'\"\n    id=\"degresiter_button\"\n    [size]=\"size\"\n    value=\"{{ loading ? 'Deactivating...' : ('Deactivate Account' | translate) }}\"\n  >\n  </e11-button>\n</div>\n\n<ng-template #deactivationModal>\n  <ng-container *ngIf=\"skippedSurvey === null; else confirmDeactivation\">\n    <div class=\"e11-mb-10\">\n      <h2 class=\"e11-text-skin-primary-accent\">{{ \"Sorry to see you go\" | translate }}</h2>\n      <p>{{ \"Please take just a second to answer a few questions\" | translate }}</p>\n    </div>\n\n    <div *ngIf=\"customDeactivationReasons?.length\" class=\"e11-mb-8\">\n      <p class=\"e11-mb-2 e11-font-primary-medium\">{{ \"Reason for deactivation\" | translate }}</p>\n      <div class=\"e11-grid md:e11-grid-cols-2 e11-gap-4\">\n        <div\n          (click)=\"selectedCustomReason = reason\"\n          *ngFor=\"let reason of customDeactivationReasons\"\n          [ngClass]=\"{\n            'e11-bg-skin-primary-accent e11-text-skin-white': selectedCustomReason?.reasonCode === reason.reasonCode,\n            'e11-bg-skin-grey/10 hover:e11-border-skin-primary-accent hover:e11-text-skin-primary-accent':\n              selectedCustomReason?.reasonCode !== reason.reasonCode\n          }\"\n          class=\"e11-w-full md:e11-col-span-1 e11-cursor-pointer e11-p-2 e11-border e11-rounded e11-border-skin-grey\"\n        >\n          <span class=\"e11-font-primary-medium\">{{ reason.reasonText | translate }}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"e11-mb-8\">\n      <p class=\"e11-mb-2 e11-font-primary-medium\">{{ \"How likely are you to recommend this product\" | translate }}</p>\n      <div class=\"e11-flex e11-gap-4\">\n        <div\n          (click)=\"recommendScore = score\"\n          *ngFor=\"let score of [1, 2, 3, 4, 5]\"\n          [ngClass]=\"{\n            'e11-bg-skin-primary-accent e11-text-skin-white': recommendScore === score,\n            'e11-bg-skin-grey/10 hover:e11-border-skin-primary-accent hover:e11-text-skin-primary-accent': recommendScore !== score\n          }\"\n          class=\"e11-w-[50px] e11-h-[50px] e11-flex e11-justify-center e11-items-center e11-cursor-pointer e11-border e11-rounded-full e11-border-skin-grey\"\n        >\n          <span class=\"e11-font-primary-medium\">{{ score }}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"e11-mb-5\">\n      <p class=\"e11-mb-2 e11-font-primary-medium\">{{ \"Anything else you'd like to add?\" | translate }}</p>\n      <e11-textarea (change)=\"otherText = $event\"></e11-textarea>\n    </div>\n\n    <div>\n      <div class=\"e11-flex e11-justify-end e11-gap-2\">\n        <e11-button (click)=\"modalGlobal.closeModal()\" [ghost]=\"true\" [value]=\"'Close' | translate\" color=\"cancel\" size=\"md\"></e11-button>\n\n        <e11-button (click)=\"skippedSurvey = true\" [ghost]=\"true\" [value]=\"'Skip' | translate\" color=\"secondary\" size=\"md\"></e11-button>\n\n        <e11-button (click)=\"skippedSurvey = false\" [value]=\"'Continue' | translate\" color=\"primary-accent\" size=\"md\"></e11-button>\n      </div>\n    </div>\n  </ng-container>\n\n  <ng-template #confirmDeactivation>\n    <div class=\"e11-px-6 e11-flex e11-gap-2 e11-items-center e11-mb-8\">\n      <span class=\"material-icons-outlined e11-text-skin-error e11-rounded-full e11-bg-red-200\">crisis_alert </span>\n      <h2 class=\"e11-text-skin-error\">\n        {{ \"Deactivate Account\" | translate }}\n      </h2>\n    </div>\n\n    <div class=\"e11-px-6 e11-pb-4\">\n      <p class=\"e11-font-primary-medium\">\n        {{\n          \"Are you sure you want to deactivate this account? This is permanent and all accounts associated with this account will be removed.\"\n            | translate\n        }}\n      </p>\n      <p class=\"e11-font-primary-bold\">{{ \"Are you absolutely certain you want to deactivate this account?\" | translate }}</p>\n    </div>\n\n    <div class=\"e11-flex e11-justify-center e11-items-center e11-gap-4 e11-w-full e11-px-6 e11-pb-6\">\n      <e11-button\n        (click)=\"modalGlobal.closeModal()\"\n        [buttonStyle]=\"'pill'\"\n        [color]=\"'neutral'\"\n        [ghost]=\"true\"\n        [iconPosition]=\"'left'\"\n        [icon]=\"'close'\"\n        [value]=\"'Cancel' | translate\"\n      ></e11-button>\n\n      <e11-button\n        (click)=\"deregister()\"\n        [color]=\"'secondary'\"\n        [iconPosition]=\"'left'\"\n        [icon]=\"'done'\"\n        [style]=\"'pill outlined'\"\n        value=\"{{ loading ? ('Deactivating...' | translate) : ('Deactivate' | translate) }}\"\n      ></e11-button>\n    </div>\n  </ng-template>\n</ng-template>\n\n<e11-confirmation\n  #confirmation\n  confirmTitle=\"{{ 'Deactivate account' | translate }}\"\n  confirmText=\"{{ 'Deactivate' | translate }}\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  [backdropStyle]=\"'dark'\"\n  [confirmClassOverrides]=\"'e11-bg-skin-error'\"\n  [isMobile]=\"false\"\n  (answer)=\"confirmDeactivation($event); confirmation.confirmationForm.reset()\"\n  [confirmValueWithInputBox]=\"true\"\n  [valueToConfirm]=\"_confirmationPhrase\"\n>\n  <div>\n    {{\n      \"WARNING: Are you sure you want to deactivate this account? This is permanent and all accounts associated with this account will be removed.\"\n        | translate\n    }}\n    <p class=\"e11-my-2\">\n      {{ \"Please confirm that you want to deactivate this account by typing: \" | translate }}\n      <span class=\"e11-font-semibold\"> {{ _confirmationPhrase }}</span>\n    </p>\n  </div>\n</e11-confirmation>\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4$2.E11ConfirmationComponent, selector: "e11-confirmation", inputs: ["confirmTitle", "confirmText", "cancelText", "confirmClassOverrides", "cancelClassOverrides", "isMobile", "processing", "processingText", "closeOnEscape", "closeOnClickOutside", "hasBackdrop", "backdropStyle", "confirmValueWithInputBox", "valueToConfirm"], outputs: ["answer"] }, { kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i5$1.E11TextareaComponent, selector: "e11-textarea", inputs: ["name", "id", "cols", "rows", "label", "required", "labelColor", "borderGlow", "readonly", "disabled", "disabledText", "hasError", "parentForm", "placeholder", "darkMode", "maxLength", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "formControlName", "containerClass", "inputClass", "loading", "tooltipConfig", "labelTextOptional"], outputs: ["change", "focus", "blur"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DeregisterBaseComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-deregister-base', template: "<div>\n  <e11-button\n    (click)=\"confirmation.open()\"\n    [color]=\"'secondary'\"\n    [disabled]=\"loading\"\n    [iconPosition]=\"'left'\"\n    [iconSize]=\"'md-18'\"\n    [icon]=\"'no_accounts'\"\n    [type]=\"'button'\"\n    id=\"degresiter_button\"\n    [size]=\"size\"\n    value=\"{{ loading ? 'Deactivating...' : ('Deactivate Account' | translate) }}\"\n  >\n  </e11-button>\n</div>\n\n<ng-template #deactivationModal>\n  <ng-container *ngIf=\"skippedSurvey === null; else confirmDeactivation\">\n    <div class=\"e11-mb-10\">\n      <h2 class=\"e11-text-skin-primary-accent\">{{ \"Sorry to see you go\" | translate }}</h2>\n      <p>{{ \"Please take just a second to answer a few questions\" | translate }}</p>\n    </div>\n\n    <div *ngIf=\"customDeactivationReasons?.length\" class=\"e11-mb-8\">\n      <p class=\"e11-mb-2 e11-font-primary-medium\">{{ \"Reason for deactivation\" | translate }}</p>\n      <div class=\"e11-grid md:e11-grid-cols-2 e11-gap-4\">\n        <div\n          (click)=\"selectedCustomReason = reason\"\n          *ngFor=\"let reason of customDeactivationReasons\"\n          [ngClass]=\"{\n            'e11-bg-skin-primary-accent e11-text-skin-white': selectedCustomReason?.reasonCode === reason.reasonCode,\n            'e11-bg-skin-grey/10 hover:e11-border-skin-primary-accent hover:e11-text-skin-primary-accent':\n              selectedCustomReason?.reasonCode !== reason.reasonCode\n          }\"\n          class=\"e11-w-full md:e11-col-span-1 e11-cursor-pointer e11-p-2 e11-border e11-rounded e11-border-skin-grey\"\n        >\n          <span class=\"e11-font-primary-medium\">{{ reason.reasonText | translate }}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"e11-mb-8\">\n      <p class=\"e11-mb-2 e11-font-primary-medium\">{{ \"How likely are you to recommend this product\" | translate }}</p>\n      <div class=\"e11-flex e11-gap-4\">\n        <div\n          (click)=\"recommendScore = score\"\n          *ngFor=\"let score of [1, 2, 3, 4, 5]\"\n          [ngClass]=\"{\n            'e11-bg-skin-primary-accent e11-text-skin-white': recommendScore === score,\n            'e11-bg-skin-grey/10 hover:e11-border-skin-primary-accent hover:e11-text-skin-primary-accent': recommendScore !== score\n          }\"\n          class=\"e11-w-[50px] e11-h-[50px] e11-flex e11-justify-center e11-items-center e11-cursor-pointer e11-border e11-rounded-full e11-border-skin-grey\"\n        >\n          <span class=\"e11-font-primary-medium\">{{ score }}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"e11-mb-5\">\n      <p class=\"e11-mb-2 e11-font-primary-medium\">{{ \"Anything else you'd like to add?\" | translate }}</p>\n      <e11-textarea (change)=\"otherText = $event\"></e11-textarea>\n    </div>\n\n    <div>\n      <div class=\"e11-flex e11-justify-end e11-gap-2\">\n        <e11-button (click)=\"modalGlobal.closeModal()\" [ghost]=\"true\" [value]=\"'Close' | translate\" color=\"cancel\" size=\"md\"></e11-button>\n\n        <e11-button (click)=\"skippedSurvey = true\" [ghost]=\"true\" [value]=\"'Skip' | translate\" color=\"secondary\" size=\"md\"></e11-button>\n\n        <e11-button (click)=\"skippedSurvey = false\" [value]=\"'Continue' | translate\" color=\"primary-accent\" size=\"md\"></e11-button>\n      </div>\n    </div>\n  </ng-container>\n\n  <ng-template #confirmDeactivation>\n    <div class=\"e11-px-6 e11-flex e11-gap-2 e11-items-center e11-mb-8\">\n      <span class=\"material-icons-outlined e11-text-skin-error e11-rounded-full e11-bg-red-200\">crisis_alert </span>\n      <h2 class=\"e11-text-skin-error\">\n        {{ \"Deactivate Account\" | translate }}\n      </h2>\n    </div>\n\n    <div class=\"e11-px-6 e11-pb-4\">\n      <p class=\"e11-font-primary-medium\">\n        {{\n          \"Are you sure you want to deactivate this account? This is permanent and all accounts associated with this account will be removed.\"\n            | translate\n        }}\n      </p>\n      <p class=\"e11-font-primary-bold\">{{ \"Are you absolutely certain you want to deactivate this account?\" | translate }}</p>\n    </div>\n\n    <div class=\"e11-flex e11-justify-center e11-items-center e11-gap-4 e11-w-full e11-px-6 e11-pb-6\">\n      <e11-button\n        (click)=\"modalGlobal.closeModal()\"\n        [buttonStyle]=\"'pill'\"\n        [color]=\"'neutral'\"\n        [ghost]=\"true\"\n        [iconPosition]=\"'left'\"\n        [icon]=\"'close'\"\n        [value]=\"'Cancel' | translate\"\n      ></e11-button>\n\n      <e11-button\n        (click)=\"deregister()\"\n        [color]=\"'secondary'\"\n        [iconPosition]=\"'left'\"\n        [icon]=\"'done'\"\n        [style]=\"'pill outlined'\"\n        value=\"{{ loading ? ('Deactivating...' | translate) : ('Deactivate' | translate) }}\"\n      ></e11-button>\n    </div>\n  </ng-template>\n</ng-template>\n\n<e11-confirmation\n  #confirmation\n  confirmTitle=\"{{ 'Deactivate account' | translate }}\"\n  confirmText=\"{{ 'Deactivate' | translate }}\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  [backdropStyle]=\"'dark'\"\n  [confirmClassOverrides]=\"'e11-bg-skin-error'\"\n  [isMobile]=\"false\"\n  (answer)=\"confirmDeactivation($event); confirmation.confirmationForm.reset()\"\n  [confirmValueWithInputBox]=\"true\"\n  [valueToConfirm]=\"_confirmationPhrase\"\n>\n  <div>\n    {{\n      \"WARNING: Are you sure you want to deactivate this account? This is permanent and all accounts associated with this account will be removed.\"\n        | translate\n    }}\n    <p class=\"e11-my-2\">\n      {{ \"Please confirm that you want to deactivate this account by typing: \" | translate }}\n      <span class=\"e11-font-semibold\"> {{ _confirmationPhrase }}</span>\n    </p>\n  </div>\n</e11-confirmation>\n" }]
        }], ctorParameters: () => [{ type: i1$1.E11ModalGlobalService }], propDecorators: { customDeactivationReasons: [{
                type: Input
            }], confirmationPhrase: [{
                type: Input
            }], size: [{
                type: Input
            }], customerKey: [{
                type: Input
            }], deactivationModal: [{
                type: ViewChild,
                args: ['deactivationModal']
            }], deactivate: [{
                type: Output
            }] } });

class DeregisterPlatformAdminComponent {
    constructor(registrationService) {
        this.registrationService = registrationService;
        this.deactivated = new EventEmitter();
        this.customDeactivationReasons = [
            { reasonCode: '1', reasonText: 'Subscription costs' },
            { reasonCode: '2', reasonText: 'Difficulty using the site' },
            { reasonCode: '3', reasonText: 'Did not work' },
            { reasonCode: '3', reasonText: 'Customer Success issues' },
            { reasonCode: '3', reasonText: 'No longer need the software' },
            { reasonCode: '4', reasonText: 'Other' },
        ];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DeregisterPlatformAdminComponent, deps: [{ token: RegistrationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: DeregisterPlatformAdminComponent, selector: "sdk-registration-deregister-platform-admin", inputs: { customerKey: "customerKey" }, outputs: { deactivated: "deactivated" }, ngImport: i0, template: "<sdk-deregister-base\n  [customerKey]=\"customerKey\"\n  [customDeactivationReasons]=\"customDeactivationReasons\"\n  [size]=\"'sm'\"\n  (deactivate)=\"deactivated.emit(true)\"\n></sdk-deregister-base>\n", styles: [""], dependencies: [{ kind: "component", type: DeregisterBaseComponent, selector: "sdk-deregister-base", inputs: ["customDeactivationReasons", "confirmationPhrase", "size", "customerKey"], outputs: ["deactivate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DeregisterPlatformAdminComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-registration-deregister-platform-admin', template: "<sdk-deregister-base\n  [customerKey]=\"customerKey\"\n  [customDeactivationReasons]=\"customDeactivationReasons\"\n  [size]=\"'sm'\"\n  (deactivate)=\"deactivated.emit(true)\"\n></sdk-deregister-base>\n" }]
        }], ctorParameters: () => [{ type: RegistrationService }], propDecorators: { customerKey: [{
                type: Input
            }], deactivated: [{
                type: Output
            }] } });

class DeregisterComponent {
    set confirmationPhrase(confirmationPhrase) {
        this._confirmationPhrase = confirmationPhrase;
    }
    constructor(authService, logger, modalGlobal) {
        this.authService = authService;
        this.logger = logger;
        this.modalGlobal = modalGlobal;
        this._confirmationPhrase = 'Deactivate';
        this.accountDeactivated = new EventEmitter();
        this.loading = false;
        this.allowAccountClose = false;
        this.loading$ = new BehaviorSubject(false);
    }
    async ngOnInit() {
        this.loading = true;
        const idToken = await this.authService.getIdToken();
        this.logger.log('idToken', idToken);
        if (idToken && idToken.claims && idToken.claims.customerKey && idToken.token) {
            this.customerKey = idToken.claims.customerKey;
            this.allowAccountClose = true;
        }
        else {
            this.loading = false;
            throw e11Error({
                title: 'Invalid ID Token',
                type: REGISTRATION_ERRORS.INVALID_TOKEN,
                message: 'Unable to find customerKey or auth token for user, closing the account is not allowed.',
            });
        }
        this.loading = false;
    }
    async deactivate(deregisterRequest) {
        this.accountDeactivated.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DeregisterComponent, deps: [{ token: i2$1.AuthService }, { token: i1.E11Logger }, { token: i1$1.E11ModalGlobalService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: DeregisterComponent, selector: "sdk-registration-deregister", inputs: { customDeactivationReasons: "customDeactivationReasons", confirmationPhrase: "confirmationPhrase" }, outputs: { accountDeactivated: "accountDeactivated" }, viewQueries: [{ propertyName: "deactivationModal", first: true, predicate: ["deactivationModal"], descendants: true }], ngImport: i0, template: "<sdk-deregister-base\n  *ngIf=\"allowAccountClose\"\n  [customerKey]=\"customerKey\"\n  [customDeactivationReasons]=\"customDeactivationReasons\"\n  (deactivate)=\"deactivate($event)\"\n></sdk-deregister-base>\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DeregisterBaseComponent, selector: "sdk-deregister-base", inputs: ["customDeactivationReasons", "confirmationPhrase", "size", "customerKey"], outputs: ["deactivate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DeregisterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-registration-deregister', template: "<sdk-deregister-base\n  *ngIf=\"allowAccountClose\"\n  [customerKey]=\"customerKey\"\n  [customDeactivationReasons]=\"customDeactivationReasons\"\n  (deactivate)=\"deactivate($event)\"\n></sdk-deregister-base>\n" }]
        }], ctorParameters: () => [{ type: i2$1.AuthService }, { type: i1.E11Logger }, { type: i1$1.E11ModalGlobalService }], propDecorators: { customDeactivationReasons: [{
                type: Input
            }], confirmationPhrase: [{
                type: Input
            }], deactivationModal: [{
                type: ViewChild,
                args: ['deactivationModal']
            }], accountDeactivated: [{
                type: Output
            }] } });

const errorMessage = 'We were unable to process your registration, please request a new invite and try again';
class EmployeeRegistrationComponent {
    constructor(configProvider, formBuilder, customValidator, registrationService, customFormValidation, errorHandler, termsService, _sanitizer) {
        this.configProvider = configProvider;
        this.formBuilder = formBuilder;
        this.customValidator = customValidator;
        this.registrationService = registrationService;
        this.customFormValidation = customFormValidation;
        this.errorHandler = errorHandler;
        this.termsService = termsService;
        this._sanitizer = _sanitizer;
        this.formPasswordSubmitted = false;
        this.passwordMinLength = { value: 8 };
        this.formEmailSubmitted = false;
        this.formRegisterSubmitted = false;
        this.userEmail = '';
        this.userEmailInUse = false;
        this.loading = false;
        this.loadingValidation = false;
        this.onSubmit = new EventEmitter();
        this.onError = new EventEmitter();
        this.destroy$ = new Subject();
    }
    async ngOnInit() {
        this.termsService
            .getMostRecentTerms()
            .pipe(takeUntil(this.destroy$))
            .subscribe((termsModels) => {
            this.termsModel = termsModels[0];
            this.termsOfUse = this._sanitizer.bypassSecurityTrustHtml(termsModels[0].terms);
        });
        if (this.registrationCode) {
            this.loadingValidation = true;
            setTimeout(() => {
                this.captchaRefInvitation.execute();
            }, 200);
        }
    }
    async validateRegistrationCode(captchaResponse) {
        if (captchaResponse) {
            if (!this.registrationCode) {
                this.loadingValidation = false;
                return;
            }
            try {
                const response = await this.registrationService.validateRegistrationCode(this.registrationCode, captchaResponse);
                this.createForm(response);
                this.employeeInviteData = response;
            }
            catch (err) {
                this.errorMessage = errorMessage;
                if (isE11ErrorOfType(err, REGISTRATION_ERRORS.INVITATION_NOT_FOUND))
                    this.errorHandler.handleError(err, { alertUser: true, level: 'warning' });
                else
                    this.errorHandler.handleError(err, { alertUser: true });
            }
            finally {
                this.loadingValidation = false;
                this.captchaRefInvitation?.reset();
            }
        }
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    createForm(data) {
        this.formRegister = this.formBuilder.group({
            firstName: new FormControl({ value: data.firstName, disabled: true }, [Validators.required, this.customFormValidation.nameValidator()]),
            lastName: new FormControl({ value: data.lastName, disabled: true }, [Validators.required]),
            email: new FormControl({ value: data.email, disabled: true }, [Validators.required, this.customValidator.emailValidator()]),
            password: new FormControl('', [Validators.required, Validators.minLength(8), this.customValidator.hasNumberValidator()]),
            passwordConfirm: new FormControl('', [Validators.required, Validators.minLength(8)]),
        }, {
            validator: [this.customValidator.passwordMatch('password', 'passwordConfirm')],
        });
    }
    get fe() {
        return this.formRegister.controls;
    }
    get f() {
        return this.formRegister.controls;
    }
    async onSubmitFormRegister(captchaResponse) {
        this.formRegisterSubmitted = true;
        if (this.formRegister?.valid && this.employeeInviteData?.email && this.registrationCode) {
            this.loading = true;
            try {
                const result = await this.registrationService.registerEmployeeUserV2(this.map(), captchaResponse);
                this.onSubmit.emit({ appUser: result.appUser, authToken: result.authToken });
            }
            catch (e) {
                this.errorHandler.handleError(e, { alertUser: true });
                this.errorMessage = errorMessage;
                await this.registrationService.abort(this.formRegister.value.password);
            }
            finally {
                this.loading = false;
            }
        }
    }
    async resolved(captchaResponse) {
        if (captchaResponse) {
            await this.onSubmitFormRegister(captchaResponse);
            this.captchaRef?.reset();
        }
    }
    map() {
        const registrationModel = {
            userType: UserType.Business,
            registrationCode: this.registrationCode,
            authTenantId: this.configProvider.config.authTenantId,
            password: this.formRegister?.value.password,
            termsVersionAccepted: this.termsModel.version,
        };
        return registrationModel;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: EmployeeRegistrationComponent, deps: [{ token: BaseRegistrationConfigProvider }, { token: i2$5.FormBuilder }, { token: FormCustomValidationService }, { token: IRegistrationService }, { token: FormCustomValidationService }, { token: i1.E11ErrorHandlerService }, { token: i6.TermsService }, { token: i4$4.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: EmployeeRegistrationComponent, selector: "sdk-registration-employee", inputs: { registrationCode: "registrationCode" }, outputs: { onSubmit: "onSubmit", onError: "onError" }, viewQueries: [{ propertyName: "captchaRef", first: true, predicate: ["captchaRef"], descendants: true }, { propertyName: "captchaRefInvitation", first: true, predicate: ["captchaRefInvitation"], descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"!errorMessage && !loadingValidation\">\n  <form\n    *ngIf=\"formRegister\"\n    id=\"form_register\"\n    class=\"form register\"\n    [formGroup]=\"formRegister\"\n    (ngSubmit)=\"captchaRef.execute()\"\n    class=\"userEmail\"\n    novalidate\n  >\n    <e11-loader-dots\n      *ngIf=\"loading\"\n      [size]=\"'md'\"\n      [fullScreen]=\"true\"\n      [color]=\"'e11-bg-skin-primary-accent'\"\n      [hasBackdrop]=\"true\"\n      [fontColor]=\"'e11-text-white'\"\n      label=\"{{ 'Creating account...' | translate }}\"\n    ></e11-loader-dots>\n\n    <div class=\"row\">\n      <div class=\"col-sm-1 hidden-xs\"></div>\n      <div class=\"col-sm-10 col-xs-12 e11-mb-7\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"firstName\"\n          id=\"firstName\"\n          label=\"{{ 'First Name' | translate }}\"\n          [size]=\"'md'\"\n          [parentForm]=\"formRegister\"\n          formControlName=\"firstName\"\n          autocomplete=\"off\"\n          borderGlow=\"primary\"\n          [hasError]=\"(f.firstName.errors && f.firstName.dirty) || (f.firstName.invalid && formRegisterSubmitted)\"\n        >\n        </e11-input>\n      </div>\n      <div class=\"col-sm-1 hidden-xs\"></div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-1 hidden-xs\"></div>\n      <div class=\"col-sm-10 col-xs-12 e11-mb-7\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"lastName\"\n          label=\"{{ 'Last Name' | translate }}\"\n          value=\"lastName\"\n          [size]=\"'md'\"\n          [parentForm]=\"formRegister\"\n          formControlName=\"lastName\"\n          autocomplete=\"off\"\n          borderGlow=\"primary\"\n          [hasError]=\"(f.lastName.errors && f.lastName.dirty) || (f.lastName.invalid && formRegisterSubmitted)\"\n        >\n        </e11-input>\n      </div>\n      <div class=\"col-sm-1 hidden-xs\"></div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-1 hidden-xs\"></div>\n      <div class=\"col-sm-10 col-xs-12 e11-mb-7\">\n        <e11-input\n          [type]=\"'email'\"\n          name=\"email\"\n          id=\"email_formEmail\"\n          label=\"{{ 'Email' | translate }}\"\n          value=\"userEmail\"\n          [size]=\"'md'\"\n          [parentForm]=\"formRegister\"\n          formControlName=\"email\"\n          autocomplete=\"off\"\n          borderGlow=\"primary\"\n          [hasError]=\"(fe.email.errors && fe.email.dirty) || (fe.email.invalid && formEmailSubmitted)\"\n        >\n        </e11-input>\n      </div>\n      <div class=\"col-sm-1 hidden-xs\"></div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-1 hidden-xs\"></div>\n      <div class=\"col-sm-10 col-xs-12\">\n        <e11-input\n          [type]=\"'password'\"\n          name=\"password\"\n          id=\"password\"\n          label=\"{{ 'Password' | translate }}\"\n          [size]=\"'md'\"\n          [parentForm]=\"formRegister\"\n          formControlName=\"password\"\n          autocomplete=\"off\"\n          borderGlow=\"primary\"\n          [required]=\"true\"\n          [togglePassword]=\"true\"\n          [hasError]=\"(f.password.errors && f.password.dirty) || (f.password.invalid && formRegisterSubmitted)\"\n        >\n          <ng-container *ngIf=\"!(formRegisterSubmitted && f.password.errors?.required)\">\n            <e11-input-errors [parentForm]=\"formRegister\" [formControl]=\"f.password\" label=\"{{ 'Password' | translate }}\"> </e11-input-errors>\n          </ng-container>\n          <div\n            *ngIf=\"formRegisterSubmitted && f.password.errors?.required\"\n            class=\"e11-inline-block e11-relative e11-h-7 e11-w-full e11-overflow-hidden\"\n          >\n            <span class=\"e11-absolute e11-text-skin-error e11-text-sm e11-truncate e11-mt-1\"> This is a required field </span>\n          </div>\n        </e11-input>\n      </div>\n      <div class=\"col-sm-1 hidden-xs\"></div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-1 hidden-xs\"></div>\n      <div class=\"col-sm-10 col-xs-12\">\n        <e11-input\n          [type]=\"'password'\"\n          name=\"passwordConfirm\"\n          id=\"password_formConfirmPassword\"\n          label=\"{{ 'Confirm Password' | translate }}\"\n          [size]=\"'md'\"\n          [parentForm]=\"formRegister\"\n          formControlName=\"passwordConfirm\"\n          autocomplete=\"off\"\n          borderGlow=\"primary\"\n          [required]=\"true\"\n          [togglePassword]=\"true\"\n          [hasError]=\"(f.passwordConfirm.errors && f.passwordConfirm.dirty) || (f.passwordConfirm.invalid && formRegisterSubmitted)\"\n        >\n          <ng-container *ngIf=\"!(formRegisterSubmitted && f.passwordConfirm.errors?.required)\">\n            <e11-input-errors [parentForm]=\"formRegister\" [formControl]=\"f.passwordConfirm\" label=\"{{ 'Confirm Password' | translate }}\">\n            </e11-input-errors>\n          </ng-container>\n          <div\n            *ngIf=\"formRegisterSubmitted && f.passwordConfirm.errors?.required\"\n            class=\"e11-inline-block e11-relative e11-h-7 e11-w-full e11-overflow-hidden\"\n          >\n            <span class=\"e11-absolute e11-text-skin-error e11-text-sm e11-truncate e11-mt-1\"> This is a required field </span>\n          </div>\n        </e11-input>\n\n        <div class=\"error-message-password-list\">\n          <div class=\"error-message\">\n            {{ \"Your password must meet the following requirements:\" | translate }}\n          </div>\n          <div\n            class=\"error-message\"\n            [ngClass]=\"{\n              'e11-text-skin-error': f.password.hasError('minlength') || (formRegisterSubmitted && f.password.invalid),\n              'pass e11-text-skin-success': !f.password.hasError('minlength') && f.password.dirty && f.password.value.length > 0\n            }\"\n          >\n            {{ 'Minimum length is {{value}} characters' | translate: passwordMinLength }} <i class=\"fas fa-check\"></i>\n          </div>\n          <div\n            class=\"error-message\"\n            [ngClass]=\"{\n              'e11-text-skin-error': f.password.hasError('hasNumberError') || (formRegisterSubmitted && f.password.invalid),\n              'pass e11-text-skin-success': !f.password.hasError('hasNumberError') && f.password.dirty && f.password.value.length > 0\n            }\"\n          >\n            {{ \"Include 1 number\" | translate }} <i class=\"fas fa-check\"></i>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-sm-1 hidden-xs\"></div>\n    </div>\n\n    <e11-button\n      id=\"submit_formRegister\"\n      value=\"{{ loading ? 'Loading...' : ('Create Account' | translate) }}\"\n      [color]=\"'primary'\"\n      [type]=\"'submit'\"\n      [display]=\"'block'\"\n    >\n    </e11-button>\n  </form>\n  <div class=\"e11-w-full e11-text-xs e11-text-center\">\n    <p>\n      {{ \"By continuing you are agreeing to our\" | translate }}\n      <span class=\"e11-text-skin-primary-accent e11-cursor-pointer\" (click)=\"modalTerms.open()\">{{ \"Terms of Use\" | translate }}</span\n      >.\n    </p>\n  </div>\n</ng-container>\n<re-captcha #captchaRef=\"reCaptcha\" size=\"invisible\" (resolved)=\"resolved($event)\"></re-captcha>\n<re-captcha #captchaRefInvitation size=\"invisible\" (resolved)=\"validateRegistrationCode($event)\"></re-captcha>\n\n<e11-loader-dots\n  *ngIf=\"loadingValidation\"\n  [size]=\"'md'\"\n  [color]=\"'e11-bg-skin-primary-accent'\"\n  label=\"{{ 'Validating link...' | translate }}\"\n></e11-loader-dots>\n\n<div *ngIf=\"errorMessage\">\n  <h3 class=\"e11-mb-4\">{{ \"An Error Occurred\" | translate }}</h3>\n  <p class=\"e11-text-skin-error\">\n    {{ errorMessage | translate }}\n  </p>\n</div>\n\n<e11-modal\n  #modalTerms\n  [title]=\"'Terms of Use' | translate\"\n  [showHeader]=\"true\"\n  [hideCloseButton]=\"false\"\n  [width]=\"'lg'\"\n  [bodyClassOverrides]=\"'e11-h-[55vh]'\"\n>\n  <div modal-body>\n    <ng-container *ngIf=\"termsOfUse\">\n      <div [innerHTML]=\"termsOfUse\"></div>\n    </ng-container>\n  </div>\n\n  <div modal-footer>\n    <div class=\"e11-text-center\">\n      <e11-button [type]=\"'button'\" value=\"{{ 'Close' | translate }}\" color=\"neutral\" (click)=\"modalTerms.close()\"> </e11-button>\n    </div>\n  </div>\n</e11-modal>\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$5.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$5.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$5.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2$5.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$5.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$5.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i7$2.RecaptchaComponent, selector: "re-captcha", inputs: ["id", "siteKey", "theme", "type", "size", "tabIndex", "badge", "errorMode"], outputs: ["resolved", "error", "errored"], exportAs: ["reCaptcha"] }, { kind: "component", type: i4$3.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i2$4.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i1$1.E11ModalComponent, selector: "e11-modal", inputs: ["title", "width", "bodyHeight", "titleAlign", "hideCloseButton", "closer", "bodyClassOverrides", "bodyClass", "modalClassOverrides", "modalClass", "contentClassOverrides", "contentClass", "headerClassOverrides", "headerClass", "footerClassOverrides", "footerClass", "showFooter", "showHeader", "darkMode", "closeOnEscape", "closeOnClickOutside", "headerCTAs", "hasBackdrop", "backdropStyle"], outputs: ["modalOpened", "onModalOpened", "modalClosed", "onModalClosed", "headerCTAClicked", "onHeaderCTAClicked"] }, { kind: "component", type: i7$1.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "pipe", type: i6$1.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: EmployeeRegistrationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-registration-employee', template: "<ng-container *ngIf=\"!errorMessage && !loadingValidation\">\n  <form\n    *ngIf=\"formRegister\"\n    id=\"form_register\"\n    class=\"form register\"\n    [formGroup]=\"formRegister\"\n    (ngSubmit)=\"captchaRef.execute()\"\n    class=\"userEmail\"\n    novalidate\n  >\n    <e11-loader-dots\n      *ngIf=\"loading\"\n      [size]=\"'md'\"\n      [fullScreen]=\"true\"\n      [color]=\"'e11-bg-skin-primary-accent'\"\n      [hasBackdrop]=\"true\"\n      [fontColor]=\"'e11-text-white'\"\n      label=\"{{ 'Creating account...' | translate }}\"\n    ></e11-loader-dots>\n\n    <div class=\"row\">\n      <div class=\"col-sm-1 hidden-xs\"></div>\n      <div class=\"col-sm-10 col-xs-12 e11-mb-7\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"firstName\"\n          id=\"firstName\"\n          label=\"{{ 'First Name' | translate }}\"\n          [size]=\"'md'\"\n          [parentForm]=\"formRegister\"\n          formControlName=\"firstName\"\n          autocomplete=\"off\"\n          borderGlow=\"primary\"\n          [hasError]=\"(f.firstName.errors && f.firstName.dirty) || (f.firstName.invalid && formRegisterSubmitted)\"\n        >\n        </e11-input>\n      </div>\n      <div class=\"col-sm-1 hidden-xs\"></div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-1 hidden-xs\"></div>\n      <div class=\"col-sm-10 col-xs-12 e11-mb-7\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"lastName\"\n          label=\"{{ 'Last Name' | translate }}\"\n          value=\"lastName\"\n          [size]=\"'md'\"\n          [parentForm]=\"formRegister\"\n          formControlName=\"lastName\"\n          autocomplete=\"off\"\n          borderGlow=\"primary\"\n          [hasError]=\"(f.lastName.errors && f.lastName.dirty) || (f.lastName.invalid && formRegisterSubmitted)\"\n        >\n        </e11-input>\n      </div>\n      <div class=\"col-sm-1 hidden-xs\"></div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-1 hidden-xs\"></div>\n      <div class=\"col-sm-10 col-xs-12 e11-mb-7\">\n        <e11-input\n          [type]=\"'email'\"\n          name=\"email\"\n          id=\"email_formEmail\"\n          label=\"{{ 'Email' | translate }}\"\n          value=\"userEmail\"\n          [size]=\"'md'\"\n          [parentForm]=\"formRegister\"\n          formControlName=\"email\"\n          autocomplete=\"off\"\n          borderGlow=\"primary\"\n          [hasError]=\"(fe.email.errors && fe.email.dirty) || (fe.email.invalid && formEmailSubmitted)\"\n        >\n        </e11-input>\n      </div>\n      <div class=\"col-sm-1 hidden-xs\"></div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-1 hidden-xs\"></div>\n      <div class=\"col-sm-10 col-xs-12\">\n        <e11-input\n          [type]=\"'password'\"\n          name=\"password\"\n          id=\"password\"\n          label=\"{{ 'Password' | translate }}\"\n          [size]=\"'md'\"\n          [parentForm]=\"formRegister\"\n          formControlName=\"password\"\n          autocomplete=\"off\"\n          borderGlow=\"primary\"\n          [required]=\"true\"\n          [togglePassword]=\"true\"\n          [hasError]=\"(f.password.errors && f.password.dirty) || (f.password.invalid && formRegisterSubmitted)\"\n        >\n          <ng-container *ngIf=\"!(formRegisterSubmitted && f.password.errors?.required)\">\n            <e11-input-errors [parentForm]=\"formRegister\" [formControl]=\"f.password\" label=\"{{ 'Password' | translate }}\"> </e11-input-errors>\n          </ng-container>\n          <div\n            *ngIf=\"formRegisterSubmitted && f.password.errors?.required\"\n            class=\"e11-inline-block e11-relative e11-h-7 e11-w-full e11-overflow-hidden\"\n          >\n            <span class=\"e11-absolute e11-text-skin-error e11-text-sm e11-truncate e11-mt-1\"> This is a required field </span>\n          </div>\n        </e11-input>\n      </div>\n      <div class=\"col-sm-1 hidden-xs\"></div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-1 hidden-xs\"></div>\n      <div class=\"col-sm-10 col-xs-12\">\n        <e11-input\n          [type]=\"'password'\"\n          name=\"passwordConfirm\"\n          id=\"password_formConfirmPassword\"\n          label=\"{{ 'Confirm Password' | translate }}\"\n          [size]=\"'md'\"\n          [parentForm]=\"formRegister\"\n          formControlName=\"passwordConfirm\"\n          autocomplete=\"off\"\n          borderGlow=\"primary\"\n          [required]=\"true\"\n          [togglePassword]=\"true\"\n          [hasError]=\"(f.passwordConfirm.errors && f.passwordConfirm.dirty) || (f.passwordConfirm.invalid && formRegisterSubmitted)\"\n        >\n          <ng-container *ngIf=\"!(formRegisterSubmitted && f.passwordConfirm.errors?.required)\">\n            <e11-input-errors [parentForm]=\"formRegister\" [formControl]=\"f.passwordConfirm\" label=\"{{ 'Confirm Password' | translate }}\">\n            </e11-input-errors>\n          </ng-container>\n          <div\n            *ngIf=\"formRegisterSubmitted && f.passwordConfirm.errors?.required\"\n            class=\"e11-inline-block e11-relative e11-h-7 e11-w-full e11-overflow-hidden\"\n          >\n            <span class=\"e11-absolute e11-text-skin-error e11-text-sm e11-truncate e11-mt-1\"> This is a required field </span>\n          </div>\n        </e11-input>\n\n        <div class=\"error-message-password-list\">\n          <div class=\"error-message\">\n            {{ \"Your password must meet the following requirements:\" | translate }}\n          </div>\n          <div\n            class=\"error-message\"\n            [ngClass]=\"{\n              'e11-text-skin-error': f.password.hasError('minlength') || (formRegisterSubmitted && f.password.invalid),\n              'pass e11-text-skin-success': !f.password.hasError('minlength') && f.password.dirty && f.password.value.length > 0\n            }\"\n          >\n            {{ 'Minimum length is {{value}} characters' | translate: passwordMinLength }} <i class=\"fas fa-check\"></i>\n          </div>\n          <div\n            class=\"error-message\"\n            [ngClass]=\"{\n              'e11-text-skin-error': f.password.hasError('hasNumberError') || (formRegisterSubmitted && f.password.invalid),\n              'pass e11-text-skin-success': !f.password.hasError('hasNumberError') && f.password.dirty && f.password.value.length > 0\n            }\"\n          >\n            {{ \"Include 1 number\" | translate }} <i class=\"fas fa-check\"></i>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-sm-1 hidden-xs\"></div>\n    </div>\n\n    <e11-button\n      id=\"submit_formRegister\"\n      value=\"{{ loading ? 'Loading...' : ('Create Account' | translate) }}\"\n      [color]=\"'primary'\"\n      [type]=\"'submit'\"\n      [display]=\"'block'\"\n    >\n    </e11-button>\n  </form>\n  <div class=\"e11-w-full e11-text-xs e11-text-center\">\n    <p>\n      {{ \"By continuing you are agreeing to our\" | translate }}\n      <span class=\"e11-text-skin-primary-accent e11-cursor-pointer\" (click)=\"modalTerms.open()\">{{ \"Terms of Use\" | translate }}</span\n      >.\n    </p>\n  </div>\n</ng-container>\n<re-captcha #captchaRef=\"reCaptcha\" size=\"invisible\" (resolved)=\"resolved($event)\"></re-captcha>\n<re-captcha #captchaRefInvitation size=\"invisible\" (resolved)=\"validateRegistrationCode($event)\"></re-captcha>\n\n<e11-loader-dots\n  *ngIf=\"loadingValidation\"\n  [size]=\"'md'\"\n  [color]=\"'e11-bg-skin-primary-accent'\"\n  label=\"{{ 'Validating link...' | translate }}\"\n></e11-loader-dots>\n\n<div *ngIf=\"errorMessage\">\n  <h3 class=\"e11-mb-4\">{{ \"An Error Occurred\" | translate }}</h3>\n  <p class=\"e11-text-skin-error\">\n    {{ errorMessage | translate }}\n  </p>\n</div>\n\n<e11-modal\n  #modalTerms\n  [title]=\"'Terms of Use' | translate\"\n  [showHeader]=\"true\"\n  [hideCloseButton]=\"false\"\n  [width]=\"'lg'\"\n  [bodyClassOverrides]=\"'e11-h-[55vh]'\"\n>\n  <div modal-body>\n    <ng-container *ngIf=\"termsOfUse\">\n      <div [innerHTML]=\"termsOfUse\"></div>\n    </ng-container>\n  </div>\n\n  <div modal-footer>\n    <div class=\"e11-text-center\">\n      <e11-button [type]=\"'button'\" value=\"{{ 'Close' | translate }}\" color=\"neutral\" (click)=\"modalTerms.close()\"> </e11-button>\n    </div>\n  </div>\n</e11-modal>\n" }]
        }], ctorParameters: () => [{ type: BaseRegistrationConfigProvider }, { type: i2$5.FormBuilder }, { type: FormCustomValidationService }, { type: IRegistrationService }, { type: FormCustomValidationService }, { type: i1.E11ErrorHandlerService }, { type: i6.TermsService }, { type: i4$4.DomSanitizer }], propDecorators: { captchaRef: [{
                type: ViewChild,
                args: ['captchaRef']
            }], captchaRefInvitation: [{
                type: ViewChild,
                args: ['captchaRefInvitation']
            }], registrationCode: [{
                type: Input
            }], onSubmit: [{
                type: Output
            }], onError: [{
                type: Output
            }] } });

class PlatformAdminInvitedListComponent {
    constructor(registrationInviteService, notificationsService) {
        this.registrationInviteService = registrationInviteService;
        this.notificationsService = notificationsService;
        this.invitedUsers = [];
        this.loading = false;
    }
    async ngOnInit() {
        await this.loadInvitedUsers();
    }
    async loadInvitedUsers() {
        if (this.customerKey) {
            this.loading = true;
            this.invitedUsers = await firstValueFrom(this.registrationInviteService.getInvitedUsers(this.customerKey));
            this.loading = false;
        }
    }
    async resend(invite) {
        if (this.customerKey) {
            this.loading = true;
            await this.registrationInviteService.resendInvite(invite, this.customerKey);
            this.loading = false;
            this.notificationsService.popNotificationMessage(inviteSentNotif$1(invite));
        }
    }
    async delete(invite) {
        if (this.customerKey) {
            this.loading = true;
            await this.registrationInviteService.deleteInvite(invite, this.customerKey);
            this.loading = false;
            this.loadInvitedUsers();
            this.notificationsService.popNotificationMessage(inviteDeletedNotif$1(invite));
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminInvitedListComponent, deps: [{ token: PlatformAdminRegistrationInviteService }, { token: i3$4.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: PlatformAdminInvitedListComponent, selector: "sdk-invited-user-list-platform-admin", inputs: { customerKey: "customerKey" }, ngImport: i0, template: `
    <ui-invited-user-list
      [invitedUsers]="invitedUsers"
      [loading]="loading"
      (resend)="resend($event)"
      (delete)="delete($event)"
    ></ui-invited-user-list>
  `, isInline: true, dependencies: [{ kind: "component", type: UIInvitedListComponent, selector: "ui-invited-user-list", inputs: ["invitedUsers", "loading", "allowDelete", "allowResend"], outputs: ["resend", "delete"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminInvitedListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-invited-user-list-platform-admin',
                    template: `
    <ui-invited-user-list
      [invitedUsers]="invitedUsers"
      [loading]="loading"
      (resend)="resend($event)"
      (delete)="delete($event)"
    ></ui-invited-user-list>
  `,
                }]
        }], ctorParameters: () => [{ type: PlatformAdminRegistrationInviteService }, { type: i3$4.E11NotificationsService }], propDecorators: { customerKey: [{
                type: Input
            }] } });
const inviteDeletedNotif$1 = (invite) => ({
    title: 'Invite Deleted',
    message: `The invite for ${invite.firstName} ${invite.lastName} has been deleted.`,
    type: 'success',
    autoClose: false,
    dismissOnRouteChange: true,
});
const inviteSentNotif$1 = (invite) => ({
    title: 'Invite Sent',
    message: `The invite for ${invite.firstName} ${invite.lastName} has been sent.`,
    type: 'success',
    autoClose: true,
    dismissOnRouteChange: true,
});

class InvitedListComponent {
    constructor(registrationInviteService, notificationsService) {
        this.registrationInviteService = registrationInviteService;
        this.notificationsService = notificationsService;
        this.invitedUsers = [];
        this.loading = false;
    }
    async ngOnInit() {
        await this.loadInvitedUsers();
    }
    async loadInvitedUsers() {
        this.loading = true;
        this.invitedUsers = await firstValueFrom(this.registrationInviteService.getInvitedUsers());
        this.loading = false;
    }
    async resend(invite) {
        this.loading = true;
        await this.registrationInviteService.resendInvite(invite);
        this.loading = false;
        this.notificationsService.popNotificationMessage(inviteSentNotif(invite));
    }
    async delete(invite) {
        this.loading = true;
        await this.registrationInviteService.deleteInvite(invite);
        this.loading = false;
        this.loadInvitedUsers();
        this.notificationsService.popNotificationMessage(inviteDeletedNotif(invite));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: InvitedListComponent, deps: [{ token: RegistrationInviteService }, { token: i3$4.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: InvitedListComponent, selector: "sdk-invited-user-list", inputs: { encodedAuthToken: "encodedAuthToken" }, ngImport: i0, template: `
    <ui-invited-user-list
      [invitedUsers]="invitedUsers"
      [loading]="loading"
      (resend)="resend($event)"
      (delete)="delete($event)"
    ></ui-invited-user-list>
  `, isInline: true, dependencies: [{ kind: "component", type: UIInvitedListComponent, selector: "ui-invited-user-list", inputs: ["invitedUsers", "loading", "allowDelete", "allowResend"], outputs: ["resend", "delete"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: InvitedListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-invited-user-list',
                    template: `
    <ui-invited-user-list
      [invitedUsers]="invitedUsers"
      [loading]="loading"
      (resend)="resend($event)"
      (delete)="delete($event)"
    ></ui-invited-user-list>
  `,
                }]
        }], ctorParameters: () => [{ type: RegistrationInviteService }, { type: i3$4.E11NotificationsService }], propDecorators: { encodedAuthToken: [{
                type: Input
            }] } });
const inviteDeletedNotif = (invite) => ({
    title: 'Invite Deleted',
    message: `The invite for ${invite.firstName} ${invite.lastName} has been deleted.`,
    type: 'success',
    autoClose: false,
    dismissOnRouteChange: true,
});
const inviteSentNotif = (invite) => ({
    title: 'Invite Sent',
    message: `The invite for ${invite.firstName} ${invite.lastName} has been sent.`,
    type: 'success',
    autoClose: true,
    dismissOnRouteChange: true,
});

class UserIdenticonComponent {
    constructor() {
        this.size = 'md' || 'xs' || 'sm' || 'lg' || 'xl'; // 18, 32, 42, 52, 62... @Todo: test and decide
    }
    ngOnInit() {
        if (this.userId && this.cdnCname) {
            this.pathToIdenticon = IdenticonService.buildPath(this.userId, this.cdnCname);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserIdenticonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: UserIdenticonComponent, selector: "sdk-user-identicon", inputs: { userId: "userId", cdnCname: "cdnCname", size: "size" }, ngImport: i0, template: "<img\n  *ngIf=\"pathToIdenticon\"\n  [src]=\"pathToIdenticon\"\n  class=\"user-avatar user-avatar-size {{ size }} e11-inline-flex e11-border e11-rounded-full e11-border-skin-app-borders e11-bg-white\"\n/>\n", styles: [".user-avatar{clip-path:circle(150px at center);display:inline-flex}.user-avatar.user-avatar-size.xs{width:18px}.user-avatar.user-avatar-size.sm{width:32px}.user-avatar.user-avatar-size.md{width:42px}.user-avatar.user-avatar-size.lg{width:52px}.user-avatar.user-avatar-size.xl{width:62px}\n"], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserIdenticonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-user-identicon', template: "<img\n  *ngIf=\"pathToIdenticon\"\n  [src]=\"pathToIdenticon\"\n  class=\"user-avatar user-avatar-size {{ size }} e11-inline-flex e11-border e11-rounded-full e11-border-skin-app-borders e11-bg-white\"\n/>\n", styles: [".user-avatar{clip-path:circle(150px at center);display:inline-flex}.user-avatar.user-avatar-size.xs{width:18px}.user-avatar.user-avatar-size.sm{width:32px}.user-avatar.user-avatar-size.md{width:42px}.user-avatar.user-avatar-size.lg{width:52px}.user-avatar.user-avatar-size.xl{width:62px}\n"] }]
        }], ctorParameters: () => [], propDecorators: { userId: [{
                type: Input
            }], cdnCname: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class DeactivationCompletedComponent {
    constructor(router) {
        this.router = router;
    }
    ngOnInit() { }
    goHome() {
        this.router.navigate(['/']);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DeactivationCompletedComponent, deps: [{ token: i1$3.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: DeactivationCompletedComponent, selector: "sdk-deactivation-completed", ngImport: i0, template: `
    <div class="e11-p-8 e11-flex e11-justify-center e11-items-center e11-flex-col e11-h-[100vh]">
      <e11-panel>
        <div class="e11-p-5 e11-flex e11-justify-center e11-items-center e11-flex-col e11-h-full">
          <h3 class="e11-text-skin-primary-accent">Thank You</h3>
          <p>Your account has been successfully deactivated.</p>
          <e11-button color="primary-accent" (click)="goHome()" value="Go Home"></e11-button>
        </div>
      </e11-panel>
    </div>
  `, isInline: true, dependencies: [{ kind: "component", type: i2$2.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i3$5.E11PanelComponent, selector: "e11-panel", inputs: ["size", "headerText", "headerSize", "headerBgColor", "headerFontColor", "headerStyle", "ctaIcon", "ctaIconType", "ctaIconSize", "ctaText", "ctaFontColor", "hasBorder", "hasShadow", "containerClassOverrides", "contentClassOverrides", "headerTemplate", "bgOpacity"], outputs: ["ctaClicked"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DeactivationCompletedComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-deactivation-completed',
                    template: `
    <div class="e11-p-8 e11-flex e11-justify-center e11-items-center e11-flex-col e11-h-[100vh]">
      <e11-panel>
        <div class="e11-p-5 e11-flex e11-justify-center e11-items-center e11-flex-col e11-h-full">
          <h3 class="e11-text-skin-primary-accent">Thank You</h3>
          <p>Your account has been successfully deactivated.</p>
          <e11-button color="primary-accent" (click)="goHome()" value="Go Home"></e11-button>
        </div>
      </e11-panel>
    </div>
  `,
                }]
        }], ctorParameters: () => [{ type: i1$3.Router }] });

const routes = [
    {
        path: DEFAULT_DEACTIVATED_PATH,
        component: DeactivationCompletedComponent,
    },
];
class DeregisterRoutingModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DeregisterRoutingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: DeregisterRoutingModule, imports: [i1$3.RouterModule], exports: [RouterModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DeregisterRoutingModule, imports: [RouterModule.forChild(routes), RouterModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DeregisterRoutingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [RouterModule.forChild(routes)],
                    exports: [RouterModule],
                }]
        }] });

const ImportExportModules = [
    E11ConfirmationModule,
    E11InputModule,
    E11ButtonModule,
    E11PanelModule,
    E11LoaderDotsModule,
    E11SelectModule,
    E11SideOverModule,
    E11ModalModule,
    E11MultiSelectModule,
    E11EmptyStateModule,
    E11PhoneNumberModule,
    E11DynamicFormModule,
    E11TooltipModule,
    E11InputErrorsModule.forRoot({
        additional: {
            phoneNumber: 'Please enter a valid phone number',
            invalidDate: 'Please enter a valid date',
            invalidStartDate: 'Must be before end date',
            invalidEndDate: 'Must be after start date',
            DateFuture: 'Must be in the past', // TODO consider how to get static type checking on these
            unacceptedTerms: 'Accept the terms to continue',
            invalidZipCodeError: 'Invalid postal code',
            passwordMatchError: 'Your passwords do not match',
            hasAlphaNumericError: 'Only letters and numbers',
            invalidNameError: 'No numbers or special characters',
        },
    }),
    // REMEMBER: Toast and Notifications are root level
];
const DeclareExportComponents = [
    CreateBusinessUserInviteComponent,
    BusinessUserInviteComponent,
    InvitedListComponent,
    ConsumerRegistrationQuickComponent,
    UserIdenticonComponent,
    RegistrationBusiness,
    EmployeeRegistrationComponent,
    DeregisterComponent,
    ProvisionCustomerTenantComponent,
    ProvisionConsumerTenantComponent,
    ProvisionCustomerClientComponent,
    ProvisionedBootstrapsListComponent,
    ProvisionedCustomerBootstrapComponent,
    ProvisionCustomerComponent,
    ProvisionEditBootstrapComponent,
    FormCustomerProvisionComponent,
    DeprovisionCustomerComponent,
    ReactivateClientCustomerComponent,
    ClientAccountComponent,
    FormProvisionInvitationComponent,
    FormProvisionBulkInvitationComponent,
    CustomerClientUserSearchComponent,
    PlatformAdminInvitedListComponent,
    PlatformAdminBusinessUserInviteComponent,
    DeregisterPlatformAdminComponent,
    AdditionalHostsComponent,
    SubdomainFieldComponent,
];
class RegistrationModule {
    static forRoot(rootConfig) {
        return {
            ngModule: RegistrationModule,
            providers: [
                {
                    provide: BaseRegistrationConfigProvider,
                    useClass: rootConfig.configProvider,
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RegistrationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: RegistrationModule, declarations: [CreateBusinessUserInviteComponent,
            BusinessUserInviteComponent,
            InvitedListComponent,
            ConsumerRegistrationQuickComponent,
            UserIdenticonComponent,
            RegistrationBusiness,
            EmployeeRegistrationComponent,
            DeregisterComponent,
            ProvisionCustomerTenantComponent,
            ProvisionConsumerTenantComponent,
            ProvisionCustomerClientComponent,
            ProvisionedBootstrapsListComponent,
            ProvisionedCustomerBootstrapComponent,
            ProvisionCustomerComponent,
            ProvisionEditBootstrapComponent,
            FormCustomerProvisionComponent,
            DeprovisionCustomerComponent,
            ReactivateClientCustomerComponent,
            ClientAccountComponent,
            FormProvisionInvitationComponent,
            FormProvisionBulkInvitationComponent,
            CustomerClientUserSearchComponent,
            PlatformAdminInvitedListComponent,
            PlatformAdminBusinessUserInviteComponent,
            DeregisterPlatformAdminComponent,
            AdditionalHostsComponent,
            SubdomainFieldComponent, EmailComponent,
            UserComponent,
            BusinessComponent,
            DeactivationCompletedComponent,
            CustomerClientProvisionedComponent,
            UIInvitedListComponent,
            UIInvitedUserComponent,
            DeregisterBaseComponent], imports: [CommonModule,
            ReactiveFormsModule,
            TranslateModule,
            RecaptchaModule,
            RouterModule,
            AuthModule, E11ConfirmationModule,
            E11InputModule,
            E11ButtonModule,
            E11PanelModule,
            E11LoaderDotsModule,
            E11SelectModule,
            E11SideOverModule,
            E11ModalModule,
            E11MultiSelectModule,
            E11EmptyStateModule,
            E11PhoneNumberModule,
            E11DynamicFormModule,
            E11TooltipModule, i7$1.E11InputErrorsModule, E11InputModule,
            E11DataTableModule,
            E11CardModule,
            E11TextareaModule,
            DeregisterRoutingModule,
            WebUtilityModule,
            UserModule,
            LetDirective,
            CustomerModule,
            FilesModule], exports: [CreateBusinessUserInviteComponent,
            BusinessUserInviteComponent,
            InvitedListComponent,
            ConsumerRegistrationQuickComponent,
            UserIdenticonComponent,
            RegistrationBusiness,
            EmployeeRegistrationComponent,
            DeregisterComponent,
            ProvisionCustomerTenantComponent,
            ProvisionConsumerTenantComponent,
            ProvisionCustomerClientComponent,
            ProvisionedBootstrapsListComponent,
            ProvisionedCustomerBootstrapComponent,
            ProvisionCustomerComponent,
            ProvisionEditBootstrapComponent,
            FormCustomerProvisionComponent,
            DeprovisionCustomerComponent,
            ReactivateClientCustomerComponent,
            ClientAccountComponent,
            FormProvisionInvitationComponent,
            FormProvisionBulkInvitationComponent,
            CustomerClientUserSearchComponent,
            PlatformAdminInvitedListComponent,
            PlatformAdminBusinessUserInviteComponent,
            DeregisterPlatformAdminComponent,
            AdditionalHostsComponent,
            SubdomainFieldComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RegistrationModule, providers: [{ provide: IRegistrationService, useClass: RegistrationService }, TenantUtils], imports: [CommonModule,
            ReactiveFormsModule,
            TranslateModule,
            RecaptchaModule,
            RouterModule,
            AuthModule, ImportExportModules, E11InputModule,
            E11DataTableModule,
            E11CardModule,
            E11TextareaModule,
            DeregisterRoutingModule,
            WebUtilityModule,
            UserModule,
            CustomerModule,
            FilesModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RegistrationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ...DeclareExportComponents,
                        EmailComponent,
                        UserComponent,
                        BusinessComponent,
                        DeactivationCompletedComponent,
                        CustomerClientProvisionedComponent,
                        UIInvitedListComponent,
                        UIInvitedUserComponent,
                        DeregisterBaseComponent,
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        TranslateModule,
                        RecaptchaModule,
                        RouterModule,
                        AuthModule,
                        ...ImportExportModules,
                        E11InputModule,
                        E11DataTableModule,
                        E11CardModule,
                        E11TextareaModule,
                        DeregisterRoutingModule,
                        WebUtilityModule,
                        UserModule,
                        LetDirective,
                        CustomerModule,
                        FilesModule,
                    ],
                    providers: [{ provide: IRegistrationService, useClass: RegistrationService }, TenantUtils],
                    exports: [...DeclareExportComponents],
                }]
        }] });

/*
 * Public API Surface of registration
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AdditionalHostsComponent, BaseRegistrationConfigProvider, BusinessUserInviteComponent, ClientAccountComponent, ClientAccountStatus, ClientAccountStore, ConsumerRegistrationModel, ConsumerRegistrationQuickComponent, CreateBusinessUserInviteComponent, CustomerClientUserSearchComponent, DEFAULT_DEACTIVATED_PATH, DeprovisionCustomerComponent, DeregisterComponent, DeregisterPlatformAdminComponent, EmployeeRegistrationComponent, FormCustomerProvisionComponent, FormProvisionBulkInvitationComponent, FormProvisionInvitationComponent, IRegistrationService, IdenticonService, InvitedListComponent, PlatformAdminBusinessUserInviteComponent, PlatformAdminInvitedListComponent, ProvisionConsumerTenantComponent, ProvisionCustomerClientComponent, ProvisionCustomerComponent, ProvisionCustomerTenantComponent, ProvisionEditBootstrapComponent, ProvisionedBootstrapsListComponent, ProvisionedCustomerBootstrapComponent, ProvisioningService, ReactivateClientCustomerComponent, RegistrationBusiness, RegistrationInviteService, RegistrationModule, RegistrationPermissions, RegistrationSearchKeyService, RegistrationService, SelectStates, SubdomainFieldComponent, TenantBootstrapStore, UserIdenticonComponent, UserRegistrationModel, UserType };
